var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-94"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-94",
    cx: 250,
    cy: 355.12,
    rx: 243.24,
    ry: 140.44,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-94"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-94",
    cx: 255.22,
    cy: 407.24,
    rx: 71.24,
    ry: 41.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-94",
    cx: 370.75,
    cy: 419.51,
    rx: 66.66,
    ry: 38.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-94",
    cx: 134.72,
    cy: 422.29,
    rx: 66.66,
    ry: 38.49,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.91,415.06c-.53,5-1.6,8.18-3.89,10.92s-6.47,3.3-10.63,2.09-9.47-3.95-10.53-8.36-.72-7.33.39-11.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.41,377.55c-1.74,0-2.47,6.61-3.68,13.23-1.31,7.09-4.07,9.84-5.22,15.65-1.31,6.63-1,9.68,1.82,14s13,9.19,18.32,3.8c4.32-4.4,4.67-9.65,4.51-16.41-.16-7-.35-11.89.18-17.13.5-5,1.1-9.86-.39-10.55-.14.73-.28,1.66-.43,2.38-.11.55-.37,3.26-1.34,3.21a8.61,8.61,0,0,1,0-1.9,2,2,0,0,0-.42-1.67,3.82,3.82,0,0,0-1.89-.85c-1.7-.42-3.4-.81-5.12-1.08-.86-.14-1.73-.24-2.59-.31a8.5,8.5,0,0,0-2.2.07,1.42,1.42,0,0,0-1,.6,1.78,1.78,0,0,0-.11.76,4.89,4.89,0,0,1-.26,1.37c-.07.19-.25.42-.5.35a.43.43,0,0,1-.27-.43c0-.81,0-1.39.11-2.33,0-.44.08-1,.1-1.47A3,3,0,0,1,212.41,377.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.41,377.55c-1.74,0-2.47,6.61-3.68,13.23-1.31,7.09-4.07,9.84-5.22,15.65-1.31,6.63-1,9.68,1.82,14s13,9.19,18.32,3.8c4.32-4.4,4.67-9.65,4.51-16.41-.16-7-.35-11.89.18-17.13.5-5,1.1-9.86-.39-10.55-.14.73-.28,1.66-.43,2.38-.11.55-.37,3.26-1.34,3.21a8.61,8.61,0,0,1,0-1.9,2,2,0,0,0-.42-1.67,3.82,3.82,0,0,0-1.89-.85c-1.7-.42-3.4-.81-5.12-1.08-.86-.14-1.73-.24-2.59-.31a8.5,8.5,0,0,0-2.2.07,1.42,1.42,0,0,0-1,.6,1.78,1.78,0,0,0-.11.76,4.89,4.89,0,0,1-.26,1.37c-.07.19-.25.42-.5.35a.43.43,0,0,1-.27-.43c0-.81,0-1.39.11-2.33,0-.44.08-1,.1-1.47A3,3,0,0,1,212.41,377.55Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,404.54c-.2,1-1.44,7.3.7,8.64,2.31,1.46,3.77-3.49,3.77-3.49s5.56-.89,13.49,2.62c-.45,1,.68,4.56,2.91,4s3.32-7.84,3.33-7.93c.12,6.47-.33,11.55-4.52,15.82-5.3,5.39-15.53.52-18.32-3.8s-3.13-7.36-1.82-14C203.64,405.76,203.8,405.14,204,404.54Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,404.54c-.2,1-1.44,7.3.7,8.64,2.31,1.46,3.77-3.49,3.77-3.49s5.56-.89,13.49,2.62c-.45,1,.68,4.56,2.91,4s3.32-7.84,3.33-7.93c.12,6.47-.33,11.55-4.52,15.82-5.3,5.39-15.53.52-18.32-3.8s-3.13-7.36-1.82-14C203.64,405.76,203.8,405.14,204,404.54Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05,410.18c-.11,2.43-3.07,1.35-3.09-2.09s2.59-11.4,2.77-17.31c1.21-6.62,1.94-13.27,3.68-13.23,0,.08-.11,1.46-.11,1.54l-.25,2.09a13.16,13.16,0,0,0-.15,1.45c-.2,5-1.39,14.47-2.07,19A62.93,62.93,0,0,0,209.05,410.18Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,412.17a62.76,62.76,0,0,0,1.93-8.4c.75-4.44,2.56-13.74,3.9-18.54.3-1,.57-2.23.64-2.63.19-1.05.31-1.59.44-2.3,0-.1,0-.13,0-.17,1.15.45,1.06,3.22.78,6.57-.29,1.93-.75,4.31-1.39,7.17-1.67,5.67-1.67,14.1-2.75,17.36S220.36,414.51,221,412.17Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.09,412.52a.68.68,0,0,1-.23-.07,25.44,25.44,0,0,0-13.28-2.24.71.71,0,0,1-.77-.44c-.08-.28.13-.54.48-.59a26.59,26.59,0,0,1,14.2,2.41.47.47,0,0,1,.24.71A.62.62,0,0,1,222.09,412.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71,407.37a.86.86,0,0,1-.21-.07,31.6,31.6,0,0,0-14.87-2.5.7.7,0,0,1-.75-.46c-.07-.28.15-.54.5-.57a32.49,32.49,0,0,1,15.71,2.65.49.49,0,0,1,.27.71A.65.65,0,0,1,223.71,407.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.22,399.82a.69.69,0,0,1-.54-.4.48.48,0,0,1,.43-.62c7.82-1.46,15.37,2.37,15.69,2.53a.49.49,0,0,1,.25.72.73.73,0,0,1-.88.15c-.07,0-7.41-3.75-14.68-2.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.82,395.12a.66.66,0,0,1-.53-.38.47.47,0,0,1,.41-.63,24.72,24.72,0,0,1,16,2.52.49.49,0,0,1,.19.73.73.73,0,0,1-.89.1,23.45,23.45,0,0,0-14.91-2.34A.66.66,0,0,1,209.82,395.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.52,389.86a.71.71,0,0,1-.53-.38.47.47,0,0,1,.4-.63c8.07-1.74,15.79,2.48,16.12,2.67a.48.48,0,0,1,.21.72.7.7,0,0,1-.88.12c-.08,0-7.54-4.12-15-2.51A1,1,0,0,1,210.52,389.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.88,400.52c.32,0,.68,3.3-1.15,4.62-2.11,1.52-8.21,3.91-16.1,2.65s-12.08-3.67-15.15-6.22-7.38-6.15-10.93-7c-3.31-.8-6.87-2.33-7.89-3.31s-.71-5.15-.71-5.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.77,370.17a1.26,1.26,0,0,0-1.24.93c-.29,1.13-.69,4.47-1.29,6.33-.84,2.59-1.55,7.95-1.2,10.1s5.72,3.87,9.13,5.22a44.85,44.85,0,0,1,11,6.93c3.6,2.95,11.32,6.19,16.48,6.37,6.12.21,13.07-1.31,14.76-3.83,2.08-3.11,3.65-6.77-5.25-11-1.68-.8-7.58-4.29-9.58-5.56-5.42-3.41-9.21-6.5-11.54-12.25a3.17,3.17,0,0,0-1.23-1.78,3.06,3.06,0,0,0-1.75-.21c-1.52.13-7.57.63-9,1.18-1.24.47-3,1-3,2.44a4.16,4.16,0,0,0,.28,1.46c.09.29.16.68-.12.84s-.61-.05-.84-.25a22,22,0,0,1-2.33-2.78,9.07,9.07,0,0,0-1.38-1.39,13.16,13.16,0,0,1-1.52-1C262.61,371.45,262.77,370.84,262.77,370.17Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.77,370.17a1.26,1.26,0,0,0-1.24.93c-.29,1.13-.69,4.47-1.29,6.33-.84,2.59-1.55,7.95-1.2,10.1s5.72,3.87,9.13,5.22a44.85,44.85,0,0,1,11,6.93c3.6,2.95,11.32,6.19,16.48,6.37,6.12.21,13.07-1.31,14.76-3.83,2.08-3.11,3.65-6.77-5.25-11-1.68-.8-7.58-4.29-9.58-5.56-5.42-3.41-9.21-6.5-11.54-12.25a3.17,3.17,0,0,0-1.23-1.78,3.06,3.06,0,0,0-1.75-.21c-1.52.13-7.57.63-9,1.18-1.24.47-3,1-3,2.44a4.16,4.16,0,0,0,.28,1.46c.09.29.16.68-.12.84s-.61-.05-.84-.25a22,22,0,0,1-2.33-2.78,9.07,9.07,0,0,0-1.38-1.39,13.16,13.16,0,0,1-1.52-1C262.61,371.45,262.77,370.84,262.77,370.17Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,399.68c-1.54-1.25-3.17-2.47-4.81-3.57h0s10.42,6.34,14.83,3.84c2.85-1.61,1.61-3.77,1.58-4.44s9.95-5,12.65-5.18h0c.74.41,1.35.74,1.74.92,8.9,4.2,7.33,7.86,5.25,11-1.69,2.52-6.76,4.33-14.65,4C290.57,406,282.75,402.63,279.15,399.68Z",
    style: {
      fill: "#845EC2",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.15,399.68c-1.54-1.25-3.17-2.47-4.81-3.57h0s10.42,6.34,14.83,3.84c2.85-1.61,1.61-3.77,1.58-4.44s9.95-5,12.65-5.18h0c.74.41,1.35.74,1.74.92,8.9,4.2,7.33,7.86,5.25,11-1.69,2.52-6.76,4.33-14.65,4C290.57,406,282.75,402.63,279.15,399.68Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.08,393.52c5.55,2.29,3.11,3.15,1.52,3.29s-10.86-5.3-16.47-9.71c-5.86-4.6-9.46-9.51-11.64-11.2-.81-.63-1.68-1.4-2.45-2.12.19-1.12.36-2.15.49-2.68a1.26,1.26,0,0,1,1.24-.93c0,.67-.16,1.28.37,1.8a13.16,13.16,0,0,0,1.52,1,9.07,9.07,0,0,1,1.38,1.39,22,22,0,0,0,2.33,2.78C273.06,383,284.53,391.24,290.08,393.52Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.23,396a.65.65,0,0,1-.35-.13.48.48,0,0,1-.05-.72c1.67-1.71,9.38-5.61,13.51-5a.52.52,0,0,1,.47.58.53.53,0,0,1-.63.42c-3.86-.54-11.19,3.35-12.51,4.7A.56.56,0,0,1,291.23,396Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.43,393.08a.65.65,0,0,1-.35-.13.48.48,0,0,1-.05-.72c1.67-1.71,9.37-5.6,13.51-5a.52.52,0,0,1,.47.58.53.53,0,0,1-.63.42c-3.86-.53-11.19,3.35-12.51,4.7A.56.56,0,0,1,286.43,393.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.62,390.27a.65.65,0,0,1-.35-.13.48.48,0,0,1,0-.72c1.67-1.71,9.38-5.62,13.51-5a.54.54,0,0,1,.47.58.54.54,0,0,1-.63.43c-3.86-.54-11.19,3.34-12.51,4.7A.6.6,0,0,1,281.62,390.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.19,387.09a.57.57,0,0,1-.35-.12.48.48,0,0,1,0-.72c1.67-1.71,9.39-5.61,13.51-5a.54.54,0,0,1,.47.58.55.55,0,0,1-.64.43c-3.85-.54-11.18,3.34-12.5,4.7A.59.59,0,0,1,277.19,387.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.85,383.93a.62.62,0,0,1-.34-.13.47.47,0,0,1-.06-.71c2.29-2.43,10.33-5.62,14.45-5a.51.51,0,0,1,.47.58.55.55,0,0,1-.63.43c-3.71-.53-11.41,2.54-13.45,4.69A.57.57,0,0,1,272.85,383.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.9,163.73c-7.67,15.15-10.16,22.42-11.33,50.31S210,291,210,291s-2.62,11.91-4,32,.88,63,.88,63,0,3.82,11.55,5.05,12.44-2.47,12.44-2.47S239.45,336,244,314.72s8.22-41.41,8.22-41.41l1.49,20.48s-2.15,9.4-1,27.93S259.62,376,259.62,376s13.15,5.64,25.4-1.06c0,0,4.7-67.64,5.67-102s1.34-72.8-3.5-97Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.9,163.73c-7.67,15.15-10.16,22.42-11.33,50.31S210,291,210,291s-2.62,11.91-4,32,.88,63,.88,63,0,3.82,11.55,5.05,12.44-2.47,12.44-2.47S239.45,336,244,314.72s8.22-41.41,8.22-41.41l1.49,20.48s-2.15,9.4-1,27.93S259.62,376,259.62,376s13.15,5.64,25.4-1.06c0,0,4.7-67.64,5.67-102s1.34-72.8-3.5-97Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.23,273.31l7-49.76s15.43-2.08,23-10.78c0,0-4.48,10.62-18.19,15l-9.12,44.43-1.17,21.58Z",
    style: {
      fill: "#845EC2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.45,128.18c-2.29,2.95-6.89,5.11-8.42,8.85-.81,2-1.55,4.92-4.63,6.15-1.39.55-3.51,1-5.34,1.57-1,7.12-.5,13.4,5.6,16.68q1.72-.7,3.51-1.38c2.76-.88,5.52-1.68,8-2.24,5.72-1.3,12.17-4.93,17-8.2a13.36,13.36,0,0,0,3.27-3.55,10.42,10.42,0,0,0,1.25-3c.49-1.84,2.13-3.12,2.36-5.06.1-.82-.33-1.91-.14-2.68a3,3,0,0,1,.46-.65,4.44,4.44,0,0,0,.66-1.53,7.2,7.2,0,0,0-.17-3.54,7.6,7.6,0,0,1-.66-2.21,7.49,7.49,0,0,1,1-2.42c.25-.57.9-1.52.59-2.13-.66-1.31-2.5-1-3.59-.49-1.59.72-2.65,2.41-3.84,3.68-2.06,2.2-2.77,3.49-4.54,4.84a51.41,51.41,0,0,1-6,4,16.24,16.24,0,0,1-3.85,1.85c-.78.2-1.88.33-1.42-.87a14.47,14.47,0,0,1,1.46-2.2,11.87,11.87,0,0,0,1.72-4.95c.29-2.57-.51-4.13-1.41-4.34C346.69,124.21,346.24,125.87,344.45,128.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,140.13c0,4.39-3.74,8.55-6.85,10.14C345.68,150.21,348.61,144.94,347.14,140.13Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.45,102.29c8.76,1,13.29,1.39,16.74,5,4.1,4.27,10.91,18.76,13.82,24.75s8,17,8,17l23-5.11s-1.5,3.27-.3,9.93c1.07,5.88,4,7.56,4,7.56s-4.84,2.31-13.69,5.57-17.1,5.64-20.5,5.12-5.64-2.88-9.87-8S269,131.75,269,131.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,101c7.44,0,13.35,1.64,17,5.43s9,14.52,13,22.62,5.81,11.59,5.81,11.59-13.58,6.8-20.92,15.45l-17.09-29.4S264.27,106.48,267.43,101Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,101c7.44,0,13.35,1.64,17,5.43s9,14.52,13,22.62,5.81,11.59,5.81,11.59-13.58,6.8-20.92,15.45l-17.09-29.4S264.27,106.48,267.43,101Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,149.05c-5.86,1.06-8.87,3.11-11.39,6.36.85-4.1,3.9-6.92,10.54-8.2Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.33,100.78A148.78,148.78,0,0,0,240,100.7s-15.37,2.44-18.29,3.31-3.42,11.67-3.21,22.48c.24,12.34.19,30.34.19,30.34-2,15.2-5.19,25.18-6,38,22.94,15.71,59.8,15.53,77.43,1.32-1.29-14.37-1.64-22.38-2.13-32.43,0,0,0-8.38-.51-14a25.67,25.67,0,0,0,4.06-12.25c.34-7.27-2.79-16.17-9.63-24.13A75.22,75.22,0,0,0,267.43,101Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.33,100.78A148.78,148.78,0,0,0,240,100.7s-15.37,2.44-18.29,3.31-3.42,11.67-3.21,22.48c.24,12.34.19,30.34.19,30.34-2,15.2-5.19,25.18-6,38,22.94,15.71,59.8,15.53,77.43,1.32-1.29-14.37-1.64-22.38-2.13-32.43,0,0,0-8.38-.51-14a25.67,25.67,0,0,0,4.06-12.25c.34-7.27-2.79-16.17-9.63-24.13A75.22,75.22,0,0,0,267.43,101Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.47,141.68s1.8,9.06,12.32,11.2c9.63,2,18-4,18-4s-5.66,9.67-18.64,6.64S235.47,141.68,235.47,141.68Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.18,118.11v-4a58.81,58.81,0,0,1-9.95-.62c-12.52-1.53-19-8-23.28-11.94l-4,1.06c3.25,5.08,12.41,12,22,14.25S271.18,118.11,271.18,118.11Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.18,118.11v-4a58.81,58.81,0,0,1-9.95-.62c-12.52-1.53-19-8-23.28-11.94l-4,1.06c3.25,5.08,12.41,12,22,14.25S271.18,118.11,271.18,118.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.23,113.5c1.47.21,2.88.37,4.19.47,0,0,1.36-10.1-1-13.1l-3-.27S263.34,108.61,261.23,113.5Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.23,113.5c1.47.21,2.88.37,4.19.47,0,0,1.36-10.1-1-13.1l-3-.27S263.34,108.61,261.23,113.5Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.6,93.16c-2-2.2-3.22-6.6-7.87-11.55-6.46-6.89-10.48-18.42-2.87-28.18s22.08-10.24,32-8.86c13.67,1.92,14.74,17.18,14.74,17.18A28.54,28.54,0,0,1,277.17,72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.57,72.76c3.93-14.89,14-20.13,25.18-19.81,4.23.12,9.14,2,10.17,8.59.25,1.58,0,4.9.24,6.26s.89,1.81,1,4.18c.72,13.58-2.79,17.06-5.14,18.94a15.19,15.19,0,0,1-10.62,3.33l.4,7.69s6.23,4.66,3.44,11.85a45.87,45.87,0,0,1-12.76-3c-9.16-4-10.25-8-10.25-8l-1.33-20.47S239.76,75.81,240.57,72.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.64 64.8 262.05 77.24 268.76 74.62 260.64 64.8",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,69a2,2,0,1,1-1.36-2.51A2,2,0,0,1,256.06,69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,66.47c-1.24.07-1.92,1.76-3.13,1.13a1.78,1.78,0,0,0,2.44.91C253.84,68.21,254,66.47,254,66.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.36,62.94l-4.66-.82a2.27,2.27,0,0,1,2.66-1.95A2.48,2.48,0,0,1,272.36,62.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.41,68.65a2,2,0,1,0,3.67-1.47,2,2,0,1,0-3.67,1.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.19,65.87c1.24-.07,2.11,1.54,3.24.78a1.78,1.78,0,0,1-2.32,1.18C270.52,67.58,270.19,65.87,270.19,65.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.22,62.32,250.43,64a2.42,2.42,0,0,1,1.48-3.2A2.66,2.66,0,0,1,255.22,62.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.91,80l7.88,2.56a4.07,4.07,0,0,1-5.15,2.8A4.33,4.33,0,0,1,255.91,80Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.75,81.49a4.26,4.26,0,0,0,2.89,3.87,4.13,4.13,0,0,0,1,.18A4,4,0,0,0,255.75,81.49Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.71,86.19c.32,2.3-.48,10.2-1.56,11.76s-2.69,2.29-2.92,5.12l4.37-.59s3.92,13.32,18.08,23.06c10.3,7.08,19,5.28,23.45,2.3,9-6,3-19.27,1.71-22.76s-7.73-7.57-7.73-7.57C251,95.83,239.43,91.91,230.71,86.19Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.71,86.19c.32,2.3-.48,10.2-1.56,11.76s-2.69,2.29-2.92,5.12l4.37-.59s3.92,13.32,18.08,23.06c10.3,7.08,19,5.28,23.45,2.3,9-6,3-19.27,1.71-22.76s-7.73-7.57-7.73-7.57C251,95.83,239.43,91.91,230.71,86.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.76,86.19a25.66,25.66,0,0,0,4.66,15.45c5.25,7.17,15.72,10.38,24.19,8.49s10-5.81,6.42-9.2S230.76,86.19,230.76,86.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.46,104.23A3.41,3.41,0,0,1,265,106c-1.38,1-4.05,2.19-9.2,2.59a25.3,25.3,0,0,1-9.43-1.13h0c-8.19-2.63-16.16-10.1-16-26.84h0a11.18,11.18,0,0,0,2.77,2.76c4.89,3.38,7.67-1,7.67-1,1.45,3.91,2.18,6.09,6,8.6,4.78,3.16,14.52,3.25,14.52,3.25.43,0,1.11,0,1.54,0a18.37,18.37,0,0,0,1.95-.19c.62-.09.92-.17,1.19-.23v.06Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.46,104.23A3.41,3.41,0,0,1,265,106c-1.38,1-4.05,2.19-9.2,2.59a25.3,25.3,0,0,1-9.43-1.13h0c-8.19-2.63-16.16-10.1-16-26.84h0a11.18,11.18,0,0,0,2.77,2.76c4.89,3.38,7.67-1,7.67-1,1.45,3.91,2.18,6.09,6,8.6,4.78,3.16,14.52,3.25,14.52,3.25.43,0,1.11,0,1.54,0a18.37,18.37,0,0,0,1.95-.19c.62-.09.92-.17,1.19-.23v.06Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.57,72.76s-.13-14.58,6.78-20.8,21.63-5.48,25-2.09c2.66,2.65,6.33,11.32,4.79,22.11a32.88,32.88,0,0,0,1-12.33c-2.22-15.1-13.52-23.94-26.45-23.06s-21,5.77-26.39,16.62-6.71,51.41-6.71,51.41c1.69-.49,8.27-1.21,12-2.14,5.51-1.37,10.78-7.9,10.3-20.63Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.57,72.76s-.13-14.58,6.78-20.8,21.63-5.48,25-2.09c2.66,2.65,6.33,11.32,4.79,22.11a32.88,32.88,0,0,0,1-12.33c-2.22-15.1-13.52-23.94-26.45-23.06s-21,5.77-26.39,16.62-6.71,51.41-6.71,51.41c1.69-.49,8.27-1.21,12-2.14,5.51-1.37,10.78-7.9,10.3-20.63Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.65,225.21c-2.54-2.73-3.94-7.62-7.38-9.73-1.85-1.13-4.61-2.32-5.32-5.57-.32-1.45-.47-3.63-.7-5.52l-17.36,2.85c.28,1.21.55,2.44.79,3.69.43,2.86.78,5.72.94,8.27.36,5.86,2.9,12.81,5.34,18.14a13.51,13.51,0,0,0,3,3.79,10.14,10.14,0,0,0,2.73,1.72c1.73.78,2.73,2.6,4.61,3.14.79.23,1.94,0,2.67.3.18.08.42.41.57.55a4.48,4.48,0,0,0,1.4.9,7.15,7.15,0,0,0,3.52.4,7.41,7.41,0,0,1,2.28-.3,7.61,7.61,0,0,1,2.23,1.42c.52.34,1.36,1.13,2,.93,1.41-.45,1.38-2.31,1.07-3.47-.46-1.69-2-3-3-4.39-1.84-2.38-3-3.29-4-5.25a49.82,49.82,0,0,1-3-6.59,16.23,16.23,0,0,1-1.22-4.1c-.07-.81,0-1.91,1.09-1.26a14.3,14.3,0,0,1,1.94,1.79,12,12,0,0,0,4.61,2.5c2.49.69,4.15.16,4.51-.7C229.21,228.05,227.64,227.34,225.65,225.21Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62,104.43c-13,2.75-15.47,5.61-18.64,13-2.53,5.88-6.53,18.44-8.9,26.72s-5.58,22.55-6.09,25.17-1.07,3.83.81,14.1c1.74,9.48,5.54,25.6,5.54,25.6s1.88,3.58,9.69,2.12,9.08-4.86,9.08-4.86L211,174l12.5-38.72S231.74,113.42,221.62,104.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,104c-4.89.69-11.53,1.73-15.51,6.39s-5.61,10.71-8.72,19.25-5.87,18-5.87,18,1,6.47,11.4,9.83,14.33.42,14.33.42,6.22-19.48,8.2-25.52S230.15,110.74,222,104Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,104c-4.89.69-11.53,1.73-15.51,6.39s-5.61,10.71-8.72,19.25-5.87,18-5.87,18,1,6.47,11.4,9.83,14.33.42,14.33.42,6.22-19.48,8.2-25.52S230.15,110.74,222,104Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.45,132.11c-.11-.9-.54-2.81-1.09-5.22-1.87-8.29-3.46-19.55-2.8-25.95a8,8,0,0,0,2-1.58c-1,5.66,1.34,22.32,2.43,27.15.56,2.47,1,4.41,1.12,5.41Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,172.25h-.15l0-1.19a7.73,7.73,0,0,0,3.81-1.71,14.45,14.45,0,0,1-3.44-2.72c-2.07-2.35-7.42-19.77-6.4-24,.86-3.53,3.75-11.36,6.77-11.69h.08c3-.19,7.45,6.75,9,10,1.9,3.89.4,22.05-1.13,24.78a14.38,14.38,0,0,1-2.77,3.4,7.45,7.45,0,0,0,4.08.85l.22,1.18A9.28,9.28,0,0,1,242.2,170,9.48,9.48,0,0,1,237.42,172.25Zm.72-40.09h0c-1.77.2-4.59,6.06-5.74,10.79-.94,3.86,4.21,20.72,6.14,22.9a13.65,13.65,0,0,0,3.53,2.71,13.65,13.65,0,0,0,2.88-3.41c1.42-2.54,2.84-20.1,1.1-23.68C243.9,137.13,239.93,132,238.14,132.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.12,170.38a1.75,1.75,0,1,1-1.93-1.55A1.75,1.75,0,0,1,249.12,170.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,171.48a1.75,1.75,0,1,1-1.93-1.56A1.77,1.77,0,0,1,239,171.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.89,148.73h-1a.41.41,0,0,1-.39-.4c0-3.33-.29-5.77-.75-6.72-2-4.18-6-9.32-7.61-9.15s-4.38,6-5.48,10.56c-.25,1,0,3.47.7,6.73a.39.39,0,0,1-.29.47l-1,.22a.4.4,0,0,1-.47-.31c-.79-3.66-1-6.19-.7-7.53.59-2.42,3.51-11.54,7-11.92s8.31,7.9,9.41,10.14c.6,1.24.91,3.76.93,7.51A.41.41,0,0,1,247.89,148.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.16,96.24l.09,2.17.06,0a13.51,13.51,0,0,1,2.08,1.46,14.34,14.34,0,0,1,2.32,2.44,28,28,0,0,1,3,5.91c2.47,5.85,3.37,15.77,3.52,27.28l1.93.29c0-4.1.22-17.71-3.61-28C273,101,269,97.6,266.16,96.24Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.75,133.7a5.72,5.72,0,1,0,6.24-5.14A5.71,5.71,0,0,0,272.75,133.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.21,133.94a3.25,3.25,0,1,0,3.54-2.92A3.25,3.25,0,0,0,275.21,133.94Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397,429.62c.53,5,1.62,8.3,3.94,11.08s6.56,3.35,10.79,2.12,9.61-4,10.68-8.48.73-7.44-.39-12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.69,391.55c1.75,0,2.5,6.71,3.73,13.42,1.33,7.2,4.13,10,5.29,15.88,1.34,6.74,1,9.83-1.84,14.21s-13.22,9.32-18.59,3.85c-4.39-4.46-4.74-9.8-4.58-16.65.17-7.08.35-12.07-.18-17.39-.51-5.08-1.11-10,.39-10.7.14.74.29,1.69.44,2.41.11.56.38,3.31,1.36,3.26a8.9,8.9,0,0,0,0-1.93,2,2,0,0,1,.42-1.69,4,4,0,0,1,1.93-.87c1.72-.42,3.44-.81,5.19-1.09.87-.14,1.75-.24,2.63-.31a8.3,8.3,0,0,1,2.23.07,1.34,1.34,0,0,1,1,.61,1.83,1.83,0,0,1,.12.77,4.33,4.33,0,0,0,.26,1.38c.07.2.26.43.51.36a.42.42,0,0,0,.27-.44c0-.82,0-1.41-.11-2.36,0-.44-.08-1-.1-1.48A3.09,3.09,0,0,0,412.69,391.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.69,391.55c1.75,0,2.5,6.71,3.73,13.42,1.33,7.2,4.13,10,5.29,15.88,1.34,6.74,1,9.83-1.84,14.21s-13.22,9.32-18.59,3.85c-4.39-4.46-4.74-9.8-4.58-16.65.17-7.08.35-12.07-.18-17.39-.51-5.08-1.11-10,.39-10.7.14.74.29,1.69.44,2.41.11.56.38,3.31,1.36,3.26a8.9,8.9,0,0,0,0-1.93,2,2,0,0,1,.42-1.69,4,4,0,0,1,1.93-.87c1.72-.42,3.44-.81,5.19-1.09.87-.14,1.75-.24,2.63-.31a8.3,8.3,0,0,1,2.23.07,1.34,1.34,0,0,1,1,.61,1.83,1.83,0,0,1,.12.77,4.33,4.33,0,0,0,.26,1.38c.07.2.26.43.51.36a.42.42,0,0,0,.27-.44c0-.82,0-1.41-.11-2.36,0-.44-.08-1-.1-1.48A3.09,3.09,0,0,0,412.69,391.55Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.25,418.94c.21,1,1.46,7.41-.71,8.77-2.34,1.48-3.82-3.54-3.82-3.54s-5.65-.91-13.7,2.66c.46,1-.69,4.62-2.95,4.07s-3.36-7.95-3.38-8c-.12,6.57.33,11.73,4.59,16.06,5.37,5.47,15.76.53,18.59-3.85s3.18-7.47,1.84-14.21C421.58,420.18,421.42,419.55,421.25,418.94Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.25,418.94c.21,1,1.46,7.41-.71,8.77-2.34,1.48-3.82-3.54-3.82-3.54s-5.65-.91-13.7,2.66c.46,1-.69,4.62-2.95,4.07s-3.36-7.95-3.38-8c-.12,6.57.33,11.73,4.59,16.06,5.37,5.47,15.76.53,18.59-3.85s3.18-7.47,1.84-14.21C421.58,420.18,421.42,419.55,421.25,418.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.09,424.66c.12,2.47,3.12,1.38,3.13-2.12S416.6,411,416.42,405c-1.23-6.71-2-13.46-3.73-13.42,0,.08.1,1.48.11,1.57l.25,2.11a13.8,13.8,0,0,1,.15,1.47c.21,5,1.41,14.69,2.1,19.25A63.58,63.58,0,0,1,416.09,424.66Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,426.68a65.36,65.36,0,0,1-1.95-8.52c-.76-4.51-2.6-13.94-4-18.82-.31-1-.58-2.26-.65-2.67-.19-1.06-.31-1.61-.44-2.32a1.18,1.18,0,0,0,0-.18c-1.17.45-1.07,3.27-.78,6.67.28,2,.75,4.37,1.4,7.28,1.7,5.74,1.7,14.3,2.8,17.61S404.62,429.06,404,426.68Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.86,427a.88.88,0,0,0,.23-.07,25.71,25.71,0,0,1,13.48-2.28.71.71,0,0,0,.78-.44c.08-.29-.13-.55-.48-.6a27.07,27.07,0,0,0-14.41,2.44.49.49,0,0,0-.25.73A.65.65,0,0,0,402.86,427Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.22,421.81a.58.58,0,0,0,.21-.07,32.09,32.09,0,0,1,15.09-2.54.7.7,0,0,0,.76-.46c.08-.29-.15-.55-.5-.59a33.21,33.21,0,0,0-15.94,2.69.52.52,0,0,0-.29.73A.69.69,0,0,0,401.22,421.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,414.15a.66.66,0,0,0,.54-.4.48.48,0,0,0-.43-.63c-7.93-1.48-15.59,2.4-15.92,2.57a.5.5,0,0,0-.25.73.73.73,0,0,0,.89.14c.07,0,7.51-3.8,14.9-2.41A1.22,1.22,0,0,0,415.92,414.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.31,409.39a.7.7,0,0,0,.54-.39.48.48,0,0,0-.41-.64,25.07,25.07,0,0,0-16.25,2.55.48.48,0,0,0-.19.74.73.73,0,0,0,.9.1A23.77,23.77,0,0,1,415,409.38.88.88,0,0,0,415.31,409.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.6,404a.71.71,0,0,0,.54-.38.49.49,0,0,0-.41-.65c-8.18-1.75-16,2.53-16.35,2.72a.49.49,0,0,0-.22.73.73.73,0,0,0,.9.12c.07,0,7.65-4.18,15.25-2.55A.72.72,0,0,0,414.6,404Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.25,414.78c-.33,0-.7,3.36,1.16,4.7,2.14,1.54,8.34,4,16.34,2.69s12.26-3.73,15.38-6.32,7.48-6.23,11.09-7.12c3.35-.81,7-2.36,8-3.36s.72-5.22.72-5.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.06,384a1.28,1.28,0,0,1,1.26.94c.3,1.16.7,4.54,1.31,6.43.85,2.63,1.57,8.06,1.22,10.25s-5.8,3.92-9.27,5.29a45.56,45.56,0,0,0-11.13,7c-3.66,3-11.49,6.28-16.73,6.46-6.21.21-13.26-1.33-15-3.88-2.12-3.17-3.71-6.87,5.32-11.14,1.71-.8,7.69-4.36,9.72-5.64,5.51-3.46,9.35-6.6,11.71-12.43a3.17,3.17,0,0,1,1.25-1.8,3.06,3.06,0,0,1,1.78-.22c1.54.13,7.68.64,9.1,1.19,1.26.49,3,1,3.07,2.48a4.47,4.47,0,0,1-.29,1.48c-.1.3-.17.69.12.86s.62-.05.85-.26a21.89,21.89,0,0,0,2.37-2.81,8.49,8.49,0,0,1,1.4-1.41c.48-.38,1.11-.58,1.54-1S358.06,384.67,358.06,384Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.06,384a1.28,1.28,0,0,1,1.26.94c.3,1.16.7,4.54,1.31,6.43.85,2.63,1.57,8.06,1.22,10.25s-5.8,3.92-9.27,5.29a45.56,45.56,0,0,0-11.13,7c-3.66,3-11.49,6.28-16.73,6.46-6.21.21-13.26-1.33-15-3.88-2.12-3.17-3.71-6.87,5.32-11.14,1.71-.8,7.69-4.36,9.72-5.64,5.51-3.46,9.35-6.6,11.71-12.43a3.17,3.17,0,0,1,1.25-1.8,3.06,3.06,0,0,1,1.78-.22c1.54.13,7.68.64,9.1,1.19,1.26.49,3,1,3.07,2.48a4.47,4.47,0,0,1-.29,1.48c-.1.3-.17.69.12.86s.62-.05.85-.26a21.89,21.89,0,0,0,2.37-2.81,8.49,8.49,0,0,1,1.4-1.41c.48-.38,1.11-.58,1.54-1S358.06,384.67,358.06,384Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.45,413.94c1.55-1.28,3.21-2.51,4.87-3.62h0s-10.56,6.44-15.05,3.9c-2.88-1.64-1.63-3.82-1.59-4.5s-10.1-5.08-12.85-5.26h0c-.74.41-1.37.75-1.76.93-9,4.27-7.44,8-5.32,11.14,1.71,2.55,6.85,4.39,14.86,4.06C329.85,420.36,337.79,416.93,341.45,413.94Z",
    style: {
      fill: "#845EC2",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.45,413.94c1.55-1.28,3.21-2.51,4.87-3.62h0s-10.56,6.44-15.05,3.9c-2.88-1.64-1.63-3.82-1.59-4.5s-10.1-5.08-12.85-5.26h0c-.74.41-1.37.75-1.76.93-9,4.27-7.44,8-5.32,11.14,1.71,2.55,6.85,4.39,14.86,4.06C329.85,420.36,337.79,416.93,341.45,413.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.35,407.69c-5.63,2.32-3.15,3.19-1.54,3.34s11-5.38,16.72-9.86c5.94-4.67,9.6-9.65,11.8-11.37.83-.64,1.71-1.42,2.49-2.15-.2-1.14-.36-2.18-.5-2.72a1.28,1.28,0,0,0-1.26-.94c0,.68.16,1.3-.37,1.83s-1.06.62-1.54,1a8.49,8.49,0,0,0-1.4,1.41,21.89,21.89,0,0,1-2.37,2.81C347.63,397,336,405.37,330.35,407.69Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,410.24a.61.61,0,0,0,.36-.13.5.5,0,0,0,0-.73c-1.69-1.73-9.52-5.69-13.71-5.1a.53.53,0,0,0-.47.59.54.54,0,0,0,.64.43c3.91-.54,11.35,3.4,12.69,4.77A.56.56,0,0,0,329.18,410.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.06,407.24a.65.65,0,0,0,.35-.13.5.5,0,0,0,0-.73c-1.69-1.73-9.51-5.69-13.7-5.1a.53.53,0,0,0-.48.59.55.55,0,0,0,.64.43c3.91-.54,11.35,3.39,12.69,4.77A.58.58,0,0,0,334.06,407.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.93,404.38a.59.59,0,0,0,.36-.13.49.49,0,0,0,0-.73c-1.69-1.73-9.51-5.69-13.7-5.09a.52.52,0,0,0-.48.58.55.55,0,0,0,.64.44c3.91-.55,11.35,3.39,12.69,4.76A.57.57,0,0,0,338.93,404.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.43,401.17a.62.62,0,0,0,.36-.14.48.48,0,0,0,0-.72c-1.68-1.74-9.52-5.7-13.7-5.1a.53.53,0,0,0-.48.59.56.56,0,0,0,.65.43c3.91-.54,11.35,3.39,12.69,4.76A.6.6,0,0,0,343.43,401.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,398a.54.54,0,0,0,.34-.12.48.48,0,0,0,.06-.73c-2.32-2.46-10.48-5.7-14.66-5.11a.53.53,0,0,0-.48.59.56.56,0,0,0,.64.43c3.77-.53,11.58,2.58,13.64,4.76A.58.58,0,0,0,347.84,398Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.87,168.46c7.78,15.37,10.2,32.83,11.38,61.14S412.81,304,412.81,304s2,14.85,3.38,35.24,2.15,61,2.15,61,0,3.88-11.72,5.12S394,402.83,394,402.83s-8.74-53.46-13.37-75-11.07-58.59-11.07-58.59l-3.18,37.35s2.19,9.54,1,28.34-7,55.11-7,55.11-12.47,5.65-24.91-1.15c0,0-4.34-69.62-5.33-104.45s-.2-75.75,4.71-100.34Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.87,168.46c7.78,15.37,10.2,32.83,11.38,61.14S412.81,304,412.81,304s2,14.85,3.38,35.24,2.15,61,2.15,61,0,3.88-11.72,5.12S394,402.83,394,402.83s-8.74-53.46-13.37-75-11.07-58.59-11.07-58.59l-3.18,37.35s2.19,9.54,1,28.34-7,55.11-7,55.11-12.47,5.65-24.91-1.15c0,0-4.34-69.62-5.33-104.45s-.2-75.75,4.71-100.34Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.55,269.21l-4.38-33.92s-15.67-2.12-23.3-10.95c0,0,4.54,10.79,18.45,15.23l4.5,28.22,1.55,38.77Z",
    style: {
      fill: "#845EC2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.85,110.93c-7.56,1-12.51,2.19-15.9,5.31s-7,8.61-10.73,14.86-10,17-10,17a33.24,33.24,0,0,0,8.95,9.88,52,52,0,0,0,12.33,6.8L358,142.31Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.85,110.93c-7.56,1-12.51,2.19-15.9,5.31s-7,8.61-10.73,14.86-10,17-10,17a33.24,33.24,0,0,0,8.95,9.88,52,52,0,0,0,12.33,6.8L358,142.31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362,110.71a215.65,215.65,0,0,1,22.67.56s13,2.69,15.94,3.56,6,13,4,23.81S402,166.53,402,166.53c3.54,11.08,6.27,28.07,7.09,41.08-23.27,15.95-59.87,13-77.77-1.41,1.31-14.58,4.31-29.68,7.32-37.37,0,0-2-7.52-1-13.2,0,0-5.07-5-5.4-12-.34-7.38,2.95-12.06,9.89-20.14a76.71,76.71,0,0,1,14.71-12.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,110.71a215.65,215.65,0,0,1,22.67.56s13,2.69,15.94,3.56,6,13,4,23.81S402,166.53,402,166.53c3.54,11.08,6.27,28.07,7.09,41.08-23.27,15.95-59.87,13-77.77-1.41,1.31-14.58,4.31-29.68,7.32-37.37,0,0-2-7.52-1-13.2,0,0-5.07-5-5.4-12-.34-7.38,2.95-12.06,9.89-20.14a76.71,76.71,0,0,1,14.71-12.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.82,159.26s-4.24,8.35-15.11,7.55a16.4,16.4,0,0,1-13.53-9.34s-.09,11.45,13.41,12.07S390.82,159.26,390.82,159.26Z",
    style: {
      fill: "#845EC2",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.42,101c-.34-1.44,1.33-7.51,2.95-9.76,4.82-6.67,8.37-7.9,10.23-16.21a19.49,19.49,0,0,0-4.27-17.19C390.71,45.05,376,43.75,364.83,46c-9.21,1.88-19.51,9.56-18.41,20.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.71,77.18c.21-2.92.53-18-11.13-22.92s-19.89-2.3-24.82-.15c-2.17,1.45-4.26,2.65-5.55,5.19A7.18,7.18,0,0,1,348,54c1-2.2,3.2-2.61,4.35-3.41,4.42-3.11,13.46-10.08,28.05-6.91S412,64.37,407.61,86.22c-3.65,18-20.68,17-20.68,17l.23-12.83Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.71,77.18c.21-2.92.53-18-11.13-22.92s-19.89-2.3-24.82-.15c-2.17,1.45-4.26,2.65-5.55,5.19A7.18,7.18,0,0,1,348,54c1-2.2,3.2-2.61,4.35-3.41,4.42-3.11,13.46-10.08,28.05-6.91S412,64.37,407.61,86.22c-3.65,18-20.68,17-20.68,17l.23-12.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.08,53.05c-7.89-3.35-17.61-2.67-22.31,0-5,2.8-5.54,4.71-5.54,4.71s8.42-9,24.07-5c14.48,3.72,15.85,17,15.58,23.19a8.49,8.49,0,0,1,1.05-.28C390.22,63.36,385.47,56.62,377.08,53.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.19,55.86c-5.36,2.7-10.1,6.58-9.75,26.09.27,15,4.7,18.89,7.12,20s5.32,1.58,9.82,1.47v6.87l-1.49.2c-2,2.38-3.94,7.72.25,15.74,22.69-7.07,23.67-13.89,23.67-13.89l.76-22s1.77,2.78,5.31.68c5.24-3.09,5.94-10.73,3.08-13.8s-9-1.85-10.79,1.66c0,0,2.17-14.33-5.82-20.26C370,51.68,363.48,52.68,357.19,55.86Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.5,90.19a3.77,3.77,0,1,1-7.43,1.32Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.29,94.57a3.17,3.17,0,0,1,4.19-3,3.66,3.66,0,0,1-4.19,3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.71,77.41a2,2,0,1,0,2-2A2,2,0,0,0,366.71,77.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.75,76.42a2,2,0,1,0,2-2A2,2,0,0,0,351.75,76.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.32 74.4 360.17 86.14 353.16 84.51 361.32 74.4",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.38,103.45c6.37-.32,16.24-3.79,18.55-10.72,0,0-.26,4.81-2.85,7.75-4.66,5.29-15.7,6.5-15.7,6.5Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.81,70.37l4.4,3.43a2.93,2.93,0,0,0-.52-4A2.72,2.72,0,0,0,368.81,70.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.64,71.51l5.21-2.1a2.7,2.7,0,0,0-3.56-1.62A3,3,0,0,0,350.64,71.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23,61.52c2.35.4,5.14-3.5,9.83-1.84,5.05,1.8,3.45,7.48,7.07,10.6,2.75,2.36,0,8.91,3,10.22,1.32.59,3.08-1.6,3.08-1.6s2.54-3.8,1.92-12.54-12.23-13.76-20.62-14.1-15.74,6.26-17.09,12.24c0,0,2.07-4.85,6-5.46S360.11,61.15,362.23,61.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23,61.52c3.38-4.25,11.42-5.37,16.66,2.15s2.7,15.44,4.8,26.52c1.46,7.66,8.24,6,8.24,6s-3.34-.12-3.14-12.28.86-19.7-7.07-26.13S363.49,53.51,362.23,61.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23,61.52c-.15-2.42-3-8.35-9.07-7.21-6.82,1.27-11.66,14.74-5.6,23.15,0,0-.6-13.75,6.2-18.47C358.53,55.69,362.23,61.52,362.23,61.52Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.05,128.29v-4a58.79,58.79,0,0,0,10.1-.63c12.7-1.55,19.4-8.09,23.7-12.11l4,1.07c-3.29,5.15-12.59,12.19-22.31,14.46S353.05,128.29,353.05,128.29Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.05,128.29v-4a58.79,58.79,0,0,0,10.1-.63c12.7-1.55,19.4-8.09,23.7-12.11l4,1.07c-3.29,5.15-12.59,12.19-22.31,14.46S353.05,128.29,353.05,128.29Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.15,123.61c-1.5.22-2.93.38-4.26.48,0,0-1.37-10.25,1-13.29l3-.28S361,118.65,363.15,123.61Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.15,123.61c-1.5.22-2.93.38-4.26.48,0,0-1.37-10.25,1-13.29l3-.28S361,118.65,363.15,123.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.38,153c-1.69,2.58-6.68,13.26,2.69,22.84s21.4,17.52,39,18.38S399.69,179,396.59,167.4c-3.66-13.74-19.4-11.08-26.36-13.74s-15-11.48-28.24-11A28.92,28.92,0,0,0,321.38,153Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,140.37c0,5,4.49,11.43,7.17,12.18,2.82,2,4.72,3.75,10.28,4.28,7.55.73,13.89-1.91,17.06-8a9.27,9.27,0,0,0,.71-6.7c-.54-2-1.86-3.56-2.89-5.28s-1.48-3.72-2.41-5.5a15.7,15.7,0,0,0-3.42-4.27,13.24,13.24,0,0,0-4.48-2.88,15.84,15.84,0,0,0-5.2-.81A16.56,16.56,0,0,0,310.55,140.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.27,127.88a2.53,2.53,0,0,1,.38,0c.22,0,.43,0,.64,0a4,4,0,0,1,.78.1,2.85,2.85,0,0,1,1.41.8,1.31,1.31,0,0,1,.42.8,3,3,0,0,0-1.58-.57c-.75-.06-1.67.23-1.81,1.08s.79,1.1,1.49,1.18a2.69,2.69,0,0,0,1.87-.41s0,0,0,0a1.13,1.13,0,0,1-.2,1.17,1.88,1.88,0,0,1-1.32.63,1.14,1.14,0,0,1-1.23-.78c0-.14-.2-.18-.24,0a1.36,1.36,0,0,0,1.38,1.6,2.4,2.4,0,0,0,2.06-1.23,2.16,2.16,0,0,0,.09-2,1.86,1.86,0,0,0-.14-2.07A3.25,3.25,0,0,0,326.2,127a2.79,2.79,0,0,0-.58.18c-.15.07-.28.19-.43.28S325.1,127.93,325.27,127.88Zm2.46,2.06a3,3,0,0,1,.49.21,2.77,2.77,0,0,1-.8.09,4.9,4.9,0,0,1-.94-.08,1.28,1.28,0,0,1-.27-.11l0,0c.05,0,.12-.09.17-.11l.2-.06a2.06,2.06,0,0,1,1.18.08Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,145a3.17,3.17,0,0,1,3.86.07c.11.11.13.58-.12.55a9.52,9.52,0,0,0-2.13-.23,2.82,2.82,0,0,0-1.69.75c-1.07,1-.57,2.53.07,3.67a5.08,5.08,0,0,0,2.91,2.63,2.38,2.38,0,0,0,2.89-1.33c.1-.23.37-.13.38.11a2.62,2.62,0,0,1-2.67,2.4,4.29,4.29,0,0,1-3.35-1.71,6.93,6.93,0,0,1-1.7-3.71A3.57,3.57,0,0,1,316,145Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.88,142.48c0,.28.41-.55,1.44-1.22a3.18,3.18,0,0,1,2.11-.48,3,3,0,0,1,.52.1c.28.08.25-.3-.28-.65a2.32,2.32,0,0,0-1.07-.4,2.44,2.44,0,0,0-2.71,2.12A3.13,3.13,0,0,0,325.88,142.48Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,137.39c.06.25.3-.53,1.15-1.24a2.85,2.85,0,0,1,1.83-.66,3.57,3.57,0,0,1,.47,0c.26,0,.2-.29-.31-.56a2.23,2.23,0,0,0-1-.24,2.08,2.08,0,0,0-2.19,2.19A2.42,2.42,0,0,0,337,137.39Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,141.47c.9-.31,2.24.47,1.44,1.08s-3.06,1.82-3.13,1.25A3.17,3.17,0,0,1,336.09,141.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,146.49l-3.63.79a1.86,1.86,0,0,0,3.63-.79Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87,146.49A3.2,3.2,0,1,0,327,144,2.88,2.88,0,0,0,323.87,146.49Z",
    style: {
      fill: "#f28f8f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16,140.11a3.2,3.2,0,1,0,1.14-3.87A2.89,2.89,0,0,0,340.16,140.11Z",
    style: {
      fill: "#f28f8f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.51,187.68c6.1,4.58,21.2,8.9,41,8.44,12.19-.28,26.71-2.13,32.17-7.32,1.83-2.38,7.39-4.94,7.3-7.78,0-1.14,1.09-2.35,1.49-3.51a7.21,7.21,0,0,0-.16-3.83c-5.08,5.51-17.8,7.8-20.46,7.34a2.74,2.74,0,0,1-2.14-1.57,3.66,3.66,0,0,1,.36-2.67c1.34-3.06,3.66-5.92,3.49-9.4a2.27,2.27,0,0,0-.84-1.82,1.59,1.59,0,0,0-1.94,0,28.33,28.33,0,0,1-4.84,5,24.36,24.36,0,0,0-5.75,6.1c-1,1.46-2,2.77-4,3.25-1.82.42-6.75.35-8.55.32-7.36-.13-19.46-4.52-26.61-9.39-1.8-1.23-5.94-8.33-4.54-16.3l-1.25-.84a3.89,3.89,0,0,1-1.46-.41c-1.23,1.75-6.06,16.28-6.83,19.36C308.93,180.76,308.41,183.09,314.51,187.68Z",
    style: {
      fill: "#c8856a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.49,172.9c-3.25-1.94-12.16-.57-13.21.51,2.42-2.95,9.24-3.09,9.24-3.09Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.7,166.53c-2.26-.82-8.53-9.79-9.37-12a34.15,34.15,0,0,0-3.73-6.88c-1.44-2-1.92-4.46-1.14-5.37s1.62-1.31,2.79-.05a19.81,19.81,0,0,0,5.64,4.59c3.28,1.87,6.73,3.74,7.64,8.3S369.7,166.53,369.7,166.53Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27,135.58c-3.95-14-9.17-18-18.29-19.84-9.79,9.79-6.36,26.93-6.36,26.93L402,168.82c-7.32-2.2-17.29-6.58-19.92-7.53a6.93,6.93,0,0,1-4.5-3.86c-1.12-2.38-2.36-5.3-2.83-6.52s-1.36-3.56-2.59-4.36c-1-.65-4.32-.66-7.21-.85a18.36,18.36,0,0,0-6.43.59c-1.58.44-6.2,2.64-7,3.89s.2,2.53,2,2.64c1.62.11,4.76-1.52,6.72-1.5s6.92.57,6.92.57-6.43.2-7.32.34-3.85,1.21-4.83,1.51-2.72,1.58-2.71,2.29.39,2.07,1.09,2.28a4.38,4.38,0,0,0,1.32.18,5.52,5.52,0,0,0-.21,1.41,1.92,1.92,0,0,0,.22,1,2,2,0,0,0-.12,1.86,3.38,3.38,0,0,0,1.52,1.58,16.78,16.78,0,0,0,4.24,1.84c3.32,1.11,4.65,1.87,6.64,5.06,1.53,2.47,4.5,3.4,7,4.14,1.82.53,8.7,5.19,14.85,9s12.11,9.55,22.2,13.27c8,2.95,15.49-.26,16.7-3.42C432.86,187.11,423.22,149.53,419.27,135.58Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.36,158.31a1.36,1.36,0,0,1-.72-.78,3.87,3.87,0,0,0,2,.28c1.43-.05,5.29-1,7.65-.87s4.93.57,6,.17c-.71.41-3.31.55-6.08.49a46.87,46.87,0,0,0-7.49.89A4.38,4.38,0,0,1,353.36,158.31Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.42,161.69c.86.21,4.86.35,6.33.44s3.88,0,3.88,0a15.71,15.71,0,0,1-3.21.4c-1.38,0-5.39-.18-6.91-.45a5.32,5.32,0,0,1-2.82-1.21,1.92,1.92,0,0,1-.22-1C355,161,356.56,161.48,357.42,161.69Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402,168.82c6.82,2.71,8.5,3.51,10.78,5.29a15.79,15.79,0,0,1,3.62,4s.94-6.89-15.39-12.84Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,114.83c8.72,2.49,12,4.23,15.74,11.43s9.74,36,9.74,36-9.5,7.3-24.45,5.91c0,0-6-16.45-7.79-24.25S392,119.82,400.64,114.83Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,114.83c8.72,2.49,12,4.23,15.74,11.43s9.74,36,9.74,36-9.5,7.3-24.45,5.91c0,0-6-16.45-7.79-24.25S392,119.82,400.64,114.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.12,432.69c-.54,5-1.62,8.3-4,11.08s-6.56,3.35-10.79,2.12-9.6-4-10.68-8.48-.73-7.44.39-12.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.39,394.62c-1.76,0-2.5,6.71-3.74,13.43-1.32,7.2-4.12,10-5.29,15.88-1.33,6.73-1,9.82,1.85,14.2s13.21,9.33,18.59,3.85c4.38-4.46,4.73-9.79,4.57-16.64-.16-7.09-.35-12.07.18-17.39.52-5.09,1.12-10-.39-10.7-.14.74-.29,1.68-.43,2.41-.12.56-.38,3.31-1.37,3.25a8.31,8.31,0,0,1,0-1.93,2.06,2.06,0,0,0-.43-1.69,3.94,3.94,0,0,0-1.92-.86c-1.72-.42-3.45-.82-5.2-1.09-.87-.14-1.75-.25-2.62-.32a8.73,8.73,0,0,0-2.23.07,1.41,1.41,0,0,0-1,.61,1.7,1.7,0,0,0-.11.78,4.69,4.69,0,0,1-.27,1.38c-.07.2-.25.43-.5.36a.42.42,0,0,1-.27-.44c0-.83,0-1.41.1-2.37,0-.44.09-1,.1-1.48A3,3,0,0,1,92.39,394.62Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.39,394.62c-1.76,0-2.5,6.71-3.74,13.43-1.32,7.2-4.12,10-5.29,15.88-1.33,6.73-1,9.82,1.85,14.2s13.21,9.33,18.59,3.85c4.38-4.46,4.73-9.79,4.57-16.64-.16-7.09-.35-12.07.18-17.39.52-5.09,1.12-10-.39-10.7-.14.74-.29,1.68-.43,2.41-.12.56-.38,3.31-1.37,3.25a8.31,8.31,0,0,1,0-1.93,2.06,2.06,0,0,0-.43-1.69,3.94,3.94,0,0,0-1.92-.86c-1.72-.42-3.45-.82-5.2-1.09-.87-.14-1.75-.25-2.62-.32a8.73,8.73,0,0,0-2.23.07,1.41,1.41,0,0,0-1,.61,1.7,1.7,0,0,0-.11.78,4.69,4.69,0,0,1-.27,1.38c-.07.2-.25.43-.5.36a.42.42,0,0,1-.27-.44c0-.83,0-1.41.1-2.37,0-.44.09-1,.1-1.48A3,3,0,0,1,92.39,394.62Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.82,422c-.2,1-1.45,7.4.71,8.77,2.35,1.47,3.83-3.55,3.83-3.55s5.64-.9,13.69,2.66c-.45,1,.69,4.62,3,4.07s3.37-8,3.38-8c.13,6.56-.33,11.72-4.58,16.05-5.38,5.48-15.76.53-18.59-3.85s-3.18-7.47-1.85-14.2C83.49,423.25,83.65,422.62,83.82,422Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.82,422c-.2,1-1.45,7.4.71,8.77,2.35,1.47,3.83-3.55,3.83-3.55s5.64-.9,13.69,2.66c-.45,1,.69,4.62,3,4.07s3.37-8,3.38-8c.13,6.56-.33,11.72-4.58,16.05-5.38,5.48-15.76.53-18.59-3.85s-3.18-7.47-1.85-14.2C83.49,423.25,83.65,422.62,83.82,422Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,427.74c-.12,2.46-3.11,1.37-3.13-2.12s2.63-11.57,2.8-17.57c1.24-6.72,2-13.46,3.74-13.43,0,.09-.11,1.49-.12,1.57L92,398.31a13.82,13.82,0,0,0-.14,1.47c-.21,5-1.42,14.69-2.11,19.24A65.23,65.23,0,0,0,89,427.74Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.11,429.75a64.58,64.58,0,0,0,2-8.52c.75-4.51,2.59-13.94,4-18.81.31-1.06.58-2.27.66-2.67.19-1.06.3-1.61.44-2.33a1.47,1.47,0,0,1,0-.17c1.17.45,1.07,3.26.79,6.66-.29,2-.76,4.37-1.41,7.28-1.7,5.75-1.69,14.31-2.79,17.62S100.45,432.13,101.11,429.75Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.22,430.12A1.13,1.13,0,0,1,102,430a25.85,25.85,0,0,0-13.47-2.27.72.72,0,0,1-.78-.44c-.09-.29.13-.56.48-.61a27.1,27.1,0,0,1,14.41,2.44.5.5,0,0,1,.25.73A.67.67,0,0,1,102.22,430.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.86,424.88a.9.9,0,0,1-.22-.06,31.8,31.8,0,0,0-15.08-2.55.71.71,0,0,1-.77-.45.51.51,0,0,1,.51-.59,33,33,0,0,1,15.94,2.69.5.5,0,0,1,.28.72A.64.64,0,0,1,103.86,424.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.15,417.22a.69.69,0,0,1-.54-.4.49.49,0,0,1,.43-.63c7.93-1.48,15.6,2.4,15.92,2.57a.49.49,0,0,1,.25.73.73.73,0,0,1-.88.15c-.08,0-7.52-3.8-14.9-2.42A.66.66,0,0,1,89.15,417.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.76,412.46a.69.69,0,0,1-.53-.39.48.48,0,0,1,.41-.64A25,25,0,0,1,105.88,414a.49.49,0,0,1,.2.74.75.75,0,0,1-.9.1,23.81,23.81,0,0,0-15.13-2.37A.71.71,0,0,1,89.76,412.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,407.11a.69.69,0,0,1-.53-.38.47.47,0,0,1,.4-.64c8.19-1.76,16,2.52,16.36,2.71a.49.49,0,0,1,.21.74.71.71,0,0,1-.89.11c-.08,0-7.65-4.17-15.25-2.54A.76.76,0,0,1,90.47,407.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7,417.93c.33,0,.69,3.36-1.16,4.7-2.14,1.54-8.34,4-16.34,2.69s-12.26-3.73-15.38-6.32-7.48-6.24-11.09-7.12c-3.35-.82-7-2.37-8-3.36s-.72-5.23-.72-5.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,387.14a1.28,1.28,0,0,0-1.26.94c-.3,1.15-.7,4.53-1.32,6.43-.84,2.63-1.56,8.06-1.21,10.25s5.8,3.92,9.27,5.29a45.69,45.69,0,0,1,11.13,7c3.66,3,11.49,6.28,16.73,6.46,6.21.22,13.26-1.32,15-3.88,2.11-3.16,3.71-6.87-5.32-11.13-1.71-.81-7.69-4.36-9.72-5.64-5.51-3.47-9.35-6.6-11.71-12.43a3.19,3.19,0,0,0-1.25-1.81,3.23,3.23,0,0,0-1.78-.22c-1.54.13-7.68.65-9.1,1.2-1.26.48-3,1-3.07,2.48a4.47,4.47,0,0,0,.29,1.48c.1.3.17.69-.12.85s-.62-.05-.85-.25a22,22,0,0,1-2.37-2.82,8.49,8.49,0,0,0-1.4-1.41,16.18,16.18,0,0,1-1.54-1C147.73,388.44,147.89,387.81,147.89,387.14Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.89,387.14a1.28,1.28,0,0,0-1.26.94c-.3,1.15-.7,4.53-1.32,6.43-.84,2.63-1.56,8.06-1.21,10.25s5.8,3.92,9.27,5.29a45.69,45.69,0,0,1,11.13,7c3.66,3,11.49,6.28,16.73,6.46,6.21.22,13.26-1.32,15-3.88,2.11-3.16,3.71-6.87-5.32-11.13-1.71-.81-7.69-4.36-9.72-5.64-5.51-3.47-9.35-6.6-11.71-12.43a3.19,3.19,0,0,0-1.25-1.81,3.23,3.23,0,0,0-1.78-.22c-1.54.13-7.68.65-9.1,1.2-1.26.48-3,1-3.07,2.48a4.47,4.47,0,0,0,.29,1.48c.1.3.17.69-.12.85s-.62-.05-.85-.25a22,22,0,0,1-2.37-2.82,8.49,8.49,0,0,0-1.4-1.41,16.18,16.18,0,0,1-1.54-1C147.73,388.44,147.89,387.81,147.89,387.14Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5,417.08c-1.55-1.27-3.21-2.5-4.87-3.62h0s10.56,6.43,15,3.9c2.89-1.64,1.64-3.83,1.6-4.51s10.1-5.07,12.84-5.26h0c.75.42,1.38.75,1.77.94,9,4.26,7.43,8,5.32,11.13-1.71,2.56-6.85,4.39-14.86,4.06C176.09,423.51,168.16,420.08,164.5,417.08Z",
    style: {
      fill: "#845EC2",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5,417.08c-1.55-1.27-3.21-2.5-4.87-3.62h0s10.56,6.43,15,3.9c2.89-1.64,1.64-3.83,1.6-4.51s10.1-5.07,12.84-5.26h0c.75.42,1.38.75,1.77.94,9,4.26,7.43,8,5.32,11.13-1.71,2.56-6.85,4.39-14.86,4.06C176.09,423.51,168.16,420.08,164.5,417.08Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,410.84c5.63,2.32,3.15,3.19,1.54,3.33s-11-5.38-16.72-9.85c-5.94-4.67-9.6-9.66-11.81-11.37-.82-.64-1.7-1.42-2.48-2.15.19-1.14.36-2.18.5-2.72a1.28,1.28,0,0,1,1.26-.94c0,.67-.16,1.3.37,1.83a16.18,16.18,0,0,0,1.54,1,8.49,8.49,0,0,1,1.4,1.41,22,22,0,0,0,2.37,2.82C158.32,400.17,170,408.52,175.6,410.84Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.77,413.39a.66.66,0,0,1-.36-.13.49.49,0,0,1,0-.73c1.69-1.74,9.51-5.69,13.7-5.1a.53.53,0,0,1,.48.59.54.54,0,0,1-.64.43c-3.91-.55-11.35,3.39-12.69,4.77A.57.57,0,0,1,176.77,413.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.89,410.39a.59.59,0,0,1-.35-.14.49.49,0,0,1,0-.73c1.69-1.73,9.51-5.68,13.7-5.09a.53.53,0,0,1,.48.59.55.55,0,0,1-.64.43c-3.92-.54-11.35,3.39-12.69,4.76A.63.63,0,0,1,171.89,410.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,407.53a.65.65,0,0,1-.35-.13.49.49,0,0,1,0-.73c1.69-1.74,9.51-5.7,13.7-5.1a.53.53,0,0,1,.48.59.54.54,0,0,1-.64.43c-3.91-.54-11.35,3.39-12.69,4.77A.58.58,0,0,1,167,407.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,404.31a.61.61,0,0,1-.36-.13.5.5,0,0,1,0-.73c1.69-1.73,9.53-5.69,13.71-5.1a.53.53,0,0,1,.47.59.55.55,0,0,1-.64.44c-3.91-.55-11.35,3.39-12.69,4.76A.56.56,0,0,1,162.52,404.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.11,401.1a.62.62,0,0,1-.34-.13.49.49,0,0,1-.07-.73c2.33-2.46,10.48-5.7,14.67-5.11a.53.53,0,0,1,.48.59.56.56,0,0,1-.64.44c-3.77-.54-11.58,2.58-13.65,4.76A.54.54,0,0,1,158.11,401.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.16,178.58C95.39,194,89.68,196.11,88.5,224.42s-.79,81.92-.79,81.92-2,14.85-3.38,35.24,2.4,61.71,2.4,61.71,0,3.88,11.73,5.12,12.62-2.5,12.62-2.5,8.75-53.46,13.38-75,11.07-58.59,11.07-58.59l3.17,37.36s-2.18,9.53-1,28.34,7,55.1,7,55.1S158,398.81,170.46,392c0,0,7.06-70.35,8-105.19s-1.53-74.43-6.44-99Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.16,178.58C95.39,194,89.68,196.11,88.5,224.42s-.79,81.92-.79,81.92-2,14.85-3.38,35.24,2.4,61.71,2.4,61.71,0,3.88,11.73,5.12,12.62-2.5,12.62-2.5,8.75-53.46,13.38-75,11.07-58.59,11.07-58.59l3.17,37.36s-2.18,9.53-1,28.34,7,55.1,7,55.1S158,398.81,170.46,392c0,0,7.06-70.35,8-105.19s-1.53-74.43-6.44-99Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.53,272.28l4.38-33.92s15.66-2.11,23.3-10.94c0,0-4.55,10.78-18.46,15.23l-4.5,28.22-1.55,38.77Z",
    style: {
      fill: "#845EC2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.54,190c3.22-5.15,1.25-13-1.86-19.28s-15.92-27.37-15.92-27.37l-19.63,16.57,19.1,31.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.68,173c2.3-1.32,5.91-.26,5.91-.26a7.83,7.83,0,0,0-5.91-2.07C185.17,171.06,188.68,173,188.68,173Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.22,114c7.56,1,12.51,2.19,15.9,5.32s7,8.6,10.73,14.85,10,17,10,17a33.33,33.33,0,0,1-8.95,9.89,51.72,51.72,0,0,1-12.34,6.79l-16.48-22.5Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,114c7.56,1,12.51,2.19,15.9,5.32s7,8.6,10.73,14.85,10,17,10,17a33.33,33.33,0,0,1-8.95,9.89,51.72,51.72,0,0,1-12.34,6.79l-16.48-22.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143,113.78a218.61,218.61,0,0,0-22.66.56s-13,2.69-15.95,3.57-6,13-4,23.8,4.51,28.08,4.51,28.08c-3.53,11.07-15.22,24.07-16.05,37.08,23.28,15.94,69.32,15.74,87.21,1.32-1.31-14.58-6.67-28.6-9.67-36.29,0,0,2-7.51,1-13.2,0,0,5.06-5,5.39-12,.35-7.38-2.95-12.06-9.89-20.14A76.8,76.8,0,0,0,148.22,114Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,113.78a218.61,218.61,0,0,0-22.66.56s-13,2.69-15.95,3.57-6,13-4,23.8,4.51,28.08,4.51,28.08c-3.53,11.07-15.22,24.07-16.05,37.08,23.28,15.94,69.32,15.74,87.21,1.32-1.31-14.58-6.67-28.6-9.67-36.29,0,0,2-7.51,1-13.2,0,0,5.06-5,5.39-12,.35-7.38-2.95-12.06-9.89-20.14A76.8,76.8,0,0,0,148.22,114Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.25,162.34s4.24,8.35,15.11,7.54a16.42,16.42,0,0,0,13.54-9.33S143,172,129.48,172.62,114.25,162.34,114.25,162.34Z",
    style: {
      fill: "#845EC2",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.21,107.72c-4-1.7-9.54-5.24-12.46-11.4-10.77-22.77.59-36.46,7.35-36.71,1.12-8.55,6.81-12.65,20-13.21,25.24-1.09,31,21.51,23.95,30.47-1.47,5.29-3.16,20.77,3.77,23.82C142,119.9,118.21,107.72,118.21,107.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.21,107.72c-4-1.7-9.54-5.24-12.46-11.4-10.77-22.77.59-36.46,7.35-36.71,1.12-8.55,6.81-12.65,20-13.21,25.24-1.09,31,21.51,23.95,30.47-1.47,5.29-3.16,20.77,3.77,23.82C142,119.9,118.21,107.72,118.21,107.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,58c3.58,1.75,9.25,6.34,9.27,24.79,0,12.66-2.48,18.51-7.19,21.46-2.31,1.45-3.45,2.84-8.18,2.43l.25,6.93s10.35,10.88-.25,13.1c-5.3,1.11-12-.5-16.8-3.73s-6.76-6.33-6.76-6.33L118,95.56s-3.59,3.35-8.56-.35c-4.11-3-5.86-8.61-3.11-11.89s8.59-2.95,11.06,1.22c0,0,3.71,3.08,3.71-3.15,0-4.76-1.52-10.89,5.58-14.86C134,62.46,139.82,65.17,148,58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,91.75l6.86,1.81A3.49,3.49,0,0,1,139,96.2,3.72,3.72,0,0,1,136.44,91.75Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,96.2a3.24,3.24,0,0,0,.75.11,3.27,3.27,0,0,0-3.32-2.81A3.65,3.65,0,0,0,139,96.2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.05,72.43l-5.49-1.25A2.69,2.69,0,0,1,151.83,69,3,3,0,0,1,154.05,72.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.72,71.75l-5.46,2.39a2.86,2.86,0,0,1,1.42-3.91A3.13,3.13,0,0,1,134.72,71.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.56,73.84l.21,13.72,7.82-1.13C148.44,81.28,143.36,75.07,141.56,73.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,106.66c-5-.25-17.46-2.65-20.84-9a16.48,16.48,0,0,0,4.24,6.44c5.7,5,16.7,5.21,16.7,5.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.64,77.81c.33,1.17,1.33.89,2.52.59s2.15-.5,1.82-1.68a2.3,2.3,0,0,0-2.76-1.58A2.16,2.16,0,0,0,148.64,77.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,78c-.15,1.21.88,1.32,2.1,1.51s2.17.35,2.32-.86a2.31,2.31,0,0,0-2-2.52A2.15,2.15,0,0,0,131.63,78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,77.79s0-.06,0-.09a.33.33,0,0,0-.08-.18,1.73,1.73,0,0,0-.21-.17,2.66,2.66,0,0,0-1-.32,4.49,4.49,0,0,0-.64-.1,1.33,1.33,0,0,0-.74.06.3.3,0,0,0-.14.26.21.21,0,0,0,.08.16.59.59,0,0,0,.26.1l2,.42a.51.51,0,0,0,.3,0A.22.22,0,0,0,131,77.79Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.66,78.51a2.68,2.68,0,0,0-.49,0l-.47,0-.93.1a.18.18,0,0,0-.16.17.29.29,0,0,0,0,.16.36.36,0,0,0,0,.09.18.18,0,0,0,.11.08l1,0h.7a1,1,0,0,0,.25,0c.14,0,.19-.17.19-.31S130.8,78.53,130.66,78.51Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.83,76.75a.19.19,0,0,1,0-.08.3.3,0,0,1,.08-.18l.2-.17a3,3,0,0,1,1-.33l.63-.09a1.36,1.36,0,0,1,.75.06.33.33,0,0,1,.14.26.25.25,0,0,1-.08.16.59.59,0,0,1-.26.1l-2,.42a.51.51,0,0,1-.3,0A.24.24,0,0,1,153.83,76.75Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.15,77.48a2,2,0,0,1,.49,0l.47,0,.93.09a.2.2,0,0,1,.16.18.29.29,0,0,1,0,.16l0,.09a.16.16,0,0,1-.11.07l-1,0h-.69a1,1,0,0,1-.25,0c-.15,0-.2-.17-.2-.31S154,77.5,154.15,77.48Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mask--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.38,84.54c9.75,1.69,21.8-1.91,25.62-2.68s5.34.8,5.34.8,6.21,2,8.95-1c1.65,6.6.23,19-5.92,22.94s-17.77,2.8-23,0a17.47,17.47,0,0,1-7.27-7l-.48-10.67-2.11-.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.29,81.64c-3.19,3.12-8.95,1-8.95,1a3,3,0,0,0-.41-.3l-.3.66c1.9,6.47,1.06,17.75-1.73,23.64a15.58,15.58,0,0,0,5.47-2.08C157.52,100.59,158.94,88.24,157.29,81.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,85.23c4.79-1.1,8.34-2.78,10.8-1.17,2.21,1.45,7.38.87,9.19-.57-.1-.65-.21-1.28-.35-1.85-3,2.73-8.95,1-8.95,1s-1.52-1.58-5.34-.8-15.87,4.37-25.62,2.68l1.12,2.06,2.11.29C125.87,87.62,132.86,86.33,137.65,85.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.09 97.56 118.02 97.64 117.99 95.56 121 95.48 121.09 97.56",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152,131.36v-4.05a59.26,59.26,0,0,1-10.09-.62c-12.7-1.55-19.32-8.09-23.63-12.12l-4.08,1.07c3.29,5.16,12.59,12.19,22.31,14.46S152,131.36,152,131.36Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,131.36v-4.05a59.26,59.26,0,0,1-10.09-.62c-12.7-1.55-19.32-8.09-23.63-12.12l-4.08,1.07c3.29,5.16,12.59,12.19,22.31,14.46S152,131.36,152,131.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,126.69c1.49.21,2.92.38,4.25.48,0,0,1.38-10.25-1-13.3l-3-.28S144.07,121.72,141.93,126.69Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,126.69c1.49.21,2.92.38,4.25.48,0,0,1.38-10.25-1-13.3l-3-.28S144.07,121.72,141.93,126.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.37,161.68c1.69,2.58,3.19,12-6.18,21.62s-21.4,17.51-39,18.37S108,194.86,109.79,183,127.07,168.27,134,165.6s17-15.91,30.23-15.4S188.37,161.68,188.37,161.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,177.66c-6.87,4.28-24.43,12.58-31.85,13.22-7.64.67-15.84-1.81-20.7-7.73-.93-1.14-2-2.52-3.46-2.49-1.63,0-2.68,1.93-2.55,3.56s1,3.06,1.59,4.58.75,3.43-.37,4.61a4.92,4.92,0,0,1-3.07,1.22,25.34,25.34,0,0,1-12.93-1.82c5.8,6,17.83,9.46,29.92,8.86,17.63-.86,29.67-8.78,39-18.37A30.09,30.09,0,0,0,186.57,177.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,148.13c0,5-4.49,11.43-7.17,12.18-2.82,2-4.72,3.75-10.28,4.28-7.55.73-13.77-1.69-16.95-7.8a13.32,13.32,0,0,1-.91-7.57c.58-3.24,1.89-4.35,3.33-6s1.13-2.36,2.06-4.14a15.83,15.83,0,0,1,3.19-4.51,13.6,13.6,0,0,1,4.71-2.65,16.1,16.1,0,0,1,5.2-.8A16.56,16.56,0,0,1,195.65,148.13Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.16,152.79a3.16,3.16,0,0,0-3.86.07c-.11.11-.13.58.12.55a9.52,9.52,0,0,1,2.13-.23,2.82,2.82,0,0,1,1.69.75c1.06,1,.57,2.53-.07,3.67a5.11,5.11,0,0,1-2.91,2.63,2.38,2.38,0,0,1-2.89-1.33c-.1-.23-.37-.13-.38.11a2.62,2.62,0,0,0,2.67,2.4A4.29,4.29,0,0,0,190,159.7a6.93,6.93,0,0,0,1.7-3.71A3.56,3.56,0,0,0,190.16,152.79Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,150.53c0,.28-.41-.55-1.43-1.22a3.16,3.16,0,0,0-2.12-.48,3,3,0,0,0-.52.1c-.28.08-.25-.3.28-.66a2.3,2.3,0,0,1,1.07-.39,2.43,2.43,0,0,1,2.71,2.12A3.13,3.13,0,0,1,179.5,150.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58,145.35c-.05.25-.3-.54-1.14-1.24a2.89,2.89,0,0,0-1.84-.66,2.42,2.42,0,0,0-.47,0c-.26,0-.2-.3.31-.56a2.23,2.23,0,0,1,1-.24,2.08,2.08,0,0,1,2.19,2.19A1.83,1.83,0,0,1,168.58,145.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.68,148.52c-.86-.41-2.28.21-1.56.91s2.82,2.17,3,1.61A3.2,3.2,0,0,0,169.68,148.52Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,154.25l3.64.79a1.74,1.74,0,0,1-2.16,1.29A1.76,1.76,0,0,1,169.56,154.25Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.21,197.23c-4.35,3-14.2,9.81-34.44,12.52-10.75,1.43-23.65.24-30.21-3.89-2.33-2-8.46-3.48-8.94-6.37-.19-1.15-1.58-2.14-2.22-3.23a7.47,7.47,0,0,1-.62-3.9c6,5,19.54,4.25,22.13,3.25a2.79,2.79,0,0,0,1.84-2,3.78,3.78,0,0,0-.9-2.62c-2-2.81-4.9-5.23-5.43-8.77a2.3,2.3,0,0,1,.47-2c.5-.48,1.41-.82,2-.39a29.19,29.19,0,0,0,5.89,4,27.93,27.93,0,0,1,7.15,5.53c1.26,1.28,2,3,3.76,3.66s4,.29,5.8-.11c9.67-2.13,14.75-7.95,19-10.47,3-2.15,11.71-8.74,14.27-9.4,2.53.11,4.9,1.87,6.61,4.23a18.9,18.9,0,0,1,2.89,6.23C199.08,190,197.37,191.58,189.21,197.23Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.43,118.31c-12.75,2.32-16.9,5.83-20.17,20.22-2.27,10-5.5,32.82-6.5,47-.44,6.12.9,11.85,8.3,15.31a141,141,0,0,0,17.87,6.45c14.47,4,29.72,8.59,44.81,7.95,7.85-.34,10-1.28,14.52-3.42,1.92-1.24,4.25-1.43,6.26-2.3,1.08-.75,1.47-2.32,2.69-2.83s3.4-.28,3.67-.93c2.37-5.67-16-3.09-19.65-4.07-2.61-.36-7.52-1.72-4.83-5.14,1.66-2.41,4.12-4.49,4.55-7.51.3-1.31-.62-3.24-1.81-2.5s-3.59,2.87-5.26,3.94a36.41,36.41,0,0,0-6,4.76,10.65,10.65,0,0,1-6.44,2.49c-8.83-.46-30.06-13.13-32.83-14.61C104.61,169,114.25,130.64,104.43,118.31Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.43,117.91c-9.36,1.36-16.44,3-20.41,18s-5.87,34.19-5.87,34.19,3.1,4,13.14,5.88,13.7.51,13.7.51,3.42-20.33,4.67-27.66S112.06,123.61,104.43,117.91Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.43,117.91c-9.36,1.36-16.44,3-20.41,18s-5.87,34.19-5.87,34.19,3.1,4,13.14,5.88,13.7.51,13.7.51,3.42-20.33,4.67-27.66S112.06,123.61,104.43,117.91Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leaves--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaves--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaves--inject-94",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.42,243.31c3.23,5.5,6.07,11,7.7,17.19a63,63,0,0,1,1.79,16.71,138.13,138.13,0,0,1-1.57,20c-1.4,7.33-2.12,11.72-4.11,19.36a123.77,123.77,0,0,1-6.52,20,128.2,128.2,0,0,1-8.85,17A154.8,154.8,0,0,1,424,377c-3.26,3.84-7.39,8.08-11,11.94a82.9,82.9,0,0,1-7,6.37c-1,.86-2.2,1.63-3.25,2.37s-2,1.37-3,2.08c-.18.12-.33.25-.47.35l-.31.25c-.11.09.05,0,.05,0s-.06,0-.07,0c-.61,1.07-.58,1.77.71,2.07,0,0,.18-.07.08-.05l-.43.1a7.67,7.67,0,0,0,2.41-.89,27.79,27.79,0,0,0,2.92-1.92,70.24,70.24,0,0,0,7.32-6c3.75-3.86,8.09-8.05,11.32-12.1,7.36-9.19,14.09-16.85,19.6-27.07,6.07-11.26,9.33-17.8,13.87-33a223.48,223.48,0,0,0,4.88-22.11A132.84,132.84,0,0,0,463.23,281a70.59,70.59,0,0,0-1-16.5c-1.26-6.17-4-11.55-6.64-17.14-.74-1.57-2.05-2.63-3-4-.08-.14-.29-.14-.19,0S452.4,243.36,452.42,243.31Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.92,236.44a21.82,21.82,0,0,1,2.56,6.35c.53,2.33.3,4.82,1.11,7.15A33.88,33.88,0,0,0,456,261.25c1.67,1.9,3.87,3.25,5.81,4.86a.56.56,0,0,0,.75,0c.2-.21.1-.45-.1-.62-3.45-2.9-6.75-5.71-9.23-9.5a23.71,23.71,0,0,1-2.69-6c-.74-2.39-.84-4.86-1.48-7.23a18.4,18.4,0,0,0-3-6.36c-.08-.12-.17,0-.11.07S446,236.46,445.92,236.44Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.35,236a13.08,13.08,0,0,0,1.55,1.31c.56.41,1.18.77,1.76,1.17,1.2.8,2.49,1.44,3.63,2.35a34.36,34.36,0,0,1,5.54,5,19.91,19.91,0,0,1,3.56,6.52,30.82,30.82,0,0,1,1.1,7.62c.09,1.44-.05,2.95-.1,4.41,0,.74-.11,1.51-.17,2.25a9.32,9.32,0,0,0,0,1.18c0,.36.09.77.12,1.09s.46.75.63.38a8.86,8.86,0,0,0,.4-2.22,19.45,19.45,0,0,0,.22-2.1,39.86,39.86,0,0,0,.15-4.07,36.37,36.37,0,0,0-.9-7.8,20.24,20.24,0,0,0-3.48-6.92,26.79,26.79,0,0,0-5.83-5.16c-1.27-.94-2.7-1.58-4-2.41-.69-.43-1.41-.83-2.09-1.28s-1.33-.94-2-1.38c-.07,0-.05.06,0,.09Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.29,265.73a37.23,37.23,0,0,1,.1,6.16,21.77,21.77,0,0,0,.28,6.34,22.68,22.68,0,0,0,2.75,5.91c.58,1,1.25,1.73,2,2.69s1.62,1.91,2.31,3a17.19,17.19,0,0,1,1.76,3.57,15.28,15.28,0,0,1,.57,2.17,14.49,14.49,0,0,0,.55,2.37c.08.22.51.4.53,0a14.7,14.7,0,0,0-.49-4.11,13,13,0,0,0-1.41-3.34c-1.29-2.09-2.9-3.93-4.25-5.82a24.13,24.13,0,0,1-3.2-5.77,20.29,20.29,0,0,1-.78-6.24c-.06-1.17.13-2.38,0-3.54a19.79,19.79,0,0,0-.59-3.37c0-.08-.16-.19-.14-.06S450.29,265.76,450.29,265.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,266.56a7.68,7.68,0,0,0,1.39,3.59c1.05,1.56,2.17,2.92,3.23,4.46a44,44,0,0,1,4.95,8.55,25.94,25.94,0,0,1,1.11,5.91c0,.27.53.46.53.16a21.19,21.19,0,0,0-2.08-9.24c-1.64-3.21-3.86-5.6-5.92-8.41-.62-.85-1.34-1.52-1.93-2.35a6.53,6.53,0,0,1-1.16-2.58s-.12-.17-.12-.09S450.61,266.54,450.61,266.56Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.15,275.53a47.24,47.24,0,0,0,3.94,6.89,28.73,28.73,0,0,1,3.38,7.37,20,20,0,0,1,.36,4.92c0,.3.48.46.51.14a17.06,17.06,0,0,0-.95-7.68c-1.13-2.9-2.87-5-4.53-7.44a27.27,27.27,0,0,1-2.6-4.17c0-.06-.14-.12-.11,0S453.13,275.56,453.15,275.53Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.47,262.69a39.68,39.68,0,0,0-.55,6.26c0,1.12.05,2.24,0,3.39a25.66,25.66,0,0,1-.2,3.48,17.3,17.3,0,0,1-2.3,6.77,37.46,37.46,0,0,1-5.43,5.78c-.79.75-1.69,1.24-2.48,2.06a6.93,6.93,0,0,0-1.18,1.54,4.52,4.52,0,0,0-.68,2.61.37.37,0,0,0,.68.15c.48-.64.87-1.69,1.22-2.25a5.14,5.14,0,0,1,1-1.17c.65-.66,1.4-1.05,2-1.67a44.81,44.81,0,0,0,5.57-5.9,16.16,16.16,0,0,0,2.57-6.79,29.54,29.54,0,0,0,0-6.58,51,51,0,0,1,0-7.52c0-.1-.17-.3-.2-.16S473.42,262.71,473.47,262.69Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.36,263.24a20.54,20.54,0,0,0-.92,2.21c-.29.75-.46,1.54-.82,2.3A20.76,20.76,0,0,1,469,272a48.48,48.48,0,0,0-5.81,8.49,12.43,12.43,0,0,0-.83,2.7,8.5,8.5,0,0,0-.19,1.42,6.81,6.81,0,0,0,0,1.43c.06.46.6.49.69.11a36.66,36.66,0,0,1,1.33-5.25,19.88,19.88,0,0,1,2.45-4.36,58.61,58.61,0,0,0,5.57-8.26,14.31,14.31,0,0,0,.71-2.36c.23-.81.4-1.7.64-2.5,0-.1-.12-.34-.19-.21S473.37,263.21,473.36,263.24Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,275.8a37,37,0,0,1-3.76,6.62,55.87,55.87,0,0,0-4.18,6.51,12.94,12.94,0,0,0-.71,1.88,6.77,6.77,0,0,0-.18.92,3.55,3.55,0,0,0,0,.64,2,2,0,0,0,.12.63c.09.22.29.46.46.13a5.76,5.76,0,0,0,.37-1.06c.12-.39.16-.69.31-1.15a14.79,14.79,0,0,1,.58-1.58,32.84,32.84,0,0,1,1.69-3.21c1.32-2.13,2.84-4.14,4.05-6.33a20.77,20.77,0,0,0,1.41-3.86c0-.07-.08-.24-.12-.14S470,275.82,470,275.8Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.77,322.2c2.23.18,4.3.22,6.33-1a16.41,16.41,0,0,0,5.21-4.95c2.95-4.42,5.11-9.32,8.15-13.66a13.19,13.19,0,0,1,2.73-2.7,21.92,21.92,0,0,1,3.62-2c.27-.14,0-.4-.23-.29a25.42,25.42,0,0,0-9.61,9.06c-1.61,2.53-2.76,5.3-4.41,7.78a25.9,25.9,0,0,1-4.81,5.52,7.57,7.57,0,0,1-3.18,1.49,12.59,12.59,0,0,1-3.51.18c-.35,0-.79.54-.29.58Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.9,312.79c.54-.89,1.12-1.83,1.69-2.69a26,26,0,0,1,1.76-2.54,31.83,31.83,0,0,1,3.84-4.25,24.4,24.4,0,0,1,9.28-4.82c2.42-.66,4.84-.41,7.29-.66.2,0,0-.22-.08-.23a27.81,27.81,0,0,0-6.46.14,18.88,18.88,0,0,0-5.38,1.62c-3.38,1.75-5.91,4.37-8.49,7.18a16.94,16.94,0,0,0-1.91,2.88c-.58,1-1.07,2.25-1.57,3.33,0,0,0,.06,0,0Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,320.07a8.88,8.88,0,0,1,.83-2.25c.41-.71.82-1.59,1.29-2.36a39.8,39.8,0,0,1,3-4.58,64.59,64.59,0,0,1,7.19-7.23,25.57,25.57,0,0,1,2.36-1.7,25.89,25.89,0,0,1,2.45-1.41s0-.08,0-.07a33.58,33.58,0,0,0-4.3,2.29,34.21,34.21,0,0,0-4.23,3.24,44.11,44.11,0,0,0-6.87,8.51,22.88,22.88,0,0,0-1.39,2.75,7.61,7.61,0,0,0-.71,2.74c0,.25.4.33.46.07Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.13,325.72a38.09,38.09,0,0,0-.7,9.92c.09,1.75.51,3.35.58,5s.09,3.24,0,4.86c0,.9-.11,1.67-.18,2.56s-.23,1.82-.28,2.73c0,.29.29.49.51.55s.33,0,.49-.07a.35.35,0,0,0,.23-.31c0-.12-.06.14,0,.06a1.45,1.45,0,0,0,.1-.24c0-.12.06-.18.11-.37a6.38,6.38,0,0,0,.16-.68c0-.31.12-.78.15-1.19.08-.74.2-1.5.25-2.3.1-1.64.13-3.34.08-5a36.72,36.72,0,0,0-.73-4.95c-.28-1.67-.57-3.34-.69-5.07a26.71,26.71,0,0,1,.26-5.28c0-.17-.31-.44-.35-.23S443,325.75,443.13,325.72Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,312.37a30.4,30.4,0,0,0,1.57,5.05,20.31,20.31,0,0,1,1.43,5.12,29.13,29.13,0,0,1-1.15,10.25c-.3,1.11-.86,2.17-1.09,3.28a9.89,9.89,0,0,0-.44,3.27c.05.53.91.36,1.05,0,.31-1,.43-2,.69-3s.65-1.92.92-2.88a28,28,0,0,0,1.17-5.09,20.51,20.51,0,0,0-.13-5.19,24.09,24.09,0,0,0-1.6-5.05c-.37-.95-.9-1.84-1.29-2.78a24.72,24.72,0,0,1-1-2.89s-.14-.15-.12-.05S443,312.34,443,312.37Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,312.33a21.41,21.41,0,0,1-.53,2.72c-.26.9-.67,1.79-1,2.69a44.18,44.18,0,0,0-2.11,5.87,23.82,23.82,0,0,0,.69,11.91,9.44,9.44,0,0,0,1.74,2.71,12.12,12.12,0,0,1,1.71,2.69c.14.33.75.43.74,0a4.33,4.33,0,0,0-1.07-2.41,15.24,15.24,0,0,1-1.72-2.33,19.21,19.21,0,0,1-1.72-5.59,19.45,19.45,0,0,1,.37-6.12,59.85,59.85,0,0,1,1.89-6c.33-1,.74-2,1-3a9.84,9.84,0,0,0,.23-3c0-.09-.2-.24-.22-.09S443,312.31,443,312.33Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.9,358.8a12.66,12.66,0,0,0-1.25,1.29,14.11,14.11,0,0,0-.91,1.32c-.57.85-1,1.74-1.6,2.56a23,23,0,0,1-3.64,4.25,25.35,25.35,0,0,1-9,4.4,28.07,28.07,0,0,1-3,.39,6.91,6.91,0,0,0-3.06,1c-.45.35.06.66.49.58s1-.27,1.43-.38,1-.16,1.44-.23c.93-.14,1.93-.14,2.84-.35a24,24,0,0,0,5.13-1.63,19.15,19.15,0,0,0,4.4-2.95,24.85,24.85,0,0,0,3.5-4.21c.66-.94,1.16-2,1.77-3,.28-.46.55-.93.85-1.4s.6-1,.88-1.43c.09-.15-.16-.34-.28-.24S449.91,358.79,449.9,358.8Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.76,356.8a15.87,15.87,0,0,1-2.14,1.42,11,11,0,0,1-2.21.78c-1.54.37-3.14.41-4.66.67a14.78,14.78,0,0,0-4.38,1.17,13.64,13.64,0,0,0-3.54,2.5,15.55,15.55,0,0,0-3,4.06c-.27.53.47.71.84.39a8.22,8.22,0,0,0,1-1.17c.31-.38.39-.57.76-1a12.44,12.44,0,0,1,1.32-1.5,14.76,14.76,0,0,1,3.1-2.2,18.87,18.87,0,0,1,4.29-1.36c1.47-.33,3.08-.57,4.58-.95a12.41,12.41,0,0,0,2.29-.87,5.63,5.63,0,0,0,1-.68c.26-.19.28-.31.46-.49s.33-.37.47-.53-.07-.34-.18-.25S452.78,356.78,452.76,356.8Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.73,364.13a40.09,40.09,0,0,0-6.29,1.92,26,26,0,0,0-2.95,1.43c-.9.5-1.56,1-2.35,1.51a8.06,8.06,0,0,0-1.1.86,1.74,1.74,0,0,0-.68.9c-.1.41.49.45.72.34a9.94,9.94,0,0,0,1.76-1.31,16.68,16.68,0,0,1,1.43-1,24.75,24.75,0,0,1,3-1.74c2.16-1,4.36-1.86,6.55-2.8,0,0,0-.07,0-.06S443.73,364.12,443.73,364.13Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.08,342.73a3.72,3.72,0,0,0-.75,1.08,6.76,6.76,0,0,0-.34,1.31,14.85,14.85,0,0,0-.11,2.59c.16,1.84.58,3.63.91,5.45.66,3.72,1.46,7.28,1.31,11.1-.09,2.09-1.23,3.87-2,5.76-.25.56.6.71.83.29a17.3,17.3,0,0,0,2.25-10.44c-.37-3.79-1.6-7.29-2.14-11a15.62,15.62,0,0,1-.13-3.06,8.42,8.42,0,0,1,.22-1.38,14.77,14.77,0,0,0,.26-1.48c0-.12-.11-.34-.27-.19S431.09,342.73,431.08,342.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.31,354.71a9.51,9.51,0,0,0-.42,1.65,10.7,10.7,0,0,0-.07,1.7c0,1.15.11,2.29.21,3.43.21,2.34.42,4.68.45,7a16.35,16.35,0,0,1-.16,2,8.34,8.34,0,0,0-.31,1.94c.1.61.64.58.95.13a3.82,3.82,0,0,0,.44-1.65,10.15,10.15,0,0,0,.09-1.65,31.2,31.2,0,0,0-.29-3.48c-.32-2.4-.66-4.79-.88-7.19a15,15,0,0,1,0-1.9c0-.63.07-1.25.12-1.86,0-.06-.11-.2-.14-.12S427.32,354.69,427.31,354.71Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.06,342.72a37.06,37.06,0,0,0-6.26,10.88,25.92,25.92,0,0,0-1.18,6.64,45.71,45.71,0,0,0,.33,7.18c.26,2.89.56,5.85,1,8.73.08.57,1.05.5,1-.06-.08-2.54-.55-5.21-.72-7.7a49.8,49.8,0,0,1-.43-7.28,40.9,40.9,0,0,1,3-12.47,34.9,34.9,0,0,1,3.47-5.69c.09-.13-.12-.36-.22-.23S431,342.72,431.06,342.72Z",
    style: {
      fill: "#845EC2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaves--inject-94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaves--inject-94",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.58,243.31c-3.23,5.5-6.07,11-7.7,17.19a63,63,0,0,0-1.79,16.71,138.13,138.13,0,0,0,1.57,20c1.4,7.33,2.12,11.72,4.11,19.36a123.77,123.77,0,0,0,6.52,20,128.2,128.2,0,0,0,8.85,17A154.8,154.8,0,0,0,76,377c3.26,3.84,7.39,8.08,11,11.94a82.9,82.9,0,0,0,7,6.37c1,.86,2.2,1.63,3.25,2.37s2,1.37,3,2.08c.18.12.33.25.47.35l.31.25c.11.09,0,0,0,0s.06,0,.07,0c.61,1.07.58,1.77-.71,2.07,0,0-.18-.07-.08-.05l.43.1a7.67,7.67,0,0,1-2.41-.89,27.79,27.79,0,0,1-2.92-1.92,70.24,70.24,0,0,1-7.32-6c-3.75-3.86-8.09-8.05-11.32-12.1-7.36-9.19-14.09-16.85-19.6-27.07-6.07-11.26-9.33-17.8-13.87-33a223.48,223.48,0,0,1-4.88-22.11A132.84,132.84,0,0,1,36.77,281a70.59,70.59,0,0,1,1-16.5c1.26-6.17,4-11.55,6.64-17.14.74-1.57,2-2.63,3-4,.08-.14.29-.14.19,0S47.6,243.36,47.58,243.31Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.08,236.44a21.82,21.82,0,0,0-2.56,6.35c-.53,2.33-.3,4.82-1.11,7.15A33.88,33.88,0,0,1,44,261.25c-1.67,1.9-3.87,3.25-5.81,4.86a.56.56,0,0,1-.75,0c-.2-.21-.1-.45.1-.62,3.45-2.9,6.75-5.71,9.23-9.5a23.71,23.71,0,0,0,2.69-6c.74-2.39.84-4.86,1.48-7.23a18.4,18.4,0,0,1,3-6.36c.08-.12.17,0,.11.07S54.05,236.46,54.08,236.44Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.65,236a13.08,13.08,0,0,1-1.55,1.31c-.56.41-1.18.77-1.76,1.17-1.2.8-2.49,1.44-3.63,2.35a34.36,34.36,0,0,0-5.54,5,19.91,19.91,0,0,0-3.56,6.52,30.82,30.82,0,0,0-1.1,7.62c-.09,1.44.05,2.95.1,4.41,0,.74.11,1.51.17,2.25a9.32,9.32,0,0,1,0,1.18c0,.36-.09.77-.12,1.09s-.46.75-.63.38a8.86,8.86,0,0,1-.4-2.22,19.45,19.45,0,0,1-.22-2.1,39.86,39.86,0,0,1-.15-4.07,35.76,35.76,0,0,1,.91-7.8,20,20,0,0,1,3.47-6.92,26.79,26.79,0,0,1,5.83-5.16c1.27-.94,2.7-1.58,4-2.41.69-.43,1.41-.83,2.09-1.28s1.33-.94,2-1.38c.07,0,0,.06,0,.09Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.71,265.73a37.23,37.23,0,0,0-.1,6.16,21.77,21.77,0,0,1-.28,6.34,22.68,22.68,0,0,1-2.75,5.91c-.58,1-1.25,1.73-2,2.69s-1.62,1.91-2.31,3a17.19,17.19,0,0,0-1.76,3.57,15.28,15.28,0,0,0-.57,2.17,14.49,14.49,0,0,1-.55,2.37c-.08.22-.51.4-.53,0a14.7,14.7,0,0,1,.49-4.11,13,13,0,0,1,1.41-3.34c1.29-2.09,2.9-3.93,4.25-5.82a24.13,24.13,0,0,0,3.2-5.77A20.29,20.29,0,0,0,49,272.7c.06-1.17-.13-2.38-.05-3.54a19.79,19.79,0,0,1,.59-3.37c0-.08.16-.19.14-.06S49.71,265.76,49.71,265.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.39,266.56A7.68,7.68,0,0,1,48,270.15c-1,1.56-2.17,2.92-3.23,4.46a44,44,0,0,0-5,8.55,25.94,25.94,0,0,0-1.11,5.91c0,.27-.53.46-.53.16A21.19,21.19,0,0,1,40.26,280c1.64-3.21,3.86-5.6,5.92-8.41.62-.85,1.34-1.52,1.93-2.35a6.53,6.53,0,0,0,1.16-2.58s.12-.17.12-.09S49.39,266.54,49.39,266.56Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.85,275.53a47.24,47.24,0,0,1-3.94,6.89,28.73,28.73,0,0,0-3.38,7.37,20,20,0,0,0-.36,4.92c0,.3-.48.46-.51.14a17.06,17.06,0,0,1,1-7.68c1.13-2.9,2.87-5,4.53-7.44a27.27,27.27,0,0,0,2.6-4.17c0-.06.14-.12.11,0S46.87,275.56,46.85,275.53Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.53,262.69a40.91,40.91,0,0,1,.56,6.26c0,1.12-.06,2.24,0,3.39a25.66,25.66,0,0,0,.2,3.48,17.3,17.3,0,0,0,2.3,6.77A37.46,37.46,0,0,0,35,288.37c.79.75,1.69,1.24,2.48,2.06A6.93,6.93,0,0,1,38.68,292a4.52,4.52,0,0,1,.68,2.61.37.37,0,0,1-.68.15c-.48-.64-.87-1.69-1.22-2.25a5.14,5.14,0,0,0-1-1.17c-.65-.66-1.4-1.05-2-1.67a44.81,44.81,0,0,1-5.57-5.9A16.16,16.16,0,0,1,26.33,277a29.54,29.54,0,0,1,0-6.58,51,51,0,0,0,0-7.52c0-.1.17-.3.2-.16S26.58,262.71,26.53,262.69Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.64,263.24a20.54,20.54,0,0,1,.92,2.21c.29.75.46,1.54.82,2.3A20.76,20.76,0,0,0,31,272a48.48,48.48,0,0,1,5.81,8.49,12.43,12.43,0,0,1,.83,2.7,8.5,8.5,0,0,1,.19,1.42,6.81,6.81,0,0,1,0,1.43c-.06.46-.6.49-.69.11a36.66,36.66,0,0,0-1.33-5.25,19.88,19.88,0,0,0-2.45-4.36,58.61,58.61,0,0,1-5.57-8.26,14.31,14.31,0,0,1-.71-2.36c-.23-.81-.4-1.7-.64-2.5,0-.1.12-.34.19-.21S26.63,263.21,26.64,263.24Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,275.8a37,37,0,0,0,3.76,6.62A55.87,55.87,0,0,1,38,288.93a12.94,12.94,0,0,1,.71,1.88,6.77,6.77,0,0,1,.18.92,3.55,3.55,0,0,1,0,.64,2,2,0,0,1-.12.63c-.09.22-.29.46-.46.13a5.76,5.76,0,0,1-.37-1.06c-.12-.39-.16-.69-.31-1.15a14.79,14.79,0,0,0-.58-1.58,32.84,32.84,0,0,0-1.69-3.21C34,284,32.52,282,31.31,279.8a20.77,20.77,0,0,1-1.41-3.86c0-.07.08-.24.12-.14S30.05,275.82,30,275.8Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.23,322.2c-2.23.18-4.3.22-6.33-1a16.41,16.41,0,0,1-5.21-4.95c-2.95-4.42-5.1-9.32-8.15-13.66a13.19,13.19,0,0,0-2.73-2.7,21.92,21.92,0,0,0-3.62-2c-.27-.14,0-.4.23-.29A25.42,25.42,0,0,1,28,306.65c1.61,2.53,2.76,5.3,4.41,7.78A25.9,25.9,0,0,0,37.25,320a7.57,7.57,0,0,0,3.18,1.49,12.59,12.59,0,0,0,3.51.18c.35,0,.79.54.29.58Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1,312.79c-.54-.89-1.12-1.83-1.69-2.69a26,26,0,0,0-1.76-2.54,31.83,31.83,0,0,0-3.84-4.25,24.4,24.4,0,0,0-9.28-4.82c-2.42-.66-4.84-.41-7.29-.66-.2,0,0-.22.08-.23a27.81,27.81,0,0,1,6.46.14,18.88,18.88,0,0,1,5.38,1.62c3.38,1.75,5.91,4.37,8.49,7.18a16.94,16.94,0,0,1,1.91,2.88c.58,1,1.07,2.25,1.57,3.33,0,0,0,.06,0,0Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,320.07a8.88,8.88,0,0,0-.83-2.25c-.41-.71-.82-1.59-1.29-2.36a39.8,39.8,0,0,0-3-4.58,64.59,64.59,0,0,0-7.19-7.23,25.57,25.57,0,0,0-2.36-1.7,25.89,25.89,0,0,0-2.45-1.41s0-.08.05-.07a33.58,33.58,0,0,1,4.3,2.29A34.21,34.21,0,0,1,34.49,306a44.11,44.11,0,0,1,6.87,8.51,22.88,22.88,0,0,1,1.39,2.75,7.61,7.61,0,0,1,.71,2.74c0,.25-.4.33-.46.07Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,325.72a38.09,38.09,0,0,1,.7,9.92c-.09,1.75-.51,3.35-.58,5s-.09,3.24,0,4.86c0,.9.11,1.67.18,2.56s.23,1.82.28,2.73c0,.29-.29.49-.51.55s-.33,0-.49-.07a.35.35,0,0,1-.23-.31c0-.12.06.14,0,.06a1.45,1.45,0,0,1-.1-.24c0-.12-.06-.18-.11-.37a6.38,6.38,0,0,1-.16-.68c0-.31-.12-.78-.15-1.19-.08-.74-.2-1.5-.25-2.3-.1-1.64-.13-3.34-.08-5a36.72,36.72,0,0,1,.73-4.95c.28-1.67.57-3.34.69-5.07a26.71,26.71,0,0,0-.26-5.28c0-.17.31-.44.35-.23S57,325.75,56.87,325.72Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,312.37a30.4,30.4,0,0,1-1.57,5.05A20.31,20.31,0,0,0,54,322.54a29.13,29.13,0,0,0,1.15,10.25c.3,1.11.86,2.17,1.09,3.28a9.89,9.89,0,0,1,.44,3.27c0,.53-.91.36-1,0-.31-1-.43-2-.69-3s-.65-1.92-.92-2.88a27.17,27.17,0,0,1-1.16-5.09,20.05,20.05,0,0,1,.12-5.19,24.09,24.09,0,0,1,1.6-5.05c.37-.95.9-1.84,1.29-2.78a24.72,24.72,0,0,0,1-2.89s.14-.15.12-.05S57,312.34,57,312.37Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,312.33a21.41,21.41,0,0,0,.53,2.72c.26.9.67,1.79,1,2.69a44.18,44.18,0,0,1,2.11,5.87A23.82,23.82,0,0,1,60,335.52a9.44,9.44,0,0,1-1.74,2.71,12.12,12.12,0,0,0-1.71,2.69c-.14.33-.75.43-.74,0a4.33,4.33,0,0,1,1.07-2.41,15.24,15.24,0,0,0,1.72-2.33,19.21,19.21,0,0,0,1.72-5.59,19.45,19.45,0,0,0-.37-6.12,59.85,59.85,0,0,0-1.89-6c-.33-1-.74-2-1-3a9.84,9.84,0,0,1-.23-3c0-.09.2-.24.22-.09S57,312.31,57,312.33Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1,358.8a12.66,12.66,0,0,1,1.25,1.29,14.11,14.11,0,0,1,.91,1.32c.57.85,1,1.74,1.6,2.56a23,23,0,0,0,3.64,4.25,25.35,25.35,0,0,0,9,4.4,28.07,28.07,0,0,0,3,.39,6.91,6.91,0,0,1,3.06,1c.45.35-.06.66-.49.58s-1-.27-1.43-.38-1-.16-1.44-.23c-.93-.14-1.93-.14-2.84-.35A24,24,0,0,1,61.22,372a19.15,19.15,0,0,1-4.4-2.95,24.85,24.85,0,0,1-3.5-4.21c-.66-.94-1.16-2-1.77-3-.28-.46-.55-.93-.85-1.4s-.6-1-.88-1.43c-.09-.15.16-.34.28-.24S50.09,358.79,50.1,358.8Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.24,356.8a15.87,15.87,0,0,0,2.14,1.42,11,11,0,0,0,2.21.78c1.54.37,3.14.41,4.66.67a14.78,14.78,0,0,1,4.38,1.17,13.64,13.64,0,0,1,3.54,2.5,15.55,15.55,0,0,1,3,4.06c.27.53-.47.71-.84.39a8.22,8.22,0,0,1-1-1.17c-.31-.38-.39-.57-.76-1a12.44,12.44,0,0,0-1.32-1.5,14.76,14.76,0,0,0-3.1-2.2,18.87,18.87,0,0,0-4.29-1.36c-1.47-.33-3.08-.57-4.58-.95a12.41,12.41,0,0,1-2.29-.87,5.63,5.63,0,0,1-1-.68c-.26-.19-.28-.31-.46-.49s-.33-.37-.47-.53.07-.34.18-.25S47.22,356.78,47.24,356.8Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.27,364.13a40.09,40.09,0,0,1,6.29,1.92,26,26,0,0,1,3,1.43c.9.5,1.56,1,2.35,1.51a8.06,8.06,0,0,1,1.1.86,1.74,1.74,0,0,1,.68.9c.1.41-.49.45-.72.34a9.94,9.94,0,0,1-1.76-1.31,16.68,16.68,0,0,0-1.43-1,24.75,24.75,0,0,0-3-1.74c-2.16-1-4.36-1.86-6.55-2.8,0,0,0-.07,0-.06S56.27,364.12,56.27,364.13Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.92,342.73a3.72,3.72,0,0,1,.75,1.08,6.76,6.76,0,0,1,.34,1.31,14.85,14.85,0,0,1,.11,2.59c-.16,1.84-.58,3.63-.91,5.45-.66,3.72-1.46,7.28-1.31,11.1.09,2.09,1.23,3.87,2,5.76.25.56-.6.71-.83.29a17.3,17.3,0,0,1-2.25-10.44c.37-3.79,1.6-7.29,2.14-11a15.62,15.62,0,0,0,.13-3.06,8.42,8.42,0,0,0-.22-1.38,14.77,14.77,0,0,1-.26-1.48c0-.12.11-.34.27-.19S68.91,342.73,68.92,342.73Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,354.71a9.51,9.51,0,0,1,.42,1.65,10.7,10.7,0,0,1,.07,1.7c0,1.15-.11,2.29-.21,3.43-.21,2.34-.42,4.68-.45,7a16.35,16.35,0,0,0,.16,2,8.34,8.34,0,0,1,.31,1.94c-.1.61-.64.58-.95.13a3.82,3.82,0,0,1-.44-1.65,10.15,10.15,0,0,1-.09-1.65,31.2,31.2,0,0,1,.29-3.48c.32-2.4.66-4.79.88-7.19a15,15,0,0,0,0-1.9c0-.63-.07-1.25-.12-1.86,0-.06.11-.2.14-.12S72.68,354.69,72.69,354.71Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.94,342.72A37.06,37.06,0,0,1,75.2,353.6a25.92,25.92,0,0,1,1.18,6.64,45.71,45.71,0,0,1-.33,7.18c-.26,2.89-.56,5.85-1,8.73-.08.57-1,.5-1-.06.08-2.54.55-5.21.72-7.7a49.8,49.8,0,0,0,.43-7.28,40.9,40.9,0,0,0-3-12.47A34.9,34.9,0,0,0,68.72,343c-.09-.13.12-.36.22-.23S69,342.72,68.94,342.72Z",
    style: {
      fill: "#845EC2"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flowers--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.86,397.77a23.45,23.45,0,0,0,14-7.69,44.47,44.47,0,0,0,8.14-15c2.11-6.14,3.76-10.32,7-13.48-15.63-3.76-33.5-.46-43.24,12.33-3.2,4.2-2.16,11.94-1.62,17.33a6.06,6.06,0,0,0,1.52,3.91,11.05,11.05,0,0,0,4.86,2.14A23.33,23.33,0,0,0,452.86,397.77Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.86,397.77a23.45,23.45,0,0,0,14-7.69,44.47,44.47,0,0,0,8.14-15c2.11-6.14,3.76-10.32,7-13.48-15.63-3.76-33.5-.46-43.24,12.33-3.2,4.2-2.16,11.94-1.62,17.33a6.06,6.06,0,0,0,1.52,3.91,11.05,11.05,0,0,0,4.86,2.14A23.33,23.33,0,0,0,452.86,397.77Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.82,364.48a19.49,19.49,0,0,0-5.51,1.91,43.11,43.11,0,0,0-4.73,2.55,48,48,0,0,0-15.35,15.29c-1.85,3-3.89,6.46-4.5,9.95,0,.2.27.81.48.45.9-1.53,1.49-3.27,2.28-4.86a45.85,45.85,0,0,1,2.76-4.82,50.11,50.11,0,0,1,7-8.51,51.14,51.14,0,0,1,8.26-6.55c1.47-.93,3-1.78,4.54-2.56s3.33-1.37,4.83-2.31C471,364.93,471.08,364.45,470.82,364.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowers--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.15,400.92c4.28,2.29,9.77,4,15.64-.33s7.67-3.09,7.67-3.09a16.26,16.26,0,0,0-14.8-5.39C441.38,393.13,439.15,400.92,439.15,400.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.33,396.44c-1.58,0-3.15-.27-4.75-.22a23.09,23.09,0,0,0-4.75.63,26.76,26.76,0,0,0-4.6,1.55,33.67,33.67,0,0,1-4.13,1.93c-.06,0-.26,0-.18-.13,1-1.18,2.76-1.84,4.16-2.44a26.76,26.76,0,0,1,4.61-1.52,22.43,22.43,0,0,1,4.69-.56,11.94,11.94,0,0,1,5,.74S459.35,396.44,459.33,396.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.59,401.87c1,4.74,3.29,10,10.41,11.68s7.33,3.83,7.33,3.83a16.26,16.26,0,0,0-5.52-14.76C447,398.51,439.59,401.87,439.59,401.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.11,414.31c-1-1.2-1.85-2.57-2.92-3.76a23.6,23.6,0,0,0-3.57-3.2,25.72,25.72,0,0,0-4.16-2.49,35.37,35.37,0,0,1-4.15-1.89c-.05,0-.14-.23,0-.22a11.5,11.5,0,0,1,4.56,1.58,26.91,26.91,0,0,1,4.14,2.52,22.94,22.94,0,0,1,3.48,3.2,12,12,0,0,1,2.66,4.25S456.12,414.32,456.11,414.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.71,389.92c-5.62-4.28,2-11.83,6.61-13.28,2.95-.93,6.38-1.2,9.05.62,1.13.78,2.44,2.48,1.89,3.94,2,.55,4.62,2.23,3.6,4.65-.85,2-2.79,2.14-4.35,3.2,2.6,1.47-.75,3.26-2.25,3.75a13.81,13.81,0,0,1-7.67.24A19.68,19.68,0,0,1,430.71,389.92Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.71,389.92c-5.62-4.28,2-11.83,6.61-13.28,2.95-.93,6.38-1.2,9.05.62,1.13.78,2.44,2.48,1.89,3.94,2,.55,4.62,2.23,3.6,4.65-.85,2-2.79,2.14-4.35,3.2,2.6,1.47-.75,3.26-2.25,3.75a13.81,13.81,0,0,1-7.67.24A19.68,19.68,0,0,1,430.71,389.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,376c-1.54,1.71-4.14,6-3.22,8.46.73,2,6.36-2.49,7.17-3.3.58-.58,6.52-6.64,3.85-6.89.19-.65,1.06-1.19.67-2s-2-.38-2.72-.16A13.46,13.46,0,0,0,432,376Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,376c-1.54,1.71-4.14,6-3.22,8.46.73,2,6.36-2.49,7.17-3.3.58-.58,6.52-6.64,3.85-6.89.19-.65,1.06-1.19.67-2s-2-.38-2.72-.16A13.46,13.46,0,0,0,432,376Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.94,384.78c1.2,1.16,6.23-2.82,7-3.58a28.8,28.8,0,0,0,4.19-5.17,16.42,16.42,0,0,0-2.8.61C434.29,377.6,430,381.2,428.94,384.78Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,366.41a.7.7,0,0,1-.23.22c-.24.17-.6-.06-.85.07a1.72,1.72,0,0,0-.89,1c-.84,1.86-.15,5.17.47,7,1,3,2.66,7.16,5,9.41,2.52,2.42,4.47-.4,6.16-2.33a21.49,21.49,0,0,0,3.55-5.8,12.42,12.42,0,0,0,1-6.55,2.53,2.53,0,0,0-4.14-1.74,7,7,0,0,0-5.79-4.11,4.35,4.35,0,0,0-4,2.15C422.09,366.09,422.15,366.24,422,366.41Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,366.41a.7.7,0,0,1-.23.22c-.24.17-.6-.06-.85.07a1.72,1.72,0,0,0-.89,1c-.84,1.86-.15,5.17.47,7,1,3,2.66,7.16,5,9.41,2.52,2.42,4.47-.4,6.16-2.33a21.49,21.49,0,0,0,3.55-5.8,12.42,12.42,0,0,0,1-6.55,2.53,2.53,0,0,0-4.14-1.74,7,7,0,0,0-5.79-4.11,4.35,4.35,0,0,0-4,2.15C422.09,366.09,422.15,366.24,422,366.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,372.77A14.62,14.62,0,0,0,432,376c-1.54,1.71-4.14,6-3.22,8.46a1.4,1.4,0,0,0,.1.16,14.41,14.41,0,0,0,2.84-2.84,21.49,21.49,0,0,0,3.55-5.8A16.25,16.25,0,0,0,436.22,372.77Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,376.36c-1.35.48-3.23.34-3.53,2.2-.21,1.27.47,1.92,1.28,2.73,2.68,2.71,6.1,3.91,9.82,4.55,1.47.25,3.2.75,4.68.45,4.29-.87-3.23-8-4.51-9.14C419.78,375.79,412.09,370.89,413.58,376.36Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,376.36c-1.35.48-3.23.34-3.53,2.2-.21,1.27.47,1.92,1.28,2.73,2.68,2.71,6.1,3.91,9.82,4.55,1.47.25,3.2.75,4.68.45,4.29-.87-3.23-8-4.51-9.14C419.78,375.79,412.09,370.89,413.58,376.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.43,377.24a20.05,20.05,0,0,0,4.11,6.91,3,3,0,0,0,1.59.89C427.26,382.78,422.64,378.33,421.43,377.24Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.23,398.49a21.15,21.15,0,0,0,2.49-3.83c.94-1.8,2.48-4,2.32-6.11-.27-3.53-4.42-5.08-7.31-5.71s-7.34-.81-10,1a3.6,3.6,0,0,0-1.88,3.63c.18,1.74.22,1.17-.86,2.38a4.41,4.41,0,0,0-.86,3.92c.66,2.18,2.41,2.31,4,3.38-.81.68,0,1.49.81,1.49.32,5,6.58,3.78,9.34,1.74A11.74,11.74,0,0,0,422.23,398.49Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.23,398.49a21.15,21.15,0,0,0,2.49-3.83c.94-1.8,2.48-4,2.32-6.11-.27-3.53-4.42-5.08-7.31-5.71s-7.34-.81-10,1a3.6,3.6,0,0,0-1.88,3.63c.18,1.74.22,1.17-.86,2.38a4.41,4.41,0,0,0-.86,3.92c.66,2.18,2.41,2.31,4,3.38-.81.68,0,1.49.81,1.49.32,5,6.58,3.78,9.34,1.74A11.74,11.74,0,0,0,422.23,398.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.83,386.29l.32-.09c-1.43-1.91-4.27-2.89-6.42-3.36a18.64,18.64,0,0,0-6.86-.23,18.79,18.79,0,0,0,8.28,3.23C422.62,386.09,424.35,386.59,425.83,386.29Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.76,393.08a13.26,13.26,0,0,0-2.75,5.54c-.26,1.5.38,2.16.72,3.41.39,1.43-1.32,5,1,5.63,1.87.53,4.05-1.91,5-3.13a18.23,18.23,0,0,0,3-5.47,21.64,21.64,0,0,0,.74-6.41c0-1.38.27-3.88-1.63-3.93C424.53,388.67,422.05,391.45,420.76,393.08Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.76,393.08a13.26,13.26,0,0,0-2.75,5.54c-.26,1.5.38,2.16.72,3.41.39,1.43-1.32,5,1,5.63,1.87.53,4.05-1.91,5-3.13a18.23,18.23,0,0,0,3-5.47,21.64,21.64,0,0,0,.74-6.41c0-1.38.27-3.88-1.63-3.93C424.53,388.67,422.05,391.45,420.76,393.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.28,400.33a11.74,11.74,0,0,0,2-1.84,21.15,21.15,0,0,0,2.49-3.83c.91-1.74,2.37-3.9,2.32-5.91l-.21,0c-2.3-.05-4.78,2.73-6.07,4.36a13.26,13.26,0,0,0-2.75,5.54,4.32,4.32,0,0,0,.48,2.7A8.42,8.42,0,0,0,420.28,400.33Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.62,398.28c-.33-2.76-.76-11.7,4.29-9.79a13.16,13.16,0,0,1,4.88,3.46c2.71,3,5.78,7.26,6,11.38.08,1.29.05,3.6-1.44,4.16-.89.34-1.68-.34-2.54,0-1.1.4-1.61,1.41-3,1.05a5,5,0,0,1-2.45-2.45C427.89,407.23,427,401.41,426.62,398.28Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.62,398.28c-.33-2.76-.76-11.7,4.29-9.79a13.16,13.16,0,0,1,4.88,3.46c2.71,3,5.78,7.26,6,11.38.08,1.29.05,3.6-1.44,4.16-.89.34-1.68-.34-2.54,0-1.1.4-1.61,1.41-3,1.05a5,5,0,0,1-2.45-2.45C427.89,407.23,427,401.41,426.62,398.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.62,398.28c.08.73.2,1.62.39,2.53.26-.58.51-1.16.71-1.75a21.64,21.64,0,0,0,.74-6.41c0-1.07.16-2.8-.65-3.56C426.1,391.15,426.38,396.3,426.62,398.28Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.21,388a19.39,19.39,0,0,1,7.9,2.08c2.68,1.38,5.68,3.49,6.47,6.52.63,2.39,0,2.95-2.1,2.81.87,2.11-2.93,1.12-3.77.92A18.19,18.19,0,0,1,431,393.67c-1-1.31-3.38-5.18-.52-5.54A15.14,15.14,0,0,1,433.21,388Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.21,388a19.39,19.39,0,0,1,7.9,2.08c2.68,1.38,5.68,3.49,6.47,6.52.63,2.39,0,2.95-2.1,2.81.87,2.11-2.93,1.12-3.77.92A18.19,18.19,0,0,1,431,393.67c-1-1.31-3.38-5.18-.52-5.54A15.14,15.14,0,0,1,433.21,388Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.59,393a13.84,13.84,0,0,0,7.55-.21,18,18,0,0,0-4-2.73,19.39,19.39,0,0,0-7.9-2.08,15.14,15.14,0,0,0-2.7.11,1.58,1.58,0,0,0-1.06.49,5.31,5.31,0,0,0,1.26,1.3A19.68,19.68,0,0,0,437.59,393Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.14,400.19a26,26,0,0,0-5.35-8.24,13.16,13.16,0,0,0-4.88-3.46,3.85,3.85,0,0,0-.91-.24c-2,.76.12,4.2,1,5.42A18.05,18.05,0,0,0,441.14,400.19Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.88,384.83c1.12-.11,2.23-.27,3.35-.4a7.35,7.35,0,0,0,1.57-.24c.2-.06,1.09-.1.85.32a.41.41,0,0,1-.12.11,5.08,5.08,0,0,1-2.07.57c-1.37.21-2.73.47-4.09.74a10.83,10.83,0,0,0-2,.38c-.41.17-.42.37.09.45a6.7,6.7,0,0,0,1.1.07c.33,0,.62.09.95.07a.62.62,0,0,1,.46.11l.05.06c0,.08-.06.14-.13.18a2.55,2.55,0,0,1-1.06.18l-1.6.08c-.27,0-.81,0-1,.16-.71.58,2,.91,2.29.94a11.42,11.42,0,0,1,3.71,1,.79.79,0,0,1,.43.55.24.24,0,0,1,0,.19c-.08.11-.25.1-.38.07-.52-.12-1-.34-1.53-.44s-.9-.21-1.34-.32a5,5,0,0,0-2.66-.1c.54,1.22,2.28,2.17,3.25,3.1a7.67,7.67,0,0,1,2,2.42c.11.29-.19.27-.37.22a1.48,1.48,0,0,1-.54-.35c-.43-.36-.83-.75-1.24-1.13a20.11,20.11,0,0,0-2.52-2.18c-1.89-1.29-1.53.08-1.33,1.58.1.79.24,1.57.32,2.36a4.51,4.51,0,0,1-.16,2.39.59.59,0,0,1-.17.24.26.26,0,0,1-.29,0,.36.36,0,0,1-.09-.29,19.35,19.35,0,0,0-.32-3,14.56,14.56,0,0,0-.78-3.47c-.14-.29-.54-1.09-1-1s-.54,1-.6,1.39c-.13.75-.25,1.54-.32,2.3a.29.29,0,0,1-.1.25c-.39-.27-.24-1-.2-1.47,0-.28.05-.56.06-.84a3.39,3.39,0,0,1,0-.78c-.89,1.31-.95,3.27-1.6,4.73a8,8,0,0,1-.81,1.63c-.32.42-.59.94-1.1,1.16-.06,0-.15,0-.17,0a.13.13,0,0,1,0-.06,7.8,7.8,0,0,1,.45-1,17.79,17.79,0,0,0,1-3.19,12.7,12.7,0,0,0,.6-3.55c-.68.22-1.27,1.23-1.74,1.77-.73.84-1.41,1.7-2.07,2.6a.52.52,0,0,1-.18.18.32.32,0,0,1-.38-.17.72.72,0,0,1-.05-.46c.15-1.23,1.17-2.11,2-2.9.5-.46,1.2-.9,1.44-1.56a3.68,3.68,0,0,0-1.36.7,28.09,28.09,0,0,1-3,1.35c-.75.31-1.46.69-2.18,1.06s-1.44.63-2.14,1a3,3,0,0,1-.55.25.33.33,0,0,1-.31,0,.34.34,0,0,1-.09-.28c.05-1.12,1.53-1.74,2.38-2.2,1-.55,2.07-1,3.11-1.51.66-.32,3.09-1,3.12-1.87-1.17-.3-2.82.26-4,.49-.57.11-1.12.3-1.68.46a4.27,4.27,0,0,1-1.75.32A.32.32,0,0,1,416,390a.4.4,0,0,1,.08-.39c.38-.52,1-.53,1.6-.72a36.43,36.43,0,0,1,3.53-1,6.64,6.64,0,0,0,1.85-.49c-.73-.61-2.17-.48-3.08-.54a9.69,9.69,0,0,1-2.85-.27.81.81,0,0,1-.41-.32.2.2,0,0,1,0-.11c0-.07.07-.13.13-.18,1-.68,2.31-.41,3.45-.38.91,0,2.33.72,3.18.24s0-1.24-.62-1.71a27.18,27.18,0,0,0-2.71-1.81c-.36-.22-.73-.42-1.09-.63s-.89-.43-1-.79a.35.35,0,0,1,.37-.44,3.93,3.93,0,0,1,2,.73c.57.33,1.11.71,1.66,1.06s1.56,1.33,2.22,1.17c.89-.2.22-1.7.12-2.41-.17-1.32-.38-2.63-.48-4,0-.61-.32-1.22.09-1.79.09-.12.24-.22.37-.16s.13.23.14.37a5.59,5.59,0,0,0,.23,1.22c.09.4.1.82.16,1.23s.16,2.95.58,3.23c.81.52,1.07-2.89,1.19-3.38.19-.82.35-1.65.56-2.47a2.76,2.76,0,0,1,1-1.82.19.19,0,0,1,.1-.05c.1,0,.13.14.13.24a4.29,4.29,0,0,1-.15.78,38.45,38.45,0,0,0-.81,4.12,5.64,5.64,0,0,0,0,2.8c.48.94,1.3-.65,1.63-1s.67-.88,1-1.29c.14-.15.78-.9,1-.6s-.38.83-.48,1c-.26.4-.51.8-.74,1.21s-1,1.43-.67,1.89.95-.17,1.22-.31a13.29,13.29,0,0,0,1.35-.91,5.82,5.82,0,0,1,2.26-1.14c.17,0,.38,0,.47.12a.07.07,0,0,1,0,.06.1.1,0,0,1,0,.07c-.5.42-1.13.68-1.63,1.1a8.25,8.25,0,0,0-1.42,1.59c-.1.14-.19.34-.08.47s.93,0,1.2,0,.56-.1.84-.17c.87-.21,1.75-.5,2.62-.62.31,0,.89-.34,1.16-.11a.12.12,0,0,1,0,.21,5.39,5.39,0,0,1-2.08.74,13.22,13.22,0,0,0-1.94.61c-.35.17-.88.6-.2.75a6.39,6.39,0,0,0,1.63-.07Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.83,385.61a.5.5,0,0,1,0-.13c.14-.31.55-.3.69-.65.07-.15,0-.39.25-.41s.23.14.39.1a1,1,0,0,0,.59-.59c0-.17,0-.28.16-.33s.54.21.74.29c.52.19.75-.31,1.22-.3.2,0,.17.19.28.3s.26,0,.45,0,.2.2.26.35.11.22.32.26.44-.27.73-.22c0,.22,0,.83.22,1s.28-.09.43,0c0,.3-.26.57,0,.87a.5.5,0,0,0,.7.05,1.24,1.24,0,0,1-.13.62c-.08.18-.38.51-.21.73s.43,0,.26.51c-.08.22-.36.41-.36.66s.07.12.15.26c.33.53-.37.46-.53.79s.25.67-.29.9c-.12.06-.26,0-.37.08s-.18.43-.19.59.09.19-.05.26-.43-.15-.59-.13a.81.81,0,0,0-.43.33c-.13.18-.06.23-.11.43a3,3,0,0,0-.85-.27c-.26,0-.25.32-.49.37-.19-.21.09-.66-.27-.68s-.56.37-.84.41a.65.65,0,0,0-.15-.6c-.27-.25-.45-.06-.72.13-.57.39-.26-.17-.34-.49a.7.7,0,0,0-.3-.43,1.09,1.09,0,0,0-.33-.19c-.25-.05-.33.19-.56.16,0-.32.34-.6.22-1a.88.88,0,0,0-.39-.42c-.28-.2-.26-.25-.26-.58a1.61,1.61,0,0,0,0-.31c0-.07-.11-.1-.1-.18s.16-.2.21-.28c.14-.26,0-.46,0-.73s.07-.39.25-.6A2.19,2.19,0,0,0,423.83,385.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.59,382.44a7.35,7.35,0,0,0,.11.82,1.45,1.45,0,0,1-.11.62c-.08.22-.18.42-.27.63a2.36,2.36,0,0,0-.24.78c0,.07.07.11.13.12a.23.23,0,0,0,.19-.1,4.45,4.45,0,0,0,.45-.79,3.79,3.79,0,0,0,.26-.71,1.52,1.52,0,0,0,.05-.7,2.5,2.5,0,0,0-.18-.48,1,1,0,0,1-.09-.24c0-.16-.3-.1-.3.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.05,382.36a1.72,1.72,0,0,0,.25,1,9.09,9.09,0,0,1,.47.87,2.58,2.58,0,0,1,.22.94,1.6,1.6,0,0,1,0,.44c0,.18-.12.35-.16.53s.21.16.3.08a1.61,1.61,0,0,0,.32-1.26,3,3,0,0,0-.24-.88,3.63,3.63,0,0,0-.5-.79,1.91,1.91,0,0,1-.49-.89c0-.05-.13-.1-.13,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,382.74a2.17,2.17,0,0,0,.79.68,2.5,2.5,0,0,1,.72.73c.17.28.32.57.47.86s.28.67.56.64a.23.23,0,0,0,.2-.19,1.63,1.63,0,0,0-.23-.6l-.21-.41a5.37,5.37,0,0,0-.43-.73,2.13,2.13,0,0,0-.55-.57c-.34-.22-.87-.15-1.14-.47,0-.06-.25,0-.18.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.33,383.9a2.41,2.41,0,0,0,.12.64,1.64,1.64,0,0,0,.24.52,3.31,3.31,0,0,0,.49.5l.29.26a.52.52,0,0,0,.11.1.28.28,0,0,0,.2.05.13.13,0,0,0,.14-.1s0,0,0-.06a.24.24,0,0,0,0-.09.81.81,0,0,0-.12-.18,2.35,2.35,0,0,0-.29-.26,2.9,2.9,0,0,1-.51-.48,1.5,1.5,0,0,1-.22-.46.92.92,0,0,0-.24-.47s-.2-.07-.2,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.15,384.11c-.18.36.14.7.4.92s.83.63,1.23,1c.21.17.39.37.6.53a.32.32,0,0,0,.33.08.24.24,0,0,0,.15-.22c0-.25-.35-.48-.53-.63s-.43-.35-.66-.52a4.56,4.56,0,0,0-.67-.4c-.31-.14-.76-.31-.79-.69,0,0,0-.06-.06,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,384.71a1.55,1.55,0,0,0,.72.69,6,6,0,0,1,.91.6c.52.46.88,1.07,1.41,1.51a.21.21,0,0,0,.31-.24,5.09,5.09,0,0,0-1.27-1.61,2.67,2.67,0,0,0-.85-.56c-.18-.06-.37-.08-.56-.14a1.82,1.82,0,0,1-.55-.29s-.15,0-.12,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.58,386.35a.92.92,0,0,1,.39.11l.41.18a2.4,2.4,0,0,0,.38.12l.22,0a.53.53,0,0,0,.36-.11.15.15,0,0,0,.07-.14c0-.06,0-.08-.09-.11a.59.59,0,0,0-.3,0l-.17,0-.36-.1-.34-.08a1.72,1.72,0,0,0-.6,0c-.13,0-.11.18,0,.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.74,387.16c.47.55,1.18.44,1.82.34a3,3,0,0,1,.94-.05,1.09,1.09,0,0,1,.39.15l.18.12a.75.75,0,0,0,.17.1.42.42,0,0,0,.16,0c.05,0,.13,0,.13-.1,0-.44-.48-.7-.85-.77a2.13,2.13,0,0,0-.94.06c-.6.14-1.3.45-1.88.09-.05,0-.19,0-.12.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.81,388.45a.7.7,0,0,1,.46-.31,1.18,1.18,0,0,1,.52.1,4.9,4.9,0,0,1,.52.24,1,1,0,0,0,.59.22c.11,0,.22-.12.15-.22a.64.64,0,0,0-.29-.22l-.29-.14a2.63,2.63,0,0,0-.59-.22,1.33,1.33,0,0,0-.74,0,.9.9,0,0,0-.3.17.8.8,0,0,0-.18.27c0,.06.11.13.15.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.83,389.32a2.49,2.49,0,0,0,1.51-.72,2.4,2.4,0,0,1,.73-.41,1,1,0,0,1,.29-.05,1.1,1.1,0,0,0,.51,0A.15.15,0,0,0,425,388c-.08-.32-.57-.3-.82-.24a2,2,0,0,0-.78.41c-.28.22-.54.46-.82.66a1.38,1.38,0,0,1-.74.3c-.14,0-.1.17,0,.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.05,390.52c.12,0,.18-.11.26-.2a3.89,3.89,0,0,1,.34-.36,1.16,1.16,0,0,1,.89-.29,2.46,2.46,0,0,0,1-.07,1.85,1.85,0,0,0,.85-.63.16.16,0,0,0-.18-.24,1.06,1.06,0,0,0-.46.26,1.09,1.09,0,0,1-.41.22,5.11,5.11,0,0,1-1,.07,1.74,1.74,0,0,0-.93.48,2.38,2.38,0,0,0-.32.38c-.06.1-.19.24-.11.36l0,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.32,391a5.5,5.5,0,0,0,.79-.54,3.11,3.11,0,0,0,.41-.4,1.45,1.45,0,0,0,.26-.43.15.15,0,0,0-.09-.15h-.14l-.06,0c-.05,0-.17.22-.2.27l-.13.18-.28.3a6.94,6.94,0,0,1-.72.6c-.09.08.09.17.16.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.12,392.16c0-.14.06-.29.09-.44a1,1,0,0,1,.12-.32,2.23,2.23,0,0,1,.49-.61,3,3,0,0,0,1.05-1.5.17.17,0,0,0-.18-.19.28.28,0,0,0-.24.19,4.54,4.54,0,0,1-1,1.4,3.16,3.16,0,0,0-.46.74.92.92,0,0,0-.09.37.69.69,0,0,0,.09.34s.1.08.11,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.75,392c0-.2.19-.29.37-.36a1.77,1.77,0,0,0,.47-.25A1.71,1.71,0,0,0,426,391a1.49,1.49,0,0,0,.29-.46c.05-.17-.13-.24-.26-.17s-.29.36-.42.52a1.66,1.66,0,0,1-.41.38,3.7,3.7,0,0,0-.46.31.6.6,0,0,0-.19.37c0,.11.21.14.23,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.23,393.22c.18-.62.8-.85,1.19-1.3a2.65,2.65,0,0,0,.57-1.37,1.94,1.94,0,0,0,0-.68.19.19,0,0,0-.26-.16.29.29,0,0,0-.18.33,2.58,2.58,0,0,1-.23,1.4c-.33.67-1.2.95-1.31,1.74,0,.11.19.14.22,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.91,393.12c-.05-.84.86-1.4.74-2.27,0-.09-.15-.11-.22-.09a.22.22,0,0,0-.17.21,1.39,1.39,0,0,1-.07.53c-.06.18-.15.36-.23.54a3,3,0,0,0-.18.5,1.51,1.51,0,0,0,0,.56c0,.06.15.1.15,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.08,392.28a1,1,0,0,1-.56-.39,6.55,6.55,0,0,1-.32-.58,3.76,3.76,0,0,0-.31-.5c-.13-.17-.31-.37-.54-.35a.24.24,0,0,0-.19.36l0-.09a.09.09,0,0,0,0,.07.64.64,0,0,0,.16.17l.1.09c.06.06.11.13.16.19s.23.37.34.55a1.75,1.75,0,0,0,.42.48,1.14,1.14,0,0,0,.66.22c.14,0,.27-.17.09-.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.2,392.48a1.41,1.41,0,0,0-.42-1,5,5,0,0,0-1.13-.91c-.14-.09-.27-.22-.42-.3a.27.27,0,0,0-.4.07.3.3,0,0,0,.09.33,2,2,0,0,0,.49.38l.51.32c.44.27,1,.55,1.06,1.13,0,.1.21.11.22,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.28,390.71a.54.54,0,0,1-.48,0,2.53,2.53,0,0,1-.37-.18,6.87,6.87,0,0,1-.62-.48,2.25,2.25,0,0,0-1.38-.7c-.13,0-.37.22-.18.34s.59.28.87.46.53.39.81.56a1.61,1.61,0,0,0,.7.26,1.21,1.21,0,0,0,.77-.17c.08-.06,0-.14-.12-.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.94,389.46a1,1,0,0,1-.32.18.72.72,0,0,1-.45-.11l-.77-.32a1.68,1.68,0,0,0-.83-.14,2.38,2.38,0,0,0-.38.11l-.14.05a.44.44,0,0,0-.15.08.57.57,0,0,0-.11.11.09.09,0,0,0,0,.11c.13.34.58.14.83.09a1.89,1.89,0,0,1,.93.21,1.79,1.79,0,0,0,.86,0,1.23,1.23,0,0,0,.68-.32c.06-.06-.07-.13-.13-.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.29,388.42a1.24,1.24,0,0,0-.85,0,4.91,4.91,0,0,0-.74.24,2,2,0,0,1-.34.12l-.13.05-.09,0c-.07,0,.05,0,0,0a1.43,1.43,0,0,1-.29,0h-.09a.87.87,0,0,0-.36,0c-.11,0-.2.18-.13.28a.78.78,0,0,0,.83.22,2.8,2.8,0,0,0,.73-.27c.28-.13.54-.3.83-.42a1.52,1.52,0,0,1,.6-.1c.08,0,.13-.09.05-.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.17,386.77a2.14,2.14,0,0,0-.69.26,3.65,3.65,0,0,0-.67.5,2.17,2.17,0,0,1-.48.35l-.12.07h0l-.07,0-.16,0a2.67,2.67,0,0,0-.4,0c-.1,0-.22.11-.14.23a.73.73,0,0,0,.82.18,2,2,0,0,0,.67-.42,5.58,5.58,0,0,0,.56-.53,1.43,1.43,0,0,1,.78-.54c.13,0,0-.18-.07-.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.46,385a1.26,1.26,0,0,1-.15.91,2.63,2.63,0,0,1-.53.4,4,4,0,0,0-.39.29,6.22,6.22,0,0,0-.75.7,2,2,0,0,0-.57.88c0,.1.16.12.22.08a8.72,8.72,0,0,0,.79-.82c.26-.26.54-.48.82-.72a2.58,2.58,0,0,0,.71-.83,1.36,1.36,0,0,0,.06-.89c0-.09-.22-.11-.21,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.69,385a2.06,2.06,0,0,0-.6.28l-.55.37-.36.29a1.31,1.31,0,0,0-.36.38c-.06.1.13.13.19.11a1.68,1.68,0,0,0,.5-.35c.12-.1.24-.2.37-.29l.38-.26c.18-.12.37-.21.55-.33s0-.24-.12-.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.09,383.35c0,.12,0,.26-.06.38a.91.91,0,0,1-.28.46c-.19.19-.42.34-.61.53a1.74,1.74,0,0,0-.39.67,1.86,1.86,0,0,0-.1.39,3.71,3.71,0,0,0-.1.48c0,.14.21.14.28.06a3,3,0,0,0,.4-.93,1.65,1.65,0,0,1,.48-.57,1.67,1.67,0,0,0,.65-1.46c0-.12-.25-.13-.27,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.34,383.52a1.79,1.79,0,0,0-1,1.1,6.09,6.09,0,0,0-.21.73c0,.14-.05.29-.07.43a.86.86,0,0,0,0,.45c0,.1.23.06.28,0a2.4,2.4,0,0,0,.19-.8c0-.22.08-.45.14-.68a2.11,2.11,0,0,1,.27-.59,1.55,1.55,0,0,1,.24-.27,3.71,3.71,0,0,0,.29-.27s-.06-.09-.1-.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.3,393.63a.38.38,0,0,1,.51-.1.37.37,0,0,1,.1.51.36.36,0,0,1-.51.1A.37.37,0,0,1,426.3,393.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.81,388.69a.37.37,0,0,1,.51-.1.38.38,0,0,1,.1.51.37.37,0,0,1-.51.1A.36.36,0,0,1,420.81,388.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,392.59a.36.36,0,0,1,.5-.11.37.37,0,0,1,.11.51.36.36,0,0,1-.51.1A.35.35,0,0,1,428,392.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,393.12a.37.37,0,0,1,.51-.1.36.36,0,0,1,.1.51.37.37,0,0,1-.51.1A.38.38,0,0,1,430,393.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.78,391.33a.37.37,0,1,1,.1.51A.37.37,0,0,1,430.78,391.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.06,390.07a.37.37,0,0,1,.51-.1.36.36,0,0,1,.1.51.37.37,0,0,1-.51.1A.38.38,0,0,1,432.06,390.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.45,386.24a.36.36,0,0,1,.51-.1.37.37,0,0,1,.1.51.38.38,0,0,1-.51.1A.37.37,0,0,1,421.45,386.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.57,382.06a.36.36,0,1,1,.61.4.36.36,0,0,1-.61-.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.72,388.43a.37.37,0,1,1,.1.51A.37.37,0,0,1,432.72,388.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.85,387.41a.37.37,0,1,1,.1.51A.37.37,0,0,1,431.85,387.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.75,382.81a.37.37,0,0,1,.51-.11.38.38,0,0,1,.1.51.36.36,0,0,1-.51.1A.35.35,0,0,1,426.75,382.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.21,385.46a.37.37,0,1,1,.1.51A.37.37,0,0,1,432.21,385.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.12,383.92a.36.36,0,0,1,.51-.1.37.37,0,0,1-.41.61A.36.36,0,0,1,422.12,383.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.58,383.93a.37.37,0,0,1,.51-.1.36.36,0,0,1-.4.61A.37.37,0,0,1,430.58,383.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.06,392.49a.37.37,0,0,1,.51-.1.36.36,0,0,1,.1.51.37.37,0,0,1-.51.1A.38.38,0,0,1,424.06,392.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,390.78a.36.36,0,0,1,.51-.1.37.37,0,0,1,.1.51.38.38,0,0,1-.51.1A.37.37,0,0,1,422,390.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.29,382.07a.38.38,0,0,1,.51-.1.36.36,0,0,1,.1.51.35.35,0,0,1-.5.1A.37.37,0,0,1,428.29,382.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.56,415.59a7.65,7.65,0,0,0,1.91.16c1.17,0,4.69.28,6.58,2s3.88,6.21,3.4,7.88a2.52,2.52,0,0,1-3.05,1.73c-.92-.23-1.25-.37-2.07,1s-1.84.05-2.29.13-.78,1.91-2.79,1.41-3.15-3.65-3.34-6.4C430.59,419.06,432.86,416.56,432.56,415.59Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.56,415.59a7.65,7.65,0,0,0,1.91.16c1.17,0,4.69.28,6.58,2s3.88,6.21,3.4,7.88a2.52,2.52,0,0,1-3.05,1.73c-.92-.23-1.25-.37-2.07,1s-1.84.05-2.29.13-.78,1.91-2.79,1.41-3.15-3.65-3.34-6.4C430.59,419.06,432.86,416.56,432.56,415.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.17,415s1.81,1.2,3.51,2.58,6.66,4.11,8.37,3.31.06-2.54.62-3.24,1.88-.68,1.11-1.76-3.76-2-5.8-2.22a25.37,25.37,0,0,0-6.17.52C433.4,414.51,433.17,415,433.17,415Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.17,415s1.81,1.2,3.51,2.58,6.66,4.11,8.37,3.31.06-2.54.62-3.24,1.88-.68,1.11-1.76-3.76-2-5.8-2.22a25.37,25.37,0,0,0-6.17.52C433.4,414.51,433.17,415,433.17,415Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.68,417.58a20.08,20.08,0,0,0,6.61,3.33,11.13,11.13,0,0,0-2.24-3.2c-1.89-1.68-5.41-2-6.58-2h-.22C434.92,416.22,435.81,416.88,436.68,417.58Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.15,414.61a6.21,6.21,0,0,1,3.48-.15,49.22,49.22,0,0,1,5.42,1.35c1.56.53,2.64-.22,2.32-1.12s-.5-1.47-.5-1.47,1.86.57,2.59-.56a2,2,0,0,0-.09-2.39c-.25-.52.6-.63.78-1.61s-.08-2.29-1.67-4-3-1.75-3.9-1.36-1.75,1.9-2.62,2.1-2.93.12-4.32,2.11-.82,5.07-1.55,6.17S433.15,414.61,433.15,414.61Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.15,414.61a6.21,6.21,0,0,1,3.48-.15,49.22,49.22,0,0,1,5.42,1.35c1.56.53,2.64-.22,2.32-1.12s-.5-1.47-.5-1.47,1.86.57,2.59-.56a2,2,0,0,0-.09-2.39c-.25-.52.6-.63.78-1.61s-.08-2.29-1.67-4-3-1.75-3.9-1.36-1.75,1.9-2.62,2.1-2.93.12-4.32,2.11-.82,5.07-1.55,6.17S433.15,414.61,433.15,414.61Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.81,414.19a4.49,4.49,0,0,0-.6.17,6.83,6.83,0,0,1,2.42.1,49.22,49.22,0,0,1,5.42,1.35c1.56.53,2.64-.22,2.32-1.12,0-.09-.06-.17-.09-.25a17,17,0,0,0-3.3-.77A25.37,25.37,0,0,0,434.81,414.19Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.05,413.8a9.45,9.45,0,0,0,3.21-3.76c1.62-2.92,2.13-6,1.85-7.42a4.42,4.42,0,0,0-2.69-2.85c-.6,0-1.23-.71-1.77-.45s-.49,1.12-1.12,1.27-1.42-.83-2.92-.27a3.14,3.14,0,0,0-1.86,2,2.3,2.3,0,0,0-2.91.89c-.94,1.73-.26,4.28,1.59,6.24A15.33,15.33,0,0,0,433.05,413.8Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.05,413.8a9.45,9.45,0,0,0,3.21-3.76c1.62-2.92,2.13-6,1.85-7.42a4.42,4.42,0,0,0-2.69-2.85c-.6,0-1.23-.71-1.77-.45s-.49,1.12-1.12,1.27-1.42-.83-2.92-.27a3.14,3.14,0,0,0-1.86,2,2.3,2.3,0,0,0-2.91.89c-.94,1.73-.26,4.28,1.59,6.24A15.33,15.33,0,0,0,433.05,413.8Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.09,413.72l0,.08h0a9.45,9.45,0,0,0,3.21-3.76,16.18,16.18,0,0,0,1.68-4.43,4.63,4.63,0,0,0-3.3,1.94C433.24,409.54,433.82,412.62,433.09,413.72Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,414.26a12,12,0,0,0-.79-4.71c-.89-1.89-3.43-4.85-5.7-5.15s-4.1.91-3.8,4a1.73,1.73,0,0,0-1.48,1.33c-.37,1.27,1.14,2.26,1.94,2.43,0,0-.29.5,1,1.11s3.87-.47,6.32.71S431.5,414.79,431.5,414.26Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,414.26a12,12,0,0,0-.79-4.71c-.89-1.89-3.43-4.85-5.7-5.15s-4.1.91-3.8,4a1.73,1.73,0,0,0-1.48,1.33c-.37,1.27,1.14,2.26,1.94,2.43,0,0-.29.5,1,1.11s3.87-.47,6.32.71S431.5,414.79,431.5,414.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,404.4l-.54,0a6.38,6.38,0,0,0,2,5.1,17.18,17.18,0,0,0,5.05,3.73,10.13,10.13,0,0,0-.77-3.64C429.82,407.66,427.28,404.7,425,404.4Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.45,414.59a18.74,18.74,0,0,0-4-2.18c-3-1.14-6.65,0-7.5,0s-2.42,1.48-2.12,3.35,1.35,2.29,1.05,3.63.19,2,1.49,2.58.26,2.2,1.5,3,4.87-1.8,6.65-4.09A16.35,16.35,0,0,0,431.45,414.59Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.45,414.59a18.74,18.74,0,0,0-4-2.18c-3-1.14-6.65,0-7.5,0s-2.42,1.48-2.12,3.35,1.35,2.29,1.05,3.63.19,2,1.49,2.58.26,2.2,1.5,3,4.87-1.8,6.65-4.09A16.35,16.35,0,0,0,431.45,414.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,415.23c.1.52,1,1.68.93,3.08s.57,2.87.61,4.06-1.06,2-2.06,2.45-.74,1.07-1.14,2.32-1.23,2.21-2.27,1.94c-.57-.14-.58-.57-1.33-.63s-1.75.33-2-.84-.06-2.13-.74-2.88-1.48-2.58-.06-3.63,2.64-1.34,3-2.4a7.05,7.05,0,0,1,2.87-3.15C431.05,414.87,431.87,414.65,432,415.23Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,415.23c.1.52,1,1.68.93,3.08s.57,2.87.61,4.06-1.06,2-2.06,2.45-.74,1.07-1.14,2.32-1.23,2.21-2.27,1.94c-.57-.14-.58-.57-1.33-.63s-1.75.33-2-.84-.06-2.13-.74-2.88-1.48-2.58-.06-3.63,2.64-1.34,3-2.4a7.05,7.05,0,0,1,2.87-3.15C431.05,414.87,431.87,414.65,432,415.23Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.91,423.42a11,11,0,0,0,.21,1.59,1.52,1.52,0,0,1,.34-.19c1-.43,2.1-1.26,2.06-2.45s-.66-2.65-.61-4.06a4.34,4.34,0,0,0-.44-1.94C432.05,417.64,430.66,419.94,430.91,423.42Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,424.72a14.49,14.49,0,0,0,4.6-3.82,16.56,16.56,0,0,0,2.82-6,5.66,5.66,0,0,0-1.57.63,7.12,7.12,0,0,0-2.87,3.16c-.39,1.06-1.62,1.35-3,2.4S423.28,424,424,424.72Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,420c.18.48.58,1.15.39,1.67,0,.06-.07.13-.13.12a.15.15,0,0,1-.07,0,1.13,1.13,0,0,1-.29-.51,8.92,8.92,0,0,0-1-1.93c-.09-.12-.35-.53-.55-.42a.18.18,0,0,0-.06.16,4.64,4.64,0,0,1,0,1.12.14.14,0,0,1-.07.1.1.1,0,0,1-.11,0,.17.17,0,0,1,0-.12c0-.21-.12-1.79-.59-1.49a.37.37,0,0,0-.12.22c-.22,1-.28,2-.52,2.93,0,.15-.1.32-.25.37a1.91,1.91,0,0,1,0-.92q.07-.54.12-1.08a14.53,14.53,0,0,0,.12-1.61c0-.22,0-1.4-.48-1.16a.57.57,0,0,0-.23.33c-.16.45-.3.92-.49,1.36a7.47,7.47,0,0,1-1.07,1.66.18.18,0,0,1-.09.08s-.1,0-.11,0a.09.09,0,0,1,0-.07,5,5,0,0,1,.35-.83,9,9,0,0,0,.35-1c.11-.34.55-1.38-.18-1.16a1.93,1.93,0,0,0-.73.57l-.84.84-1,1.05a.66.66,0,0,1-.19.15c-.44.18-.19-.41-.09-.55s.37-.42.54-.64c.51-.67,1-1.32,1.57-2,.16-.19.46-.36.47-.65,0-.83-.95,0-1.29.12l-1.44.41c-.24.07-.49.13-.73.18s-.46,0-.56-.08.57-.39.69-.44c.34-.15.68-.29,1-.41l.85-.31c.15-.07.65-.2.67-.41a.29.29,0,0,0-.13-.22.79.79,0,0,0-.26-.08,9.81,9.81,0,0,0-2.81.06.28.28,0,0,1,.06-.33.68.68,0,0,1,.33-.16,6.63,6.63,0,0,1,1.88-.22,11.74,11.74,0,0,1,1.87.11c.22,0-.31-.55-.35-.6a5,5,0,0,0-.95-.95c-.5-.41-1-.79-1.52-1.2-.11-.09-.1-.22.05-.25a.4.4,0,0,1,.19,0,5.15,5.15,0,0,1,2,1.05c.27.21,1,1,1.36.67.67-.63-.57-2-1-2.46s-.81-.95-1.21-1.42c-.21-.26-.56-.43-.72-.72a.14.14,0,0,1,0-.11.12.12,0,0,1,.1-.09c.21-.05.36.13.51.24s.38.28.56.43a7.57,7.57,0,0,1,1,1c.05.05,1.08,1.37,1.13,1.17a2.29,2.29,0,0,0-.15-1.21c-.1-.33-.37-.8-.2-1.13l0-.05h.08c.25.08.34.51.41.72s.19.59.31.87c.38.87.43-.25.41-.59-.06-1.25-.24-2.48-.4-3.72,0-.33-.33-.86-.15-1.16l0,0h.06c.29.07.41.56.5.8s.18.68.26,1a17,17,0,0,1,.18,1.89c0,.41.09.82.16,1.22,0,.15,0,.31.16.4s.38,0,.49-.19.45-.64.65-1c0-.07.1-.15.18-.15a.16.16,0,0,1,.13.14.46.46,0,0,1,0,.2c-.22.71-.42,1.43-.59,2.15,0,.22,0,.39.23.23a3.89,3.89,0,0,0,.43-.38,8.2,8.2,0,0,1,3.51-1.8c.39-.1,1-.31,1.39-.07,0,0,.09.07.08.13l0,.06a1,1,0,0,1-.52.24,5.21,5.21,0,0,0-.66.24,11,11,0,0,0-1.5.93,30.4,30.4,0,0,0-2.52,2,2.09,2.09,0,0,1,.57-.16l.63-.22c.22-.07.43-.12.65-.17a.92.92,0,0,1,.56.1.14.14,0,0,1,.08.05.13.13,0,0,1,0,.13.34.34,0,0,1-.12.06c-.33.12-2.72.68-2.3,1.23.19.25,1,.25,1.27.28a3.66,3.66,0,0,1,2.05.59c.05.06.11.13.08.2s-.16.09-.25.07a7.21,7.21,0,0,0-1.84-.29c-.69.05.19.58.38.69a7.13,7.13,0,0,1,2.55,1.66c.05.07.09.18,0,.22a.14.14,0,0,1-.14,0,11.29,11.29,0,0,0-2.57-1.3c-.25-.08-1-.43-1.24-.24s.23.71.33.84a10.51,10.51,0,0,1,.91,1.11.61.61,0,0,1,.05.12.11.11,0,0,1,0,.12.12.12,0,0,1-.13,0,.44.44,0,0,1-.11-.09,3.24,3.24,0,0,0-.5-.48c-.12-.08-.26-.14-.39-.22s-.59-.33-.67,0,.54.8.67,1A8,8,0,0,1,436,420Z",
    style: {
      fill: "#845EC2",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.3,412.89a.93.93,0,0,0,.55.2h.43a.37.37,0,0,1,.16.31l0,.08a1,1,0,0,0-.25,0c-.16,0-.36.18-.52.06s-.1.07-.05.12a.44.44,0,0,0,.27.09c0,.07.18.15.23.26a.14.14,0,0,1,0,.06,1.22,1.22,0,0,1-.32,0,1.07,1.07,0,0,1-.49-.29s-.05,0,0,.05a.65.65,0,0,0,.34.35,2,2,0,0,0,.53.15h0v.05a.58.58,0,0,1-.07.21H430a2.19,2.19,0,0,0-.57.09c-.06,0,0,.14,0,.13h.32c.12.1.32.13.43.27l-.09.08a.8.8,0,0,1-.55.26,1.08,1.08,0,0,1-.31,0c-.07,0-.17,0-.22,0v0c.05.08.16.09.24.12a1.55,1.55,0,0,0,.31,0,1,1,0,0,0,.6-.16.24.24,0,0,0,.08-.06.28.28,0,0,1,0,.09c0,.16,0,.21,0,.29a1.32,1.32,0,0,0-.86.29s0,.17.09.13a1.49,1.49,0,0,1,.8-.2h.11s-.05.11-.08.17a.73.73,0,0,1-.2.26.46.46,0,0,1-.36.07s0,.09,0,.11a.54.54,0,0,0,.22.05.52.52,0,0,0,.21,0,.93.93,0,0,0,.31-.25l.11-.19h.12a.37.37,0,0,1,.19.15,2.17,2.17,0,0,1-.42.31,2.13,2.13,0,0,0-.45.34.8.8,0,0,0-.22.55c0,.05.07.09.08,0,.14-.42.63-.6,1-.81.08,0,.15-.1.23-.15a.33.33,0,0,0,.17.07l-.09.19a.67.67,0,0,1-.16.27c-.05,0,0,.18.07.13a.65.65,0,0,0,.22-.18,1.45,1.45,0,0,0,.17-.26l.06-.09.1.05v.08a3.61,3.61,0,0,1-.18.72,1.19,1.19,0,0,0,0,.59c0,.05.07.06.07,0a2.76,2.76,0,0,1,.35-.71A1.22,1.22,0,0,0,432,417h0l.09,0a.17.17,0,0,1,0,.07c0,.23-.14.74.16.86,0,0,0,0,0,0a.38.38,0,0,1,0-.41,4.6,4.6,0,0,0,.19-.52.38.38,0,0,1,.18,0l0,0a3.1,3.1,0,0,0,.27.51s.08,0,.08,0a.84.84,0,0,0-.11-.41s0,0,0,0,.05-.16.14-.22a.62.62,0,0,1,.25,0,1.46,1.46,0,0,1,.05.2,1.41,1.41,0,0,1-.06.61,1.37,1.37,0,0,0-.06.57c0,.07.11.09.1,0s.23-.42.31-.63a1.15,1.15,0,0,0,.05-.58.09.09,0,0,0,.1,0c.12-.06.15-.26.21-.4a1.81,1.81,0,0,0,.37.94s.06,0,0-.08a1.11,1.11,0,0,1-.16-.67,2,2,0,0,0-.07-.41c.12-.06.26-.07.39-.12a2.93,2.93,0,0,1,.52.59s.08.05.11,0,0-.09,0-.12a.74.74,0,0,1-.08-.29.67.67,0,0,0-.1-.21,1,1,0,0,0-.28-.25s0-.05,0-.08.12-.12.22-.18a.13.13,0,0,0,.06-.07.7.7,0,0,0,.43-.07s0-.08,0-.08-.33,0-.49,0c0,0,0,0,0,0a.21.21,0,0,1,0-.26.35.35,0,0,1,.1-.08,1.7,1.7,0,0,1,.39,0,.76.76,0,0,1,.42.23c.08.06.14,0,.09-.11a1.29,1.29,0,0,0-.4-.33.89.89,0,0,0-.28-.07c-.1-.13-.2-.28-.18-.38h0a1.42,1.42,0,0,0,.35-.11c.09,0,0-.19-.09-.18l-.15,0c-.13-.08-.27-.15-.28-.33a.23.23,0,0,1,.07-.2,1.08,1.08,0,0,1,.31,0,.64.64,0,0,1,.51.35c.05.07.11,0,.07-.09a.91.91,0,0,0-.42-.4,1.17,1.17,0,0,0-.36-.08l-.2-.12c-.11-.05-.37-.08-.4-.24a2.37,2.37,0,0,0,.46,0,1.1,1.1,0,0,0,.4-.17c.05,0,0-.17-.05-.13a1.09,1.09,0,0,1-.59.08h-.19s-.05-.07-.14-.11-.3,0-.41-.14h0a1.89,1.89,0,0,0,.44-.19.64.64,0,0,0,.29-.32s0-.13-.07-.09a1.7,1.7,0,0,1-.22.15.94.94,0,0,1-.23.1l-.3.09c0-.15-.15-.15-.27-.12.05-.09.09-.19.14-.28a.33.33,0,0,1,.13-.16.6.6,0,0,1,.23-.06c.05,0,.05-.1,0-.1a.75.75,0,0,0-.33.06,1,1,0,0,0-.4.32,1,1,0,0,0-.14.22c-.15-.1-.15-.29-.32-.3a1.36,1.36,0,0,1,0-.17.68.68,0,0,1,.12-.22.57.57,0,0,1,.18-.12s0-.11,0-.1a.77.77,0,0,0-.63.59.94.94,0,0,0,0,.16h0c-.13,0-.26-.13-.34-.2h0A1.11,1.11,0,0,0,432,411c-.06-.06-.09.07-.05.11.22.25.07.61,0,.9,0,0,0,0,0,0a.49.49,0,0,1-.34,0l-.07,0a0,0,0,0,1,0,0,.57.57,0,0,1,.09-.42c0-.07-.06-.19-.13-.13a.87.87,0,0,0-.22.67.8.8,0,0,1-.18.27c-.1.08-.19,0-.3,0a1.1,1.1,0,0,1-.55-.32s-.07,0-.05.07a1.11,1.11,0,0,0,.39.33l.2.09c.09.1.2.18.09.28a.24.24,0,0,1-.11.06l-.09,0a2,2,0,0,0-.65,0,1,1,0,0,1-.63-.11C429.28,412.73,429.26,412.86,429.3,412.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.7,412.13A.24.24,0,0,0,430,412a.23.23,0,0,0-.17-.28.23.23,0,1,0-.11.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.22,416.79a.23.23,0,0,0,.28-.17.22.22,0,0,0-.17-.28.22.22,0,0,0-.28.17A.24.24,0,0,0,429.22,416.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.92,411.92a.23.23,0,0,0,.28-.17.24.24,0,0,0-.17-.28.22.22,0,0,0-.28.17A.23.23,0,0,0,430.92,411.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.66,410.79a.24.24,0,0,0,.12-.46.24.24,0,0,0-.29.17A.25.25,0,0,0,431.66,410.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.78,411.3a.22.22,0,0,0,.28-.16.23.23,0,1,0-.45-.12A.23.23,0,0,0,432.78,411.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.92,411.35a.24.24,0,0,0,.28-.17.23.23,0,1,0-.28.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.57,417.67a.24.24,0,0,0,.28-.17.23.23,0,0,0-.17-.28.22.22,0,0,0-.28.16A.24.24,0,0,0,430.57,417.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.81,418.3a.22.22,0,0,0,.28-.17.23.23,0,0,0-.17-.28.23.23,0,1,0-.11.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.92,411.84a.23.23,0,1,0-.17-.28A.24.24,0,0,0,434.92,411.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,412.69a.22.22,0,0,0,.28-.17.23.23,0,1,0-.45-.11A.24.24,0,0,0,435,412.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.51,417a.23.23,0,1,0,.12-.45.23.23,0,0,0-.28.17A.22.22,0,0,0,434.51,417Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,413.45a.22.22,0,0,0,.28-.17.23.23,0,1,0-.45-.11A.24.24,0,0,0,436,413.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.87,418.47a.23.23,0,0,0,.28-.17A.24.24,0,0,0,432,418a.23.23,0,1,0-.11.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.84,414.86a.23.23,0,1,0-.17-.28A.23.23,0,0,0,435.84,414.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.13,413.62a.25.25,0,0,0,.29-.17.23.23,0,0,0-.17-.28.23.23,0,1,0-.12.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.91,415.29a.24.24,0,0,0,.28-.17.23.23,0,0,0-.45-.12A.24.24,0,0,0,428.91,415.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.55,416.71a.23.23,0,0,0,.28-.17.22.22,0,0,0-.16-.28.23.23,0,0,0-.29.17A.24.24,0,0,0,435.55,416.71Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowers--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.18,416.49a24.7,24.7,0,0,1-14.25,8.9c-5.87,1.23-12,.8-17.92-.27-6.7-1.22-11.38-1.86-15.95-.48,4.58-16.23,16.78-30.89,33.48-33.24,5.49-.77,12,4.16,16.69,7.42a6.33,6.33,0,0,1,2.8,3.4c.45,1.78-.08,3.83-.54,5.55A24.64,24.64,0,0,1,68.18,416.49Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.18,416.49a24.7,24.7,0,0,1-14.25,8.9c-5.87,1.23-12,.8-17.92-.27-6.7-1.22-11.38-1.86-15.95-.48,4.58-16.23,16.78-30.89,33.48-33.24,5.49-.77,12,4.16,16.69,7.42a6.33,6.33,0,0,1,2.8,3.4c.45,1.78-.08,3.83-.54,5.55A24.64,24.64,0,0,1,68.18,416.49Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,415.83a20.4,20.4,0,0,1,4.57-4.07,49,49,0,0,1,4.76-3,50.42,50.42,0,0,1,21.88-6.19c3.67-.17,7.9-.24,11.41,1,.2.07.6.65.17.66-1.87.05-3.76-.31-5.62-.41a49.29,49.29,0,0,0-5.83.05,53.57,53.57,0,0,0-11.38,2,54.25,54.25,0,0,0-10.23,4.21c-1.61.86-3.16,1.82-4.68,2.83s-2.95,2.35-4.59,3.25C28.81,416.24,28.34,416.05,28.5,415.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowers--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.91,391.71c-4.81.64-10.56.32-14.52-5.82s-6.09-5.59-6.09-5.59a16.24,16.24,0,0,1,15.75.17C72.57,383.63,71.91,391.71,71.91,391.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6,380.4c1.47.56,3,.87,4.52,1.47a23,23,0,0,1,4.23,2.27,25.57,25.57,0,0,1,3.75,3.06,35.21,35.21,0,0,0,3.19,3.27s.26,0,.22-.06a11.34,11.34,0,0,0-3-3.75,27.72,27.72,0,0,0-3.78-3.05,22.19,22.19,0,0,0-4.19-2.17,11.91,11.91,0,0,0-4.9-1.06S54.59,380.39,54.6,380.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.16,392.44c-2.64,4.08-6.61,8.24-13.85,7.27s-8.21,1-8.21,1a16.24,16.24,0,0,1,10.36-11.87C65.45,386.7,71.16,392.44,71.16,392.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.32,398.26c1.39-.76,2.64-1.75,4-2.49A24.79,24.79,0,0,1,59.84,394a26.67,26.67,0,0,1,4.77-.86,34.58,34.58,0,0,0,4.56-.3s.21-.17.09-.21a11.5,11.5,0,0,0-4.82-.12,26.75,26.75,0,0,0-4.77.9,22.44,22.44,0,0,0-4.38,1.77,12,12,0,0,0-4,3S51.31,398.27,51.32,398.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.29,385.93c3.6-2.77-1.34-7.6-4.29-8.52-1.9-.59-4.11-.75-5.82.43-.73.5-1.57,1.6-1.21,2.54-1.3.36-3,1.45-2.3,3,.55,1.28,1.8,1.36,2.81,2.05-1.67.94.49,2.09,1.46,2.4a9,9,0,0,0,4.93.13A12.79,12.79,0,0,0,78.29,385.93Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.29,385.93c3.6-2.77-1.34-7.6-4.29-8.52-1.9-.59-4.11-.75-5.82.43-.73.5-1.57,1.6-1.21,2.54-1.3.36-3,1.45-2.3,3,.55,1.28,1.8,1.36,2.81,2.05-1.67.94.49,2.09,1.46,2.4a9,9,0,0,0,4.93.13A12.79,12.79,0,0,0,78.29,385.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,377c1,1.09,2.67,3.86,2.09,5.43-.46,1.26-4.1-1.58-4.62-2.1-.38-.37-4.21-4.25-2.49-4.42-.13-.42-.69-.76-.44-1.28s1.28-.25,1.75-.11A8.72,8.72,0,0,1,77.43,377Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,377c1,1.09,2.67,3.86,2.09,5.43-.46,1.26-4.1-1.58-4.62-2.1-.38-.37-4.21-4.25-2.49-4.42-.13-.42-.69-.76-.44-1.28s1.28-.25,1.75-.11A8.72,8.72,0,0,1,77.43,377Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.41,382.62c-.77.75-4-1.79-4.51-2.28A18.74,18.74,0,0,1,72.19,377a10.78,10.78,0,0,1,1.81.39C75.94,378,78.75,380.32,79.41,382.62Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.79,370.79a.58.58,0,0,0,.16.14c.15.11.38,0,.54,0a1.14,1.14,0,0,1,.58.64c.54,1.2.11,3.33-.28,4.53-.64,2-1.69,4.61-3.2,6.07s-2.87-.25-4-1.49a13.85,13.85,0,0,1-2.3-3.72,8,8,0,0,1-.68-4.2,1.63,1.63,0,0,1,2.66-1.13A4.5,4.5,0,0,1,81,369a2.81,2.81,0,0,1,2.6,1.38C83.76,370.58,83.72,370.68,83.79,370.79Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.79,370.79a.58.58,0,0,0,.16.14c.15.11.38,0,.54,0a1.14,1.14,0,0,1,.58.64c.54,1.2.11,3.33-.28,4.53-.64,2-1.69,4.61-3.2,6.07s-2.87-.25-4-1.49a13.85,13.85,0,0,1-2.3-3.72,8,8,0,0,1-.68-4.2,1.63,1.63,0,0,1,2.66-1.13A4.5,4.5,0,0,1,81,369a2.81,2.81,0,0,1,2.6,1.38C83.76,370.58,83.72,370.68,83.79,370.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,374.92A9.32,9.32,0,0,1,77.43,377c1,1.09,2.67,3.86,2.09,5.43a.33.33,0,0,1-.06.1,9,9,0,0,1-1.84-1.82,13.85,13.85,0,0,1-2.3-3.72A10.23,10.23,0,0,1,74.69,374.92Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26,377.16c.87.31,2.08.21,2.28,1.41.14.81-.3,1.23-.82,1.76a11.12,11.12,0,0,1-6.3,2.95,8.77,8.77,0,0,1-3,.3c-2.76-.54,2.06-5.16,2.87-5.89C85.27,376.81,90.2,373.64,89.26,377.16Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26,377.16c.87.31,2.08.21,2.28,1.41.14.81-.3,1.23-.82,1.76a11.12,11.12,0,0,1-6.3,2.95,8.77,8.77,0,0,1-3,.3c-2.76-.54,2.06-5.16,2.87-5.89C85.27,376.81,90.2,373.64,89.26,377.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,377.75a12.93,12.93,0,0,1-2.62,4.46,2,2,0,0,1-1,.58C80.48,381.33,83.44,378.45,84.21,377.75Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.77,391.42A13.08,13.08,0,0,1,82.15,389c-.61-1.15-1.6-2.59-1.51-3.92.16-2.27,2.83-3.28,4.68-3.69s4.72-.54,6.46.57A2.32,2.32,0,0,1,93,384.25c-.11,1.12-.14.76.56,1.54a2.84,2.84,0,0,1,.56,2.51c-.42,1.41-1.54,1.49-2.58,2.19.52.43,0,.95-.51,1-.19,3.22-4.23,2.45-6,1.14A7.31,7.31,0,0,1,83.77,391.42Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.77,391.42A13.08,13.08,0,0,1,82.15,389c-.61-1.15-1.6-2.59-1.51-3.92.16-2.27,2.83-3.28,4.68-3.69s4.72-.54,6.46.57A2.32,2.32,0,0,1,93,384.25c-.11,1.12-.14.76.56,1.54a2.84,2.84,0,0,1,.56,2.51c-.42,1.41-1.54,1.49-2.58,2.19.52.43,0,.95-.51,1-.19,3.22-4.23,2.45-6,1.14A7.31,7.31,0,0,1,83.77,391.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.41,383.58l-.2-.05a7.06,7.06,0,0,1,4.11-2.18,11.76,11.76,0,0,1,4.41-.17,12.19,12.19,0,0,1-5.31,2.1A8.77,8.77,0,0,1,81.41,383.58Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.69,387.93a8.51,8.51,0,0,1,1.79,3.56c.17,1-.24,1.39-.46,2.19s.87,3.2-.6,3.62c-1.2.35-2.61-1.21-3.25-2a11.58,11.58,0,0,1-1.93-3.51,13.65,13.65,0,0,1-.5-4.12c0-.89-.18-2.49,1-2.53C82.26,385.11,83.86,386.89,84.69,387.93Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.69,387.93a8.51,8.51,0,0,1,1.79,3.56c.17,1-.24,1.39-.46,2.19s.87,3.2-.6,3.62c-1.2.35-2.61-1.21-3.25-2a11.58,11.58,0,0,1-1.93-3.51,13.65,13.65,0,0,1-.5-4.12c0-.89-.18-2.49,1-2.53C82.26,385.11,83.86,386.89,84.69,387.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,392.59a7.31,7.31,0,0,1-1.25-1.17A13.08,13.08,0,0,1,82.15,389c-.59-1.11-1.53-2.5-1.51-3.79l.13,0c1.49,0,3.09,1.74,3.92,2.78a8.51,8.51,0,0,1,1.79,3.56,2.78,2.78,0,0,1-.3,1.74A5.31,5.31,0,0,1,85,392.59Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.94,391.29c.2-1.77.45-7.52-2.79-6.28A8.42,8.42,0,0,0,75,387.25c-1.73,1.91-3.69,4.69-3.84,7.34,0,.83,0,2.31.94,2.67.58.21,1.08-.23,1.64,0s1,.9,1.94.66a3.22,3.22,0,0,0,1.57-1.58C80.15,397.05,80.71,393.31,80.94,391.29Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.94,391.29c.2-1.77.45-7.52-2.79-6.28A8.42,8.42,0,0,0,75,387.25c-1.73,1.91-3.69,4.69-3.84,7.34,0,.83,0,2.31.94,2.67.58.21,1.08-.23,1.64,0s1,.9,1.94.66a3.22,3.22,0,0,0,1.57-1.58C80.15,397.05,80.71,393.31,80.94,391.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.94,391.29c0,.48-.13,1-.24,1.63a12,12,0,0,1-.46-1.12,13.65,13.65,0,0,1-.5-4.12c0-.69-.11-1.8.41-2.29C81.25,386.71,81.09,390,80.94,391.29Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.67,384.71a12.39,12.39,0,0,0-5.07,1.37c-1.72.9-3.65,2.26-4.15,4.21-.39,1.54,0,1.9,1.37,1.8-.56,1.36,1.88.71,2.42.58a11.74,11.74,0,0,0,6.85-4.33c.62-.84,2.16-3.34.32-3.56A11.16,11.16,0,0,0,76.67,384.71Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.67,384.71a12.39,12.39,0,0,0-5.07,1.37c-1.72.9-3.65,2.26-4.15,4.21-.39,1.54,0,1.9,1.37,1.8-.56,1.36,1.88.71,2.42.58a11.74,11.74,0,0,0,6.85-4.33c.62-.84,2.16-3.34.32-3.56A11.16,11.16,0,0,0,76.67,384.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,388a8.92,8.92,0,0,1-4.86-.11,11.34,11.34,0,0,1,2.59-1.77,12.39,12.39,0,0,1,5.07-1.37,11.16,11.16,0,0,1,1.74.07,1,1,0,0,1,.68.31,3.5,3.5,0,0,1-.8.84A12.79,12.79,0,0,1,73.87,388Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.61,392.57A16.92,16.92,0,0,1,75,387.25,8.42,8.42,0,0,1,78.15,385a3,3,0,0,1,.58-.16c1.31.49-.06,2.71-.64,3.49A11.56,11.56,0,0,1,71.61,392.57Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.59,382.67c-.72-.07-1.44-.17-2.16-.25a4.25,4.25,0,0,1-1-.15c-.13,0-.7-.06-.54.21l.07.07a3.26,3.26,0,0,0,1.33.36c.89.13,1.76.3,2.64.46a7.51,7.51,0,0,1,1.27.25c.27.1.28.23,0,.29a4.29,4.29,0,0,1-.71,0c-.21,0-.4.06-.61.05a.45.45,0,0,0-.3.07l0,0c0,.05,0,.09.09.11a1.53,1.53,0,0,0,.67.12l1,.05c.17,0,.52,0,.66.1.46.37-1.32.58-1.47.61a7.18,7.18,0,0,0-2.38.64.47.47,0,0,0-.28.35.16.16,0,0,0,0,.12.25.25,0,0,0,.25,0c.33-.07.65-.22,1-.28s.58-.14.86-.21a3.21,3.21,0,0,1,1.71-.08c-.34.79-1.46,1.41-2.08,2a4.77,4.77,0,0,0-1.27,1.56c-.07.18.12.17.24.14a.82.82,0,0,0,.35-.23c.27-.23.53-.48.79-.73A12.7,12.7,0,0,1,77.28,387c1.22-.83,1,.05.87,1-.07.5-.15,1-.2,1.51a2.88,2.88,0,0,0,.11,1.54.36.36,0,0,0,.11.16.17.17,0,0,0,.18,0,.26.26,0,0,0,.06-.19,12.76,12.76,0,0,1,.2-1.95,9.24,9.24,0,0,1,.49-2.23c.09-.19.34-.71.63-.65s.35.67.39.89c.08.49.16,1,.21,1.48a.18.18,0,0,0,.06.16c.25-.17.15-.67.13-.94s0-.36,0-.54a1.74,1.74,0,0,0,0-.51c.58.84.63,2.1,1,3a4.82,4.82,0,0,0,.52,1c.21.27.38.61.71.75,0,0,.1,0,.11,0s0,0,0,0a4.55,4.55,0,0,0-.3-.63,11.77,11.77,0,0,1-.63-2,7.79,7.79,0,0,1-.39-2.28c.43.13.81.78,1.12,1.13.47.54.91,1.09,1.34,1.67a.29.29,0,0,0,.11.11.2.2,0,0,0,.25-.11.48.48,0,0,0,0-.29,3.3,3.3,0,0,0-1.32-1.86c-.33-.3-.77-.58-.93-1a2.24,2.24,0,0,1,.87.44,20,20,0,0,0,1.95.87c.48.19.94.43,1.41.66s.92.41,1.38.64a2.21,2.21,0,0,0,.35.16.2.2,0,0,0,.2,0,.18.18,0,0,0,0-.17c0-.73-1-1.12-1.53-1.41s-1.34-.65-2-1c-.42-.2-2-.66-2-1.19a6.53,6.53,0,0,1,2.55.3c.37.07.72.19,1.08.29a2.77,2.77,0,0,0,1.13.21.25.25,0,0,0,.16-.12.26.26,0,0,0,0-.25c-.25-.34-.67-.34-1-.46-.75-.25-1.49-.47-2.27-.65a3.94,3.94,0,0,1-1.19-.31c.47-.39,1.39-.31,2-.35a6.22,6.22,0,0,0,1.83-.18.49.49,0,0,0,.26-.21.15.15,0,0,0,0-.07s0-.09-.09-.11a3.65,3.65,0,0,0-2.22-.24c-.59,0-1.5.47-2,.16s0-.79.39-1.1A17.06,17.06,0,0,1,85.05,381l.69-.41c.19-.11.58-.28.63-.51a.22.22,0,0,0-.12-.26.25.25,0,0,0-.12,0,2.5,2.5,0,0,0-1.27.47c-.36.22-.71.46-1.06.69s-1,.86-1.43.76-.14-1.09-.08-1.55c.11-.85.24-1.69.29-2.55,0-.4.21-.79-.06-1.16a.21.21,0,0,0-.24-.1c-.07,0-.08.15-.08.24a4.24,4.24,0,0,1-.15.79c-.06.25-.06.53-.1.79s-.09,1.9-.36,2.07c-.52.34-.7-1.85-.77-2.16-.13-.53-.23-1.06-.37-1.59a1.81,1.81,0,0,0-.66-1.17l-.07,0c-.06,0-.09.09-.08.15a3,3,0,0,0,.09.51,23.75,23.75,0,0,1,.54,2.64,3.58,3.58,0,0,1,0,1.81c-.3.6-.84-.42-1.05-.67s-.43-.57-.67-.83c-.1-.1-.51-.58-.68-.39s.25.54.32.63q.25.39.48.78c.14.25.62.91.43,1.21s-.61-.1-.78-.19a8.77,8.77,0,0,1-.87-.58,3.66,3.66,0,0,0-1.46-.73c-.11,0-.25,0-.3.08s0,0,0,0a.05.05,0,0,0,0,0c.32.27.72.43,1,.71a5.19,5.19,0,0,1,.92,1c.06.1.12.22,0,.31s-.6,0-.77,0a5.17,5.17,0,0,1-.54-.11c-.56-.13-1.13-.31-1.69-.39-.2,0-.58-.21-.75-.06a.06.06,0,0,0,0,.06.13.13,0,0,0,0,.07,3.51,3.51,0,0,0,1.34.47,7.56,7.56,0,0,1,1.25.39c.23.1.57.38.13.48a4.14,4.14,0,0,1-1-.05Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,383.14l0-.08c-.09-.2-.35-.2-.45-.42s0-.25-.16-.26-.15.09-.25.06a.65.65,0,0,1-.38-.38c0-.11,0-.18-.1-.21s-.35.14-.48.19c-.33.12-.48-.2-.78-.19-.13,0-.11.12-.18.19s-.17,0-.29,0-.13.13-.17.23-.07.14-.2.17-.29-.17-.48-.14c0,.14,0,.53-.13.61s-.18,0-.28,0c0,.19.17.37,0,.56s-.3.12-.45,0a.81.81,0,0,0,.09.4c0,.12.25.33.13.47s-.27,0-.16.33c0,.14.23.26.23.42s0,.08-.09.17c-.21.34.23.29.34.51s-.16.43.19.58c.08,0,.17,0,.24.05s.11.27.12.37-.06.13,0,.17.27-.1.37-.08a.47.47,0,0,1,.28.2c.09.12,0,.15.08.28a1.78,1.78,0,0,1,.54-.17c.17,0,.16.2.32.23.11-.13-.06-.42.17-.43s.36.23.54.25a.4.4,0,0,1,.09-.38c.17-.16.29,0,.47.08.37.25.16-.11.21-.32a.43.43,0,0,1,.2-.27.92.92,0,0,1,.21-.13c.16,0,.21.13.36.11,0-.21-.23-.39-.15-.62a.68.68,0,0,1,.25-.28c.18-.12.17-.15.17-.37a.61.61,0,0,1,0-.19c0-.05.07-.07.06-.12s-.1-.13-.13-.18,0-.3,0-.47,0-.25-.16-.38A1.33,1.33,0,0,1,82.7,383.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.27,381.11c0,.18,0,.35-.07.53a1.09,1.09,0,0,0,.07.4l.18.4a1.82,1.82,0,0,1,.16.5.09.09,0,0,1-.09.08.13.13,0,0,1-.12-.06,2.9,2.9,0,0,1-.29-.51,2.54,2.54,0,0,1-.17-.46,1.13,1.13,0,0,1,0-.45,1.57,1.57,0,0,1,.12-.3.43.43,0,0,0,0-.16c0-.1.2-.07.2,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.26,381.06a1.08,1.08,0,0,1-.16.63c-.1.19-.22.37-.3.56a1.6,1.6,0,0,0-.14.61,1.27,1.27,0,0,0,0,.28,3.37,3.37,0,0,0,.1.34c0,.12-.13.11-.19.06a1,1,0,0,1-.21-.82,2.21,2.21,0,0,1,.15-.56,2.43,2.43,0,0,1,.32-.51,1.15,1.15,0,0,0,.31-.57s.09-.07.09,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6,381.3a1.55,1.55,0,0,1-.51.44,1.48,1.48,0,0,0-.46.47c-.11.17-.2.36-.3.55s-.18.43-.35.41-.14-.06-.14-.12a1.09,1.09,0,0,1,.15-.39l.13-.26a4.48,4.48,0,0,1,.28-.47,1.24,1.24,0,0,1,.35-.37c.22-.14.56-.1.73-.3s.16,0,.12,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.37,382a1.42,1.42,0,0,1-.08.41,1,1,0,0,1-.15.34,2.34,2.34,0,0,1-.31.32l-.19.17-.07.06a.13.13,0,0,1-.13,0s-.08,0-.08-.06,0,0,0,0a.19.19,0,0,1,0-.07.44.44,0,0,1,.08-.11,1.45,1.45,0,0,1,.18-.17,2.42,2.42,0,0,0,.33-.31,1.08,1.08,0,0,0,.13-.29.71.71,0,0,1,.16-.31s.13,0,.13,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.13,382.17c.12.24-.09.45-.26.6s-.53.4-.79.62-.24.23-.38.34a.19.19,0,0,1-.21,0,.15.15,0,0,1-.1-.14c0-.16.23-.31.34-.41l.42-.33a2.43,2.43,0,0,1,.44-.26c.19-.09.48-.2.5-.45,0,0,0,0,0,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9,382.56a1,1,0,0,1-.46.44,3.68,3.68,0,0,0-.58.39c-.33.29-.56.69-.9,1-.1.08-.26,0-.21-.15a3.47,3.47,0,0,1,.82-1,1.76,1.76,0,0,1,.54-.36c.12,0,.24-.06.36-.09a1.39,1.39,0,0,0,.36-.19s.09,0,.07,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.51,383.61a.77.77,0,0,0-.26.07l-.26.12-.25.08H82.6a.33.33,0,0,1-.23-.07.09.09,0,0,1-.05-.09s0-.05.06-.07a.63.63,0,0,1,.19,0h.12l.22-.06a2,2,0,0,1,.23-.06,1.21,1.21,0,0,1,.38,0c.09,0,.07.11,0,.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.69,384.13c-.3.35-.76.28-1.17.22a2.09,2.09,0,0,0-.61,0,.77.77,0,0,0-.25.1l-.11.08a.6.6,0,0,1-.11.06h-.1s-.09,0-.09-.07c0-.28.31-.45.55-.5a1.35,1.35,0,0,1,.6,0c.39.09.84.28,1.21.05,0,0,.12,0,.08.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,385a.48.48,0,0,0-.3-.2.8.8,0,0,0-.34.07A2.49,2.49,0,0,0,83,385a.8.8,0,0,1-.38.14c-.07,0-.14-.08-.1-.15a.45.45,0,0,1,.19-.14l.18-.09a1.64,1.64,0,0,1,.39-.14.84.84,0,0,1,.47,0,.86.86,0,0,1,.19.11.52.52,0,0,1,.12.18S84,385,84,385Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,385.52a1.55,1.55,0,0,1-1-.46,1.66,1.66,0,0,0-.47-.26.58.58,0,0,0-.19,0,.62.62,0,0,1-.33,0,.08.08,0,0,1,0-.09c0-.2.36-.19.52-.15a1.37,1.37,0,0,1,.51.26c.18.14.34.29.53.42a.92.92,0,0,0,.47.19c.09,0,.07.11,0,.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.85,386.29c-.07,0-.11-.07-.16-.13a2.39,2.39,0,0,0-.22-.23.74.74,0,0,0-.57-.18,1.63,1.63,0,0,1-.66-.05,1.13,1.13,0,0,1-.54-.4c-.06-.08,0-.16.11-.15a.65.65,0,0,1,.3.17.94.94,0,0,0,.26.14,4.21,4.21,0,0,0,.62,0,1.18,1.18,0,0,1,.6.3,1.57,1.57,0,0,1,.2.25c0,.06.13.15.08.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,386.58a4.52,4.52,0,0,1-.51-.34,1.66,1.66,0,0,1-.26-.27.77.77,0,0,1-.17-.27.08.08,0,0,1,.06-.09h.08l.05,0s.1.14.12.17l.09.12a1.57,1.57,0,0,0,.18.19,5.9,5.9,0,0,0,.46.39c.06,0-.06.1-.1.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.53,387.35a2.8,2.8,0,0,0-.06-.28.9.9,0,0,0-.08-.21,1.66,1.66,0,0,0-.31-.39,1.94,1.94,0,0,1-.69-1,.12.12,0,0,1,.12-.12.16.16,0,0,1,.15.12,3.15,3.15,0,0,0,.64.9,1.79,1.79,0,0,1,.3.47,1.05,1.05,0,0,1,.06.24.6.6,0,0,1-.06.22s-.07.05-.07,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.13,387.26a.33.33,0,0,0-.24-.23,1.14,1.14,0,0,1-.31-.16,1.81,1.81,0,0,1-.24-.24.8.8,0,0,1-.19-.3c0-.11.08-.15.16-.11s.19.23.28.33a1.24,1.24,0,0,0,.26.25,3,3,0,0,1,.3.19.39.39,0,0,1,.12.24c0,.07-.13.09-.14,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82,388c-.12-.39-.52-.54-.77-.83a1.66,1.66,0,0,1-.37-.87,1.14,1.14,0,0,1,0-.45.12.12,0,0,1,.16-.1A.19.19,0,0,1,81,386a1.66,1.66,0,0,0,.15.9c.22.43.78.6.85,1.11,0,.07-.12.09-.14,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.74,388c0-.54-.56-.9-.48-1.46,0-.06.09-.07.14-.06a.16.16,0,0,1,.11.13.84.84,0,0,0,0,.35,3.49,3.49,0,0,0,.15.34,1.85,1.85,0,0,1,.12.33.86.86,0,0,1,0,.36s-.09.06-.09,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.34,387.45a.68.68,0,0,0,.36-.26,2.64,2.64,0,0,0,.2-.37c.06-.11.13-.22.2-.33s.2-.23.35-.22a.15.15,0,0,1,.12.23l0-.06s0,0,0,.05a.52.52,0,0,1-.1.11l-.07.06a.58.58,0,0,0-.1.12c-.08.11-.15.24-.22.35a1,1,0,0,1-.27.31.79.79,0,0,1-.42.15c-.09,0-.17-.11-.06-.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,387.57a1,1,0,0,1,.27-.67,3.39,3.39,0,0,1,.72-.58c.09-.06.17-.14.27-.2a.17.17,0,0,1,.26.05c0,.08,0,.15-.06.21a1.43,1.43,0,0,1-.31.24l-.33.21c-.28.18-.66.36-.68.74,0,.05-.14.07-.14,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.92,386.44a.34.34,0,0,0,.31,0l.23-.11a3.12,3.12,0,0,0,.4-.32,1.44,1.44,0,0,1,.89-.45c.09,0,.24.14.12.22s-.38.18-.56.3-.34.25-.52.36a1.08,1.08,0,0,1-.45.17.79.79,0,0,1-.5-.11s0-.09.08-.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.49,385.64a.61.61,0,0,0,.21.11c.1,0,.19,0,.29-.07l.49-.2a1.09,1.09,0,0,1,.53-.1l.25.07.09,0,.1,0,.07.07a.06.06,0,0,1,0,.07c-.08.22-.37.1-.54.06a1.25,1.25,0,0,0-.59.14,1.14,1.14,0,0,1-.55,0,.78.78,0,0,1-.44-.2s0-.09.08-.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,385a.86.86,0,0,1,.55,0,4.5,4.5,0,0,1,.48.16l.21.07.09,0,.06,0s0,0,0,0l.19,0h.06a.59.59,0,0,1,.23,0,.14.14,0,0,1,.08.19c-.11.17-.36.17-.53.14a2.38,2.38,0,0,1-.47-.17,5.44,5.44,0,0,0-.54-.27.84.84,0,0,0-.39-.06c-.05,0-.08-.06,0-.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.34,383.91a1.19,1.19,0,0,1,.44.17,2.24,2.24,0,0,1,.44.32,1.54,1.54,0,0,0,.3.22l.08,0h.07l.1,0H79c.07,0,.14.08.1.15a.46.46,0,0,1-.53.12,1.31,1.31,0,0,1-.44-.26c-.12-.11-.24-.23-.35-.35a1,1,0,0,0-.51-.34c-.08,0,0-.11,0-.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.79,382.75a.78.78,0,0,0,.1.58,1.28,1.28,0,0,0,.34.26l.25.19a4.06,4.06,0,0,1,.49.44,1.29,1.29,0,0,1,.36.57c0,.06-.1.07-.14,0a6.38,6.38,0,0,1-.51-.53c-.17-.16-.35-.3-.53-.45a1.7,1.7,0,0,1-.46-.54.93.93,0,0,1,0-.57c0-.06.14-.07.14,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.29,382.76a1.46,1.46,0,0,1,.38.18l.35.23.24.19a.88.88,0,0,1,.23.24c0,.07-.09.09-.12.08a1,1,0,0,1-.32-.23l-.24-.18-.25-.17c-.12-.08-.24-.14-.36-.21s0-.15.09-.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.66,381.7c0,.08,0,.17,0,.25a.62.62,0,0,0,.18.29c.13.13.27.22.4.34a1,1,0,0,1,.25.43,2.33,2.33,0,0,1,.07.25,1.7,1.7,0,0,1,.06.31c0,.09-.13.09-.18,0a2.08,2.08,0,0,1-.26-.59.92.92,0,0,0-.31-.37,1.08,1.08,0,0,1-.42-.94c0-.07.16-.08.17,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.14,381.81a1.13,1.13,0,0,1,.65.7,3.79,3.79,0,0,1,.14.48c0,.09,0,.18,0,.27a.57.57,0,0,1,0,.29c0,.07-.14,0-.17,0a1.53,1.53,0,0,1-.13-.51,3.12,3.12,0,0,0-.09-.44,1.33,1.33,0,0,0-.18-.38,1.19,1.19,0,0,0-.15-.18,1,1,0,0,1-.19-.17s0-.05.06-.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.13,388.31a.23.23,0,1,0-.39.26.23.23,0,0,0,.33.06A.24.24,0,0,0,81.13,388.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.65,385.11a.24.24,0,1,0-.39.27.24.24,0,0,0,.39-.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.07,387.64a.23.23,0,1,0-.39.26A.23.23,0,0,0,80,388,.24.24,0,0,0,80.07,387.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.74,388a.24.24,0,1,0-.07.33A.24.24,0,0,0,78.74,388Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.24,386.84a.22.22,0,0,0-.32-.06.23.23,0,0,0-.07.32.24.24,0,0,0,.33.07A.23.23,0,0,0,78.24,386.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.41,386a.23.23,0,0,0-.32-.06.24.24,0,0,0-.07.33.25.25,0,0,0,.33.06A.23.23,0,0,0,77.41,386Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.23,383.54a.23.23,0,1,0-.39.26.23.23,0,0,0,.33.06A.24.24,0,0,0,84.23,383.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.21,380.86a.23.23,0,1,0-.39.26.23.23,0,0,0,.33.06A.24.24,0,0,0,82.21,380.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,385a.23.23,0,0,0-.33-.06.22.22,0,0,0-.06.32.24.24,0,0,0,.33.07A.25.25,0,0,0,77,385Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.54,384.32a.22.22,0,0,0-.32-.06.23.23,0,0,0-.07.32.24.24,0,0,0,.33.07A.23.23,0,0,0,77.54,384.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.81,381.34a.24.24,0,0,0-.39.27.24.24,0,0,0,.33.06A.23.23,0,0,0,80.81,381.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.31,383.07a.24.24,0,1,0-.07.33A.24.24,0,0,0,77.31,383.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.79,382.05a.23.23,0,0,0-.32-.07.24.24,0,0,0-.07.33.23.23,0,0,0,.33.06A.22.22,0,0,0,83.79,382.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.35,382.08A.23.23,0,0,0,78,382a.22.22,0,0,0-.06.32.23.23,0,0,0,.32.07A.24.24,0,0,0,78.35,382.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.57,387.56a.25.25,0,0,0-.33-.06.23.23,0,0,0-.06.33.22.22,0,0,0,.32.06A.24.24,0,0,0,82.57,387.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.87,386.46a.24.24,0,0,0-.33-.07.23.23,0,0,0-.06.33.22.22,0,0,0,.32.06A.23.23,0,0,0,83.87,386.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.81,380.88a.22.22,0,0,0-.32-.06.23.23,0,0,0-.07.32.24.24,0,0,0,.33.07A.23.23,0,0,0,79.81,380.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,410.14a9.11,9.11,0,0,1-2.1-.75c-1.22-.59-5.09-2-7.9-1.09s-7.09,4.7-7.39,6.7a3,3,0,0,0,2.4,3.3c1.08.19,1.5.2,1.73,2s1.92.94,2.36,1.24-.09,2.4,2.27,2.83,5.08-2.34,6.61-5.15C76.22,414.75,75,411,75.81,410.14Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,410.14a9.11,9.11,0,0,1-2.1-.75c-1.22-.59-5.09-2-7.9-1.09s-7.09,4.7-7.39,6.7a3,3,0,0,0,2.4,3.3c1.08.19,1.5.2,1.73,2s1.92.94,2.36,1.24-.09,2.4,2.27,2.83,5.08-2.34,6.61-5.15C76.22,414.75,75,411,75.81,410.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,409.23s-2.49.38-5,1-9,1.15-10.45-.53S61.21,407,61,406s-1.66-1.63-.32-2.41,4.92-.27,7.2.45a29.65,29.65,0,0,1,6.28,3.51C75.44,408.59,75.45,409.23,75.45,409.23Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,409.23s-2.49.38-5,1-9,1.15-10.45-.53S61.21,407,61,406s-1.66-1.63-.32-2.41,4.92-.27,7.2.45a29.65,29.65,0,0,1,6.28,3.51C75.44,408.59,75.45,409.23,75.45,409.23Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,410.26a23.27,23.27,0,0,1-8.6.34,12.76,12.76,0,0,1,3.91-2.3c2.81-.87,6.68.5,7.9,1.09l.23.1C73,409.67,71.75,409.93,70.5,410.26Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.66,408.82A7.28,7.28,0,0,0,72.05,407a59.33,59.33,0,0,0-6.39-1.17c-1.9-.19-2.68-1.51-1.9-2.3S65,402.19,65,402.19s-2.24-.29-2.47-1.83a2.39,2.39,0,0,1,1.24-2.49c.52-.43-.33-1,0-2.08s1.19-2.38,3.67-3.38,4.06-.39,4.78.43.93,2.85,1.77,3.49,3,1.53,3.55,4.31-1.57,5.75-1.34,7.26S75.66,408.82,75.66,408.82Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.66,408.82A7.28,7.28,0,0,0,72.05,407a59.33,59.33,0,0,0-6.39-1.17c-1.9-.19-2.68-1.51-1.9-2.3S65,402.19,65,402.19s-2.24-.29-2.47-1.83a2.39,2.39,0,0,1,1.24-2.49c.52-.43-.33-1,0-2.08s1.19-2.38,3.67-3.38,4.06-.39,4.78.43.93,2.85,1.77,3.49,3,1.53,3.55,4.31-1.57,5.75-1.34,7.26S75.66,408.82,75.66,408.82Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.11,407.57c.22.17.39.32.55.47A8.22,8.22,0,0,0,72.05,407a59.33,59.33,0,0,0-6.39-1.17c-1.9-.19-2.68-1.51-1.9-2.3l.21-.23a20.12,20.12,0,0,1,3.86.78A29.65,29.65,0,0,1,74.11,407.57Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.15,408s-1.27-1.65-1.58-5.51.62-7.36,1.6-8.74A5.11,5.11,0,0,1,80.39,392c.64.26,1.65-.17,2.08.36s0,1.43.59,1.88,1.89-.19,3.21,1.13a3.64,3.64,0,0,1,1,3s2.47.06,2.64,2.34-1.78,4.65-4.68,5.83A17.85,17.85,0,0,1,76.15,408Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.15,408s-1.27-1.65-1.58-5.51.62-7.36,1.6-8.74A5.11,5.11,0,0,1,80.39,392c.64.26,1.65-.17,2.08.36s0,1.43.59,1.88,1.89-.19,3.21,1.13a3.64,3.64,0,0,1,1,3s2.47.06,2.64,2.34-1.78,4.65-4.68,5.83A17.85,17.85,0,0,1,76.15,408Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.14,407.9s0,.07,0,.1h0s-1.27-1.65-1.58-5.51a18.51,18.51,0,0,1,.36-5.5,5.48,5.48,0,0,1,2.55,3.65C78,403.41,75.91,406.39,76.14,407.9Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.57,409.24a14.21,14.21,0,0,1,3.1-4.61c1.85-1.56,6-3.48,8.5-2.7s3.9,2.94,2.12,6a2,2,0,0,1,.92,2.13c-.23,1.52-2.29,1.84-3.23,1.63,0,0,.08.67-1.54.71s-3.87-2.35-7-2.28S77.32,409.8,77.57,409.24Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.57,409.24a14.21,14.21,0,0,1,3.1-4.61c1.85-1.56,6-3.48,8.5-2.7s3.9,2.94,2.12,6a2,2,0,0,1,.92,2.13c-.23,1.52-2.29,1.84-3.23,1.63,0,0,.08.67-1.54.71s-3.87-2.35-7-2.28S77.32,409.8,77.57,409.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.17,401.93c.21.07.41.14.6.22a7.48,7.48,0,0,1-4.53,4.45,20.22,20.22,0,0,1-7.14,1.52,12.19,12.19,0,0,1,2.57-3.49C82.52,403.07,86.63,401.15,89.17,401.93Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.47,409.62a21.43,21.43,0,0,1,5.23-.41c3.72.24,7,3.2,7.94,3.61s1.84,2.73.62,4.55-2.52,1.79-2.86,3.34-1.15,2-2.81,2-1.33,2.19-3,2.47-4.29-4.25-5.06-7.53A19,19,0,0,1,77.47,409.62Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.47,409.62a21.43,21.43,0,0,1,5.23-.41c3.72.24,7,3.2,7.94,3.61s1.84,2.73.62,4.55-2.52,1.79-2.86,3.34-1.15,2-2.81,2-1.33,2.19-3,2.47-4.29-4.25-5.06-7.53A19,19,0,0,1,77.47,409.62Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,410c-.35.5-1.85,1.29-2.47,2.8s-2,2.76-2.59,4,.14,2.65,1,3.59.26,1.48.08,3,.24,2.92,1.47,3.14c.67.12.89-.32,1.72,0s1.68,1.19,2.52.08,1.08-2.22,2.18-2.69,2.79-2,1.8-3.81-2.14-2.69-2-4a8.22,8.22,0,0,0-1.52-4.72C77.75,410.11,77,409.48,76.6,410Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,410c-.35.5-1.85,1.29-2.47,2.8s-2,2.76-2.59,4,.14,2.65,1,3.59.26,1.48.08,3,.24,2.92,1.47,3.14c.67.12.89-.32,1.72,0s1.68,1.19,2.52.08,1.08-2.22,2.18-2.69,2.79-2,1.8-3.81-2.14-2.69-2-4a8.22,8.22,0,0,0-1.52-4.72C77.75,410.11,77,409.48,76.6,410Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79,419.22a16.33,16.33,0,0,1-1,1.57,2.11,2.11,0,0,0-.27-.36c-.86-.94-1.62-2.35-1-3.59s2-2.49,2.59-4a5.13,5.13,0,0,1,1.4-1.84C75.36,412.55,75.73,415.65,73.79,419.22Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.51,423.93a16.89,16.89,0,0,1-3-6.26,19.09,19.09,0,0,1-.11-7.68,6,6,0,0,1,1.36,1.42,8.22,8.22,0,0,1,1.52,4.72c-.09,1.3,1.06,2.2,2,4S81.6,423.46,80.51,423.93Z",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.07,413.14c-.42.42-1.17.94-1.22,1.57,0,.08,0,.18.08.2H69a1.42,1.42,0,0,0,.55-.4,9.74,9.74,0,0,1,2-1.55c.15-.09.62-.4.78-.18a.2.2,0,0,1,0,.2,5.74,5.74,0,0,0-.52,1.2.17.17,0,0,0,0,.12.12.12,0,0,0,.14,0,.4.4,0,0,0,.1-.12c.13-.2,1-1.83,1.34-1.28a.38.38,0,0,1,0,.28c-.23,1.13-.66,2.22-.86,3.35a.56.56,0,0,0,.09.51,2.19,2.19,0,0,0,.42-1c.11-.4.25-.8.39-1.19a15.44,15.44,0,0,1,.65-1.76c.11-.23.71-1.47,1.07-1a.72.72,0,0,1,.08.46c0,.56-.13,1.12-.13,1.68a8.35,8.35,0,0,0,.32,2.27.38.38,0,0,0,.06.13.1.1,0,0,0,.13,0,.09.09,0,0,0,0-.08,6.14,6.14,0,0,0,0-1.05c0-.4.06-.81.11-1.21s.08-1.73.74-1.14a2.13,2.13,0,0,1,.5.95c.17.43.33.87.49,1.3s.4,1.07.61,1.61a.75.75,0,0,0,.13.25c.38.4.39-.34.36-.54s-.19-.62-.26-.94c-.22-.95-.46-1.89-.73-2.83-.08-.27-.32-.59-.19-.9.37-.9,1,.48,1.31.74s.88.76,1.33,1.13c.23.19.45.37.68.54s.47.27.64.18-.42-.68-.52-.79c-.29-.32-.58-.64-.89-.93s-.5-.48-.74-.73-.6-.53-.51-.76a.31.31,0,0,1,.24-.17,1.06,1.06,0,0,1,.31,0,11.16,11.16,0,0,1,3,1.42.33.33,0,0,0,.09-.39.83.83,0,0,0-.27-.32,8.21,8.21,0,0,0-1.88-1.14,15.16,15.16,0,0,0-2-.78c-.25-.07.59-.43.65-.46a5.55,5.55,0,0,1,1.47-.55c.72-.2,1.46-.34,2.18-.54.16,0,.21-.18.06-.29a.7.7,0,0,0-.2-.08,6.18,6.18,0,0,0-2.6.17c-.37.09-1.54.56-1.75.05-.41-1,1.57-1.84,2.2-2.13l2-.93a6,6,0,0,0,1.12-.4.18.18,0,0,0,.08-.11.14.14,0,0,0-.06-.15c-.2-.14-.44,0-.65,0l-.8.19a9.16,9.16,0,0,0-1.52.54c-.08,0-1.81.92-1.76.69a2.8,2.8,0,0,1,.73-1.21c.27-.29.78-.67.77-1.1,0,0,0,0,0-.06a.09.09,0,0,0-.07,0c-.31,0-.61.37-.79.56s-.49.53-.75.77c-.81.74-.33-.47-.14-.82.66-1.29,1.45-2.51,2.2-3.74.2-.33.77-.75.72-1.15,0,0,0,0,0-.06a.09.09,0,0,0-.07,0c-.33-.07-.7.39-.9.6a10.11,10.11,0,0,0-.77,1,18,18,0,0,0-1.1,1.9c-.24.42-.49.83-.76,1.22-.1.15-.17.32-.37.35s-.37-.21-.42-.44c-.09-.44-.16-.89-.21-1.34,0-.1,0-.21-.13-.24a.18.18,0,0,0-.2.08.6.6,0,0,0-.06.22c-.11.86-.25,1.72-.42,2.57,0,.25-.2.4-.35.13a6.65,6.65,0,0,1-.27-.61,10.82,10.82,0,0,0-.79-1.41,9.48,9.48,0,0,0-2.06-2.18c-.36-.29-.93-.82-1.43-.74-.06,0-.13,0-.14.09a.14.14,0,0,0,0,.09c.06.21.28.36.44.5a6.33,6.33,0,0,1,.59.57,14,14,0,0,1,1.13,1.71,33.71,33.71,0,0,1,1.69,3.34c-.06-.15-.39-.34-.52-.45l-.56-.53a5.58,5.58,0,0,0-.6-.49,1,1,0,0,0-.65-.17.12.12,0,0,0-.1,0,.16.16,0,0,0,0,.15.41.41,0,0,0,.1.13c.29.28,2.55,2,1.84,2.4-.32.17-1.19-.23-1.48-.32a4.17,4.17,0,0,0-2.45-.35c-.08,0-.18.08-.18.17s.12.17.23.19a8.24,8.24,0,0,1,2.08.58c.71.38-.48.53-.73.55a8.1,8.1,0,0,0-3.49.53c-.09,0-.19.15-.12.22s.1,0,.16,0a13.84,13.84,0,0,1,3.34-.15c.31,0,1.31.05,1.43.35s-.58.65-.75.74a11,11,0,0,0-1.5.73.52.52,0,0,0-.11.1.16.16,0,0,0,0,.15.17.17,0,0,0,.14.07.42.42,0,0,0,.15,0,3.52,3.52,0,0,1,.77-.27c.17,0,.34,0,.51,0s.78-.07.73.3-1,.58-1.19.72A8.68,8.68,0,0,0,70.07,413.14Z",
    style: {
      fill: "#845EC2",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,408.85a1,1,0,0,1-.67-.06l-.46-.2a.41.41,0,0,0-.31.25.38.38,0,0,0,0,.1,1.26,1.26,0,0,1,.26.13c.15.11.3.36.52.32s.07.12,0,.14a.53.53,0,0,1-.33,0,1.8,1.8,0,0,0-.37.15.34.34,0,0,0-.06.06,1.65,1.65,0,0,0,.36.11,1.24,1.24,0,0,0,.66-.07s0,.06,0,.07a.8.8,0,0,1-.53.21,2.24,2.24,0,0,1-.63-.1h0s0,0,0,.05a1,1,0,0,0,0,.26l.09,0a2.53,2.53,0,0,1,.55.37c.06.05,0,.17-.09.13l-.34-.16c-.18.05-.4,0-.58.07,0,.05,0,.09.05.14a1,1,0,0,0,.45.54,2.33,2.33,0,0,0,.33.14c.09,0,.21,0,.23.13v0c-.09.07-.21,0-.31,0a1.39,1.39,0,0,1-.35-.09,1.26,1.26,0,0,1-.56-.46l-.06-.11s0,.07,0,.1c0,.2-.08.24-.19.29a1.51,1.51,0,0,1,.77.72c0,.07-.11.17-.15.09a1.68,1.68,0,0,0-.75-.59l-.12-.06v.22a1,1,0,0,0,.09.38.61.61,0,0,0,.34.25c.05,0,0,.12,0,.11a.62.62,0,0,1-.27,0,.52.52,0,0,1-.19-.14.88.88,0,0,1-.21-.42l0-.26-.13,0a.39.39,0,0,0-.27.07,2.47,2.47,0,0,0,.29.53,2.68,2.68,0,0,1,.32.57,1,1,0,0,1,0,.7s-.11.06-.1,0c.06-.52-.38-.94-.65-1.33a2.4,2.4,0,0,1-.16-.27.41.41,0,0,1-.22,0v.25a1,1,0,0,0,0,.35c0,.08-.08.2-.14.11a1,1,0,0,1-.14-.29c0-.12,0-.24-.06-.36a.5.5,0,0,0,0-.12h-.12l0,.09a4.9,4.9,0,0,0-.16.85,1.35,1.35,0,0,1-.24.64s-.09,0-.08,0a2.6,2.6,0,0,0,0-.92,2.11,2.11,0,0,1,.09-.55h0a.23.23,0,0,1-.11,0,.29.29,0,0,0,0,.09c-.07.27-.21.85-.58.83,0,0,0-.05,0-.05.18-.08.21-.24.23-.42s0-.43.05-.64a.33.33,0,0,0-.2,0h0a2.93,2.93,0,0,1-.52.41.05.05,0,0,1-.08-.06.91.91,0,0,1,.32-.38l0,0c0-.08,0-.2,0-.29a.58.58,0,0,0-.25-.17l-.14.18a1.69,1.69,0,0,0-.24.67,1.61,1.61,0,0,1-.21.64c0,.07-.15,0-.11-.05s0-.55,0-.82a1.38,1.38,0,0,1,.23-.64s-.07,0-.11-.05,0-.35,0-.52a2.17,2.17,0,0,1-.84.81c-.06,0,0-.08,0-.1a1.28,1.28,0,0,0,.49-.63,1.87,1.87,0,0,1,.27-.4,3.49,3.49,0,0,0-.35-.32,3.51,3.51,0,0,0-.84.38s-.11,0-.12,0a.11.11,0,0,1,.07-.13c.1-.06.15-.18.22-.26a.91.91,0,0,1,.21-.18,1.39,1.39,0,0,1,.42-.14.43.43,0,0,0,0-.07c.07-.19-.06-.18-.14-.3a.14.14,0,0,1,0-.1.75.75,0,0,1-.42-.28s0-.09,0-.08.35.16.54.2l0,0a.26.26,0,0,0,.09-.29.32.32,0,0,0-.07-.13,3.17,3.17,0,0,0-.42-.19.9.9,0,0,0-.56,0c-.11,0-.12-.11,0-.16A1.24,1.24,0,0,1,73,408a.78.78,0,0,1,.34,0c.16-.09.35-.2.38-.31h0a2.92,2.92,0,0,1-.32-.28c-.07-.1.1-.2.18-.15l.15.11c.17,0,.35,0,.46-.21a.37.37,0,0,0,0-.25,3.41,3.41,0,0,0-.33-.17.75.75,0,0,0-.7.12c-.09.06-.1-.08,0-.12a1.08,1.08,0,0,1,.64-.22,1.36,1.36,0,0,1,.42.09.93.93,0,0,1,.27,0c.14,0,.43.1.54,0a2.73,2.73,0,0,1-.47-.27,1,1,0,0,1-.35-.36c0-.07.07-.19.13-.11a1.25,1.25,0,0,0,.58.36l.19.09a.52.52,0,0,1,.21-.05c.15,0,.34.09.5.06h0a2.42,2.42,0,0,1-.36-.42.7.7,0,0,1-.16-.48s.09-.12.12-.06.09.18.15.27a2.18,2.18,0,0,0,.21.22L76,406c.13-.13.23-.08.34,0,0-.12,0-.24,0-.36a.43.43,0,0,0-.06-.22.63.63,0,0,0-.22-.18s0-.14,0-.11a.8.8,0,0,1,.33.22,1.12,1.12,0,0,1,.27.53c0,.1,0,.2,0,.3.2,0,.29-.24.48-.16,0-.06,0-.13,0-.2a1.42,1.42,0,0,0,0-.29.77.77,0,0,0-.14-.21s0-.14.06-.11a.9.9,0,0,1,.37.93,1.13,1.13,0,0,1,0,.18l0,0c.12.07.33,0,.45,0h0a1.31,1.31,0,0,1,.67-.75c.1,0,.07.12,0,.15-.34.15-.37.6-.41,1a.43.43,0,0,0,0,0,.56.56,0,0,0,.35.2h.09l0,0a.7.7,0,0,0,.1-.49c0-.09.16-.17.2-.07a1,1,0,0,1-.09.81,1.24,1.24,0,0,0,.06.37c.06.14.2.11.31.16a1.25,1.25,0,0,0,.74-.08c.05,0,.05.08,0,.1a1.15,1.15,0,0,1-.57.17h-.25c-.14.06-.29.09-.23.25a.34.34,0,0,0,.09.12h.11a2.41,2.41,0,0,1,.7.29,1.14,1.14,0,0,0,.72.18C80.65,408.69,80.61,408.83,80.55,408.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,407.85a.28.28,0,0,1-.22-.31.27.27,0,0,1,.32-.22.28.28,0,0,1,.22.31A.27.27,0,0,1,80.5,407.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.77,413a.27.27,0,0,1-.22-.32.27.27,0,0,1,.31-.21.26.26,0,0,1,.22.31A.28.28,0,0,1,78.77,413Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31,407.05a.27.27,0,0,1-.21-.32.26.26,0,0,1,.31-.21.27.27,0,0,1,.22.31A.28.28,0,0,1,79.31,407.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.07,405.49a.27.27,0,1,1,.1-.53.26.26,0,0,1,.21.31A.27.27,0,0,1,79.07,405.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.64,405.5a.27.27,0,1,1,.1-.53.26.26,0,0,1,.21.31A.26.26,0,0,1,77.64,405.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.41,405a.28.28,0,0,1-.22-.32.27.27,0,0,1,.32-.21.27.27,0,0,1,.22.31A.27.27,0,0,1,76.41,405Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.92,413.29a.28.28,0,0,1-.22-.31.27.27,0,0,1,.32-.22.27.27,0,0,1,.21.31A.26.26,0,0,1,76.92,413.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.18,412.4a.27.27,0,0,1-.21-.31.26.26,0,0,1,.31-.22.28.28,0,0,1,.22.32A.27.27,0,0,1,73.18,412.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.11,405a.26.26,0,0,1-.21-.31.27.27,0,0,1,.31-.22.28.28,0,0,1,.22.32A.27.27,0,0,1,75.11,405Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.68,405.92a.27.27,0,1,1,.31-.22A.27.27,0,0,1,74.68,405.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.05,410.71a.27.27,0,0,1-.21-.31.26.26,0,0,1,.31-.22.28.28,0,0,1,.22.31A.27.27,0,0,1,73.05,410.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.25,406.24a.26.26,0,0,1-.21-.31.27.27,0,0,1,.31-.22.28.28,0,0,1,.22.32A.27.27,0,0,1,73.25,406.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,413.52a.27.27,0,0,1-.22-.32.28.28,0,0,1,.31-.22.27.27,0,0,1,.22.32A.28.28,0,0,1,75.16,413.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,407.79a.27.27,0,0,1-.21-.32.26.26,0,0,1,.31-.21.26.26,0,0,1,.22.31A.27.27,0,0,1,72.69,407.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38,409.7a.28.28,0,0,1-.22-.32.27.27,0,0,1,.32-.21.27.27,0,0,1,.22.31A.28.28,0,0,1,80.38,409.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82,411.57a.27.27,0,1,1,.31-.22A.27.27,0,0,1,79.82,411.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.11,409.88a.27.27,0,1,1,.1-.53.27.27,0,0,1-.1.53Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hearts--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Heart--inject-94",
    d: "M441.93,142.21c3.31-2,7.34.35,8.32,5.26.86-4.94,4.82-7.38,8.18-5.48s2.87,11.27-8,18.45C439.36,153.55,438.63,144.21,441.93,142.21Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--heart--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.17,94.6c1.66-2.83,5.62-2.72,8.35.55-1.37-4,.6-7.47,3.88-7.41s6.72,7.25,1.51,17C430.85,104.12,426.52,97.44,428.17,94.6Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.17,94.6c1.66-2.83,5.62-2.72,8.35.55-1.37-4,.6-7.47,3.88-7.41s6.72,7.25,1.51,17C430.85,104.12,426.52,97.44,428.17,94.6Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--heart--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.92,117.38c2.36-.35,4.1,1.94,3.5,5,1.66-2.62,4.51-3.07,6-1.18s-1,7.12-9,8.63C453.75,123.24,455.56,117.74,457.92,117.38Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.92,117.38c2.36-.35,4.1,1.94,3.5,5,1.66-2.62,4.51-3.07,6-1.18s-1,7.12-9,8.63C453.75,123.24,455.56,117.74,457.92,117.38Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--heart--inject-94",
    d: "M76.56,88.49c-3.71-1-7,2.29-6.61,7.28-2.14-4.52-6.62-5.82-9.34-3.09s.23,11.63,12.63,15.64C82.07,98.74,80.28,89.54,76.56,88.49Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--heart--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.74,138.2c-2.52-1.47-5.54.34-6.24,4.06-.69-3.72-3.72-5.53-6.23-4s-2.06,8.54,6.24,13.86C59.8,146.75,60.26,139.68,57.74,138.2Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.74,138.2c-2.52-1.47-5.54.34-6.24,4.06-.69-3.72-3.72-5.53-6.23-4s-2.06,8.54,6.24,13.86C59.8,146.75,60.26,139.68,57.74,138.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--heart--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.22,106.33c-2.38.17-3.57,2.8-2.31,5.63-2.2-2.18-5.08-2-6.08.17s2.59,6.71,10.65,6.43C50.58,111.12,47.6,106.15,45.22,106.33Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.22,106.33c-2.38.17-3.57,2.8-2.31,5.63-2.2-2.18-5.08-2-6.08.17s2.59,6.71,10.65,6.43C50.58,111.12,47.6,106.15,45.22,106.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorLogin);
export default __webpack_public_path__ + "static/media/Doctor_login.db8a906db959e61ab090a68e1bc1539a.svg";
export { ForwardRef as ReactComponent };